export default {
  staffBot: {
    title: "Staff bot",
    subtitle: "Upload documents via Telegram and get task notifications",
    connected: "Bot connected",
    error: "Error",
    disconnect: "Disconnect",
    disconnectConfirm: "Disconnect the bot? Staff will have to link again.",
    youLinked: "Your Telegram is linked",
    howToLink: "Open the bot, press /start and share your phone number — it links by your number in the system.",
    featureDocs: "Photo or PDF + client number in the caption (#123) — the file goes to the right document field of the deal",
    featureCard: "Type a client number — their deals, stage and debt",
    featureTasks: "New tasks arrive with a Done button, /tasks — today’s tasks",
    connectHint: "Create a bot in @BotFather (/newbot) and paste its token here. This bot is for staff, not for clients.",
    connect: "Connect",
    notConnected: "The bot is not connected yet. Contact your administrator.",
  },
  dealFinance: {
    tab: "Payments",
    title: "Payments",
    agreed: "Agreed amount",
    extra: "Extra sales",
    paid: "Paid",
    debt: "Debt",
    addPayment: "Add payment",
    addCharge: "Extra sale",
    extraSale: "extra sale",
    delete: "Delete",
    deleteConfirm: "Delete? The debt will be recalculated",
    error: "Error",
    paymentAdded: "Payment added",
    chargeAdded: "Extra sale added",
    cancel: "Cancel",
    save: "Save",
    amount: "Amount",
    date: "Date",
    methodLabel: "Method",
    method: {
      cash: "Cash",
      transfer: "Transfer",
      card: "Card",
    },
    note: "Note",
    chargeHint: "The agreed amount stays the same — the extra service is added to the debt.",
    chargeTitle: "Service",
    valueLocked: "Only an administrator can change the agreed amount",
    payments: "Income",
    debts: "Debtors",
    from: "From",
    to: "To",
    allMethods: "All methods",
    allFunnels: "All funnels",
    received: "Total received",
    noPayments: "No payments in this period",
    export: "Excel (CSV)",
    totalDebt: "Total debt",
    debtors: "Debtors",
    noDebts: "No debtors",
    lastPayment: "last payment",
    client: "Client",
    deal: "Deal",
    stage: "Stage",
    acceptedBy: "Received by",
    phone: "Phone",
  },
  stageRules: {
    title: "Stage rules",
    requiredCount: "{n} required fields",
    autoTaskOn: "auto task",
    requiredFields: "Required fields to enter",
    requiredHint: "A deal can enter this stage only when these fields are filled. For file fields a document must be uploaded.",
    noFields: "No deal fields yet",
    valueField: "Amount",
    autoTask: "Create a task when a deal enters",
    taskTitle: "Task text, e.g. Record a video review",
    toDealOwner: "Deal owner",
    dueIn: "Due in",
    days: "days",
    modalTitle: "Fill in first",
    modalHint: "Required to move the deal to this stage:",
    chooseFile: "Choose file",
    removeFile: "Remove file",
    uploadFailed: "Upload failed",
    yes: "Yes",
    select: "Select",
    cancel: "Cancel",
    saveAndMove: "Save and move",
    bulkBlocked: "{n} deals not moved — required fields are empty",
    fromEnterDay: "from the day it enters",
    fromField: "from «{name}»",
    leadStage: "First stage is for leads",
    leadStageHint: "New inquiries land here and cards show a Lead badge. Turn off for service funnels that receive deals from another funnel.",
    renewalTitle: "Deal by expiry date",
    renewalHint: "When a date in a won deal is approaching (e.g. permit expiry), a new deal opens for the client in the chosen funnel and the owner gets a task. Once per date.",
    renewalEnabled: "Enabled",
    renewalDateField: "Date field",
    renewalDays: "Days before",
    renewalFunnel: "Funnel",
    renewalStage: "Stage",
    renewalTask: "Task text",
    renewalTaskPlaceholder: "E.g. Offer a renewal",
    save: "Save",
  },
  notif: { title: "Notifications", subtitle: "Who did what and when", markAll: "Mark all read", empty: "No notifications", seeAll: "See all", loadError: "Loading error" },
  common: { selectPlaceholder: "Select...", searchPlaceholder: "Search...", noResults: "No results" },
  proc: {
    title: "My processes", subtitle: "Processes to carry out",
    empty: "No processes", emptyHint: "Processes assigned to you will appear here", filesTitle: "Sketch / files", archiveTitle: "Archive", backToWork: "Back to work", archiveEmpty: "Archive is empty", archiveEmptyHint: "Your completed work is kept here", proposalTag: "Proposal", tabWork: "My work", tabRequests: "Money request", tabArchive: "Archive",
    countSuffix: "processes", logout: "Log out", refresh: "Refresh",
    saved: "Saved", loadError: "Loading error",
    problemTitle: "What's the problem?", problemPlaceholder: "Briefly describe the problem…", problemSubmit: "Submit", problemRequired: "Describe the problem", cancel: "Cancel",
  },

  snab: {
    title: "My requests", subtitle: "Documents to procure",
    empty: "No requests", emptyHint: "Open requests assigned to you will appear here",
    createReceipt: "Create receipt", tabProducts: "Products", tabSuppliers: "Suppliers", suppliersEmpty: "No suppliers", needQty: "Needed", buy: "Buy", zoom: "Zoom", tabRequests: "Money request", needBy: "Due:", noItems: "No positions",
    logout: "Log out", refresh: "Refresh", loadError: "Loading error",
  },

  roles: {
    title: "Roles", subtitle: "Custom roles — control module visibility, actions and data",
    addRole: "Add role", editRole: "Edit role", name: "Role name", namePlaceholder: "e.g. Salesperson, Storekeeper...", nameRequired: "Role name is required",
    modulesSection: "Modules and actions", module: "Module", actionView: "View", actionCreate: "New", actionEdit: "Edit", actionDelete: "Del",
    dataFlagsSection: "Hidden data", dataFlagsHint: "Checked data is hidden for this role (phone, email, deal amount...)",
    ownSection: "Show own records only", ownHint: "In the checked sections the user sees only documents they created (not others').",
    save: "Save", cancel: "Cancel", delete: "Delete", deleteTitle: "Delete role", deleteText: "role will be deleted. Users with this role revert to full access.",
    added: "Role added", updated: "Role updated", deleted: "Role deleted", loadError: "Loading error", genericError: "An error occurred",
    empty: "No roles", modulesCount: "modules", hiddenCount: "hidden",
    restricted: "This data is hidden from you",
    prodSubActionsLabel: "Production: separate entry permissions",
    prodEditOutputs: "Enter finished product batches",
    prodEditComponents: "Enter raw material consumption",
    flags: {
      contacts_phone: "Contact phone number", contacts_email: "Contact email", deals_value: "Deal amount",
      products_costPrice: "Cost price (purchase)", products_avgCost: "Average cost", products_margin: "Margin / markup", inventory_stockValue: "Stock value",
      sklad_valuation: "Warehouse value (total cost)", sklad_unitCost: "Unit cost",
      finance_pnl: "Profit & loss (P&L)", finance_companyBalance: "Company balance", finance_cashboxBalance: "Cashbox balances", finance_netProfit: "Net profit", finance_cogs: "Cost of goods (COGS)", finance_debtsTotals: "Debt totals",
      cashbox_balance: "Cashbox balance", cashbox_turnover: "Cashbox turnover",
      jobOrder_summary: "Job order amounts (stats + agreed/paid/debt)", jobOrder_profit: "Job order profit", jobOrder_totalCost: "Job order cost", jobOrder_laborCost: "Labor cost", jobOrder_materialCost: "Material cost",
      jobOrder_lockBasic: "Lock editing basic info", jobOrder_lockProcesses: "Lock editing processes", jobOrder_lockMaterials: "Lock editing expenses", jobOrder_lockFiles: "Lock editing files", jobOrder_lockDelete: "Lock deleting the order",
      jobOrder_otherExpenses: "Hide other expenses section", jobOrder_otherExpensesEdit: "Lock adding other expenses", jobOrder_otherExpensesDelete: "Lock deleting other expenses",
      jobOrder_lockConfirm: "Lock confirming the order", jobOrder_lockStart: "Lock moving to in-progress", jobOrder_lockComplete: "Lock completing the order",
      proposal_cost: "Proposal cost", proposal_margin: "Proposal margin",
      reports_inventoryValue: "Report: inventory value", reports_profitColumns: "Report: profit columns",
    },
  },

  dtp: { now: "Now", done: "Done" },
  picker: { placeholder: "Product...", search: "Search...", notFound: "Not found" },
  catPicker: { all: "All", back: "Back", empty: "Empty", count: "{n} items" },
  update: { title: "New version available", subtitle: "Please refresh", action: "Update", dismiss: "Dismiss" },


  production: {
    loadError: "Loading error", error: "Error", cancel: "Cancel", save: "Save", saved: "Updated", added: "Added", deleted: "Deleted", movedToTrash: "Moved to trash", toTrash: "To trash", delete: "Delete", back: "Back", selectPlaceholder: "Select...", row: "Row", addRow: "Add row", print: "Print", printTitle: "Print", unitSuffix: "pcs",
    prodLabel: "Production", prodSubtitle: "From raw materials to finished goods", pkgLabel: "Packaging", pkgSubtitle: "Packaging finished goods",
    searchPlaceholder: "Number or product...", new: "New", notFound: "Document not found", notFoundHint: "Create a new document", newBlank: "Create blank", newFromRecipe: "From recipe", recipe: "Recipe", norma: "Norm (how many times)", normaHint: "The recipe is multiplied by this number (1 norm = 1 recipe) — materials and output are written accordingly.", noRecipes: "No recipes. Add one in the Recipes (BOM) section first.", recipePickFirst: "Select a recipe",
    thNumber: "Number", thDate: "Date", thOutput: "Finished product", thOut: "Output", thCost: "Cost", thUnit: "Unit", thStatus: "Status", thActions: "Actions", outLabel: "Output:",
    trashTitle: "Move to trash", trashText1: "document will be moved to the trash. Raw material and finished goods stock will be restored (recoverable within 30 days).",
    docLoadError: "Document not loaded", bomSelectProductFirst: "First select the finished product", bomQtyFirst: "Enter the output quantity", bomNotFound: "No recipe found for this product", bomLoaded: "Recipe loaded", whRequired: "Warehouses are required", outProductRequired: "Finished product is required", outQtyInvalid: "Invalid output quantity", minOneComponent: "Enter at least one raw material", costShare: "Cost share", costShareAuto: "auto", costShareHint: "Leave the share empty to split the total cost automatically by output quantity. Enter shares to split by those weights.", outAllocCost: "Cost", outputsCount: "products", removeRow: "Remove row", lotLabel: "Batch:", lotCol: "Batch", lotAuto: "Auto (oldest)", lotNoLabel: "No batch", lotLeft: "left", uomRequired: "Select a unit", compProductRequired: "Select the raw material", compQtyRequired: "Enter the raw material quantity", addGroup: "Group", newGroup: "New group", groupNamePlaceholder: "Group name", removeGroup: "Remove group",
    fromWh: "Raw material warehouse (from)", toWh: "Finished goods warehouse (to)", outputCard: "Finished product", applyBomTitle: "Load raw materials from the selected product's recipe", applyBom: "Load from recipe", product: "Product", outProductPlaceholder: "Finished product...", qty: "Quantity", uom: "Unit", uomPlaceholder: "pcs, kg...", batchNo: "Batch №", batchPlaceholder: "(optional)", expiry: "Expiry date", addBatch: "Add batch", batchTime: "Time", batchTotal: "Total", grandTotalLabel: "Total output:", normaTitle: "Norm", normaPerUnit: "raw materials per", normaAdd: "Add raw material",
    componentsTitle: "Raw materials (consumption)", noComponents: "No raw material rows", colProduct: "Product", colQty: "Quantity", colUom: "Unit", colEstCost: "Est. cost", uomPlaceholder2: "unit", costInline: "Cost:", stockInStock: "Stock:",
    overheadTitle: "Additional expenses (optional)", noOverhead: "No rows (wages, electricity, depreciation, etc.)", colCategory: "Category (from cashbox)", colName: "Name", colAmount: "Amount", catManual: "— (manual)", overheadNamePlaceholder: "Wages, Electricity...", amountPlaceholder: "Amount", overheadHint: "If you select a category, it links to the expense category in Payments (shown merged in reports). You create the category in Finance → Payments.", colCashbox: "Cashbox (cash)", overheadNoCash: "— (cost only)", overheadCashHint: "If a cashbox is selected, this expense is paid in cash from it and shows in the cashbox card. It's still added to cost; not recorded separately in Payments/P&L (no double counting).",
    costTitle: "Cost (estimated)", costMaterials: "Raw materials", costOverhead: "Additional expenses", costTotal: "Total cost", costUnit: "Unit cost", costNote: "On save, the actual cost is determined by FIFO/average method and the finished product's avgCost is updated accordingly.", note: "Note", optional: "Optional...",
    trashText2: "The document will be moved to the trash. Raw material and finished goods stock will be restored (recoverable within 30 days).",
    bomMahsulotRequired: "Product is required", bomMinOneComponent: "At least one composition row", bomOutQtyInvalid: "Invalid output quantity", bomEditTitle: "Edit recipe", bomNewTitle: "New recipe (BOM)", bomKind: "Type", bomOutProduct: "Finished product", bomOutQty: "Output quantity", bomOutQtyHint: "This recipe is for the specified amount of finished product", bomUom: "Unit", bomComponents: "Raw materials", bomNoRows: "No rows", bomColUom: "Unit", bomColNote: "Note", bomColCategory: "Category", bomOverheadHint: "If you select a category, it links to the expense category in Payments (shown merged in reports).",
    bomTitle: "Recipes (BOM)", bomNavShort: "Recipes", recipeSaveBtn: "Save as recipe", recipeSaveTitle: "Save current form as a recipe", recipeSaveHint: "The current finished products, materials and expenses are saved as a recipe. Later 'From recipe' + norm fills it automatically.", recipeName: "Recipe name", recipeNamePlaceholder: "E.g. Bread (standard)", recipeNameRequired: "Enter a recipe name", recipeSaved: "Recipe saved", bomSubtitle: "Raw material recipes for finished products", all: "All", bomSearchPlaceholder: "Product...", bomNewBtn: "Recipe", bomEmpty: "No recipes", bomThProduct: "Product", bomThKind: "Type", bomThOut: "Output", bomThComposition: "Composition", bomThOverhead: "Add.exp.", componentsCount: "raw materials", overheadShort: "Add.exp.:", bomDeleteTitle: "Delete recipe", bomDeleteText: "recipe will be permanently deleted.",
    ppProdTitle: "PRODUCTION DOCUMENT", ppPkgTitle: "PACKAGING DOCUMENT", ppDate: "Date:", ppRawWh: "Raw material warehouse:", ppFinishedWh: "Finished goods warehouse:", ppFinished: "Finished product:", ppBatch: "Batch №:", ppExpiry: "Expiry:", ppComponents: "Raw materials", ppColNum: "№", ppColName: "Name", ppColQty: "Quantity", ppColUom: "Unit", ppColUnitCost: "Unit cost", ppColSum: "Sum", ppMaterialsTotal: "Raw materials total:", ppOverhead: "Additional expenses", ppOverheadTotal: "Additional total:", ppTotalCost: "Total cost:", ppUnitCost: "Unit cost:", ppNote: "Note:", ppSignMaker: "Produced by (signature)", ppSignReceiver: "Received by (signature)",
  
    moveTo: "Move",
  
    moveToUngrouped: "To ungrouped",
  },

  scheduled: {
    title: "Scheduled payments", subtitle: "Monthly payment templates you need to pay each month.",
    new: "New payment", add: "Add", edit: "Edit", delete: "Delete",
    name: "Name", namePlaceholder: "Office rent, Electricity...",
    amount: "Amount", dayOfMonth: "Day of month", dayHint: "(1–28)",
    cashbox: "Account", category: "Category", counterparty: "Counterparty", note: "Note",
    optional: "optional",
    statusPaid: "Paid", statusPending: "Pending", statusOverdue: "Overdue",
    lastPaid: "Last paid",
    payBtn: "Create expense", payTitle: "Create payment", payDate: "Date", payConfirm: "Create payment",
    paySuccess: "Payment created", payError: "An error occurred",
    deleteConfirm: "Delete template?", deleted: "Deleted",
    saved: "Saved", loadError: "Failed to load",
    empty: "No scheduled payments", emptyHint: "Add recurring monthly expenses",
    active: "Active", inactive: "Inactive", toggleActive: "Toggle status",
    every: "Every", dayLabel: "th of the month",
    totalMonth: "Total scheduled payments", totalPaid: "Paid", totalRemain: "Remaining",
    itemsCount: "items",
  },
  payReq: {
    title: "Requests", subtitle: "Employee money requests.", new: "Request", newTitle: "New request",
    send: "Send", sent: "Request sent", cancel: "Cancel", amount: "Amount", amountInvalid: "Invalid amount",
    note: "Note", notePlaceholder: "What it is for...", paymentMethod: "Payment method", paymentMethodPlaceholder: "Cash / Card / Transfer...", pmCash: "Cash", pmCard: "Card", pmTransfer: "Transfer", jobOrder: "Job order", optional: "optional", searchPlaceholder: "Number or customer...", notFound: "Not found", noteRequired: "Note is required",
    loadError: "Load error", error: "Error", empty: "No requests", emptyHint: "Add a new request",
    byFinance: "Finance:", reason: "Reason:", approve: "Approve", approved: "Approved", markPaid: "Mark paid", approveTitle: "Approve request", approveHint: "Enter the approved amount. This is not a payment yet.", approvedAmount: "Approved amount", requested: "Requested", statTotal: "Total requests", statApproved: "Approved", statPaid: "Paid out", statRejected: "Rejected", reject: "Reject",
    rejectTitle: "Reject request", rejectReasonLabel: "Rejection reason (optional):", rejectReasonPlaceholder: "Reason...",
    rejected: "Rejected", delete: "Delete", deleteConfirm: "Delete request?", deleted: "Deleted",
    tabs: { pending: "Pending", approved: "Approved", paid: "Paid", rejected: "Rejected", all: "All" },
    status: { pending: "Pending", approved: "Approved", paid: "Paid", rejected: "Rejected" },
  },
  integrations: { back: "Back",
    title: "Integrations", subtitle: "Enable integrations with other services.",
    saved: "Saved", error: "Error", on: "Enabled", enable: "Enable", disable: "Disable", activeSuffix: "active", off: "Off", soon: "Coming soon", configure: "Configure", eskizConn: "Connection", eskizOk: "Connected", eskizEmail: "Email", eskizPassword: "Password", eskizPassKeep: "Leave empty to keep unchanged", eskizFrom: "Sender (nick)", eskizFromHint: "4546 for test. Real nick must be approved in Eskiz.", eskizSave: "Save & connect", eskizTest: "Test SMS", eskizPhone: "Phone", eskizMessage: "Message", eskizSendTest: "Send test", eskizTestHint: "The default text «Это тест от Eskiz» is approved. For your own text, get it moderated at my.eskiz.uz → SMS → My texts.", eskizEmailReq: "Enter email", eskizPhoneReq: "Enter phone number", eskizConnected: "Eskiz connected", eskizSent: "SMS sent", smsRulesTitle: "SMS notifications", smsRulesHint: "When the event occurs, an SMS is sent to the customer automatically (the text must be approved in Eskiz).", smsPlaceholders: "Placeholders", smsTplPlaceholder: "e.g. Dear {customer}, order {number} received.", smsRulesSave: "Save notifications", tabSettings: "Settings", tabHistory: "History", balTitle: "SMS balance", balTotal: "Total balance", balPrice: "Price per SMS", balSave: "Save balance", balLow: "Low balance!", balLowHint: "Balance is below one SMS price. Top up.", histEmpty: "No SMS sent yet", evtJoCreated: "When job order is created", evtJoDelivered: "When job order is completed", evtSaleCreated: "When a sale (invoice) is created", evtPayIncoming: "When payment is received",
    cat: { sms: "SMS", hr: "HR" },
    svc: { "hr-line": "HR management (HR Line)", "sms-eskiz": "Send SMS (eskiz.uz)", "sms-playmobile": "SMS gateway (Play Mobile)", "hr-attendance": "Employee attendance", "hr-payroll": "Payroll" },
  },
  finance: { total: "Total",
    loadError: "Loading error", cancel: "Cancel", save: "Save", add: "Add", saved: "Updated", added: "Added", deleted: "Deleted", error: "Error", delete: "Delete", deleteTitle: "Confirm deletion", nameRequired: "Name is required", search: "Search...", notFound: "Not found", selectCp: "Select counterparty...", loadMore: "Load more", clearSelection: "Clear selection", edit: "Edit", back: "Back", kirim: "Incoming", chiqim: "Outgoing", insufficient: "Insufficient funds in the cashbox",
    thName: "Name", thCurrency: "Currency", thBranch: "Branch", thBalance: "Balance", thActions: "Actions", thNumber: "Number", thDate: "Date", thType: "Type", thCp: "Counterparty", thCashbox: "Cashbox", thCategory: "Category", thAmount: "Amount", thStatus: "Status", thDesc: "Description", thDirection: "Direction",
    debtsTitle: "Debts", debtsSubtitle: "Debtors and creditors (counterparty balances)", none: "None", debtors: "Debtors", debtorsHint: "Owe us", creditors: "Creditors", creditorsHint: "We owe",
    cbReportLoadError: "Error loading report", cbBase: "Base", cbTitle: "Company balance", cbSubtitle: "Net worth per currency", noData: "No data", cbGrandTotal: "Total net worth (converted to {base})", cbConvertedNote: "Other currencies are calculated at organization rates", cbRatesLabel: "Rate", cbInventory: "Stock balances (cost price)", cbInventoryHint: "Raw materials and finished goods", cbReceivables: "Receivables from counterparties", cbReceivablesHint: "Money counterparties will pay", cbCash: "Cash in cashboxes", cbCashHint: "Cashboxes in this currency", cbPayables: "Debt to counterparties", cbPayablesHint: "Debt payable to counterparties", cbFormula: "Formula: Stock cost + Receivables + Cash in cashboxes − Debt to counterparties. Stock cost is stored only in the base currency ({base}).",
    pnlTitle: "P&L (Profit and loss)", pnlSubtitle: "Revenue → Cost → Gross profit → Expenses → Net profit (in base currency)", pnlReport: "P&L statement", pnlRevenue: "Revenue (sales)", pnlCogs: "− Cost", pnlGross: "= Gross profit", pnlOpex: "− Operating expenses", pnlOperating: "= Operating profit", pnlFinancial: "− Financial expenses (interest/bank)", pnlSecLabel: "P&L section", pnlSecHint: "Operating — normal expense; Financial — bank interest/loans; Excluded — supplier/debt payments.", pnlSec_operating: "Operating", pnlSec_financial: "Financial", pnlSec_excluded: "Excluded", pnlNet: "≡ Net profit", pnlNote: "Note: Cost is based on current cost price (approximate). Taxes and loans are not included.", pnlExpenseDetail: "Operating expenses breakdown", pnlNoExpense: "No expense payments", pnlCashFlow: "Cash flow (additional)", pnlCashFlowHint: "Cashbox movement, does not affect P&L", pnlNetFlow: "Net flow",
    cbxCurrencyRequired: "Currency is required", cbxEditTitle: "Edit cashbox", cbxNewTitle: "New cashbox", cbxNameLabel: "Name *", cbxNamePlaceholder: "Cashbox name", cbxCurrencyLabel: "Currency *", cbxBranchLabel: "Branch", cbxBranchNone: "— Not selected —", cbxBranchHint: "Branches are added in Settings → Company.", cbxTitle: "Cashboxes", cbxSubtitle: "List of cashboxes", cbxAdd: "Add cashbox", cbxNotFound: "Cashbox not found", cbxNotFoundHint: "Add a new cashbox", cbxDeleteText: "cashbox will be deleted.",
    ccTitle: "Cashbox card", ccNotFound: "Cashbox not found", ccBackToList: "Back to list", ccConversion: "Conversion", ccReceipt: "Cash receipt (purchase)", ccOverhead: "Production expense", ccConvOut: "(out)", ccConvIn: "(in)", ccCurrentBalance: "Current balance", ccJournal: "Movement journal", ccNoMovements: "No movements",
    convCashboxesRequired: "Cashboxes are required", convSameCashbox: "Cannot select the same cashbox", convSameCurrency: "Cannot convert to the same currency", convTransferMode: "Transfer (no rate, 1:1)", convTransferTitle: "Cashbox-to-cashbox transfer", convTransferBtn: "Transfer", convTransferTag: "Transfer", convFromAmountInvalid: "Invalid amount to give", convRateRequired: "Enter the rate", convDone: "Conversion done", convEditTitle: "Edit conversion", convNewTitle: "New conversion", convFrom: "From cashbox", convSelect: "Select...", convBalance: "Balance:", convGive: "Given (amount)", convTo: "To cashbox", convRate: "Rate", convReverse: "Reverse", convReceive: "Received", convAuto: "(automatic)", convDoBtn: "Execute", convTitle: "Conversion", convSubtitle: "Convert currency from cashbox to cashbox", convNewBtn: "Conversion", convNotFound: "Conversion not found", convNotFoundHint: "Create a new conversion", convThGive: "Given", convThReceive: "Received", convDeleteText: "conversion will be deleted. Cashbox balances will be restored.",
    payTitle: "Payments", paySubtitle: "Incoming and outgoing money", paySearch: "Number or counterparty...", payFilterCp: "Counterparty", payFilterCashbox: "All cashboxes", payFilterCategory: "All categories", payIncoming: "Money in", payOutgoing: "Money out", payNotFound: "Payment not found", payNotFoundHint: "Create money in or money out", payDeleteText: "payment will be deleted. Counterparty balance will be restored.",
    pfIncomingTitle: "Incoming Payment", pfOutgoingTitle: "Outgoing Payment", pfJoSelect: "Select order...", pfClearSelection: "— Clear selection —", pfJoSearch: "Number or customer...", pfNewCp: "New counterparty", cpAdded: "Counterparty added", pfPhone: "Phone", pfPhonePlaceholder: "+998 ...", smTitle: "Manage statuses", smNew: "New status", smNamePlaceholder: "Status name...", catIncomingTitle: "Incoming categories", catOutgoingTitle: "Outgoing categories", catNew: "New category", catNamePlaceholder: "Category name...",
    pfDocLoadError: "Document not loaded", pfCpRequired: "Counterparty is required", pfCashboxRequired: "Cashbox is required", pfAmountInvalid: "Invalid amount", pfDateInvalid: "Invalid date (DD/MM/YYYY HH:MM)", pfHeaderTitle: "Payments", pfFromRequest: "This expense is being created from request:", pfPrint: "Print", pfPrintTitle: "Print", pfAddAnother: "Add another incoming", pfAddAnotherTitle: "Add another incoming for this order (from another cashbox)", pfJoRemainTitle: "The order has a remaining debt", pfJoRemainHint: "Payment saved. If the customer wants to pay into another cashbox too, click \"Add another incoming\".", pfDateLabel: "Date:", pfStatusless: "No status", pfCpLabel: "Counterparty *", pfNewCpTitle: "Add a new counterparty", pfCashboxLabel: "Cashbox *", pfCashboxSelect: "Select cashbox...", pfBalance: "Balance:", pfAmountLabel: "Amount *", pfCategoryLabel: "Category", pfManage: "Manage", pfCategoryless: "No category", pfJobOrder: "Order", pfJobOrderHint: "If selected, the payment is linked to this order's balance. If left empty — a regular incoming.", pfProcess: "Process (labor)", pfProcessHint: "The amount is recorded as this process's labor.", pfProcessRequired: "Please select a process", pfProcessCurrencyMismatch: "Payment currency must match the order currency", pfOptional: "optional", pfNote: "Note", pfNotePlaceholder: "Note (optional)...", pfJoTotal: "Order total", pfJoPaid: "Paid", pfJoRemaining: "Remaining", pfJoHistory: "Payment history", pfJoNoPayments: "No payments yet", pfJoLoading: "Loading...", pfDeleteText: "The payment will be deleted and the counterparty balance restored.", pfNameLabel: "Name *", pfNamePlaceholder: "Name", pfCommissionAdd: "Add commission", pfCommission: "Commission (2nd expense)", pfCommissionPct: "Percent", pfSecondAdd: "Split into 2nd cashbox", pfSecondTitle: "2nd cashbox incoming (cash + card)", pfSecondCashboxLabel: "2nd cashbox", pfSecondAmountLabel: "2nd amount", pfSecondRemove: "Remove", pfSecondCashboxRequired: "2nd cashbox is required", pfSecondSameCashbox: "2nd cashbox must differ", pfSecondInvalid: "Invalid 2nd cashbox amount", pfCommissionInvalid: "Invalid commission amount", pfCommissionEmpty: "No commission categories set — choose via «Manage».", pfCommissionMgrTitle: "Commission categories", pfCommissionMgrHint: "Checked expense categories appear in the commission selector.",
    ppIncomingTitle: "INCOMING ORDER", ppOutgoingTitle: "OUTGOING ORDER", ppDate: "Date:", ppReceivedFrom: "Received from", ppGivenTo: "Given to", ppCashbox: "Cashbox:", ppCategory: "Category:", ppAmount: "Amount:", ppNote: "Note:", ppSignedIncomingLeft: "Submitted (signature)", ppSignedOutgoingLeft: "Issued (signature)", ppSignedIncomingRight: "Received (signature)", ppSignedOutgoingRight: "Got (signature)",
  
    convVerifyBtn: "Confirm",
  
    convVerified: "Conversion confirmed",
  
    convVerifiedBadge: "Confirmed",
  
    convDraftBadge: "Not confirmed",
  
    convVerifiedAt: "Confirmed",
  
    convLockedHint: "A confirmed document cannot be edited",
  },

  contracts: { optional: "optional", legalNamePlaceholder: "Legal name", managerLabel: "Responsible (who works)", managerNone: "Not selected",
    selectCp: "Select counterparty...", search: "Search...", notFound: "Not found",
    editTitle: "Edit contract", newTitle: "New contract",
    number: "Number", date: "Date", cpLabel: "Counterparty *", legalName: "Legal name", inn: "INN", legalMissing: "Legal name/INN not filled in the counterparty card.", amount: "Amount *", currency: "Currency",
    description: "Description", descPlaceholder: "Contract subject...", note: "Note", notePlaceholder: "Optional...",
    filesLabel: "Files (PDF, scans)", cancel: "Cancel", save: "Save", add: "Add",
    cpRequired: "Counterparty is required", amountInvalid: "Invalid amount",
    saved: "Updated", added: "Added", error: "Error", loadError: "Loading error", deleted: "Deleted",
    title: "Contracts", subtitle: "Contract registry — each contract is auto-numbered",
    searchPlaceholder: "Number, counterparty...", newBtn: "Contract", empty: "No contracts", emptyHint: "Add a new contract",
    thCp: "Counterparty", thAmount: "Amount", thCreatedBy: "Created by", thActions: "Actions",
    deleteTitle: "Confirm deletion", deleteText: "contract will be deleted.", delete: "Delete",
  },

  aktSverka: { tabCustomer: "With customer", tabSupplier: "With supplier",
    selectCp: "Select counterparty...", search: "Search...", notFound: "Not found",
    cpRequired: "Counterparty is required", error: "Error", copied: "Copied",
    regenConfirm: "The old link will be revoked and a new one created. Continue?", urlUpdated: "Link updated",
    title: "Reconciliation act", subtitle: "Mutual settlement document with the counterparty", cpLabel: "Counterparty",
    fromDate: "Start date", toDate: "End date", generate: "Generate", print: "Print / PDF",
    permUrlTitle: "Permanent URL for the counterparty", permUrlHint: "This URL is permanent — the counterparty can save it and view their settlements anytime. Periods are selected on the public page.",
    copyTitle: "Copy", copy: "Copy", regenTitle: "New URL (old one is revoked)", regen: "Refresh",
    loadError: "Loading error", linkError: "Could not open the link", printShort: "Print / PDF",
    docTitle: "RECONCILIATION ACT", docSubtitle: "Mutual settlements between counterparties", ourOrg: "Our organization", tel: "Tel", period: "Period",
    noTx: "No transactions in this period", currencyLabel: "Currency", thDate: "Date", thDoc: "Document", thDebit: "Debit", thCredit: "Credit", thBalance: "Balance",
    openingBalance: "Opening balance", totalRow: "Total",
    theyOweA: " owes us ", theyOweB: ".", weOwePre: "We owe ", weOweMid: " ", weOweSuf: ".",
    noDebtPre: "In this period ", noDebt: "no debt (balance 0)",
    signOur: "On behalf of our organization:", signCp: "On behalf of the counterparty:", signLine: "(Full name, position, signature, date)",
  },

  sklad: { allCategories: "All categories", lowOnly: "Low stock", totalValue: "Total stock value", thCategory: "Category", thValue: "Value",
    loadError: "Loading error", cancel: "Cancel", save: "Save", add: "Add", saved: "Updated", added: "Added", deleted: "Deleted", error: "Error", delete: "Delete", deleteTitle: "Confirm deletion", nameRequired: "Name is required", total: "Total", thName: "Name", thProduct: "Product", thUom: "Unit", sku: "SKU",
    sbTitle: "Stock balances", sbSubtitle: "Product stock by warehouse", sbSearch: "Search product...", sbNotFound: "Product not found", sbNotFoundHint: "Stock is formed through receipt documents",
    rTitle: "Total cost", rSubtitle: "Warehouse value based on stock and cost price", rKpi: "Total warehouse value (cost)", rEmpty: "No stock", rStock: "Stock", rCost: "Cost", rValue: "Value",
    tTitle: "Transfers", tSubtitle: "Transfer goods between warehouses", tNew: "Transfer", tSearch: "Search by number...", tNotFound: "No transfers found", tNotFoundHint: "Create a new transfer document", tNumber: "Number", tDate: "Date", tDirection: "Direction", tProducts: "Products", itemCountSuffix: "products",
    whEditTitle: "Edit warehouse", whNewTitle: "New warehouse", whNameLabel: "Name *", whNamePlaceholder: "Warehouse name", whTitle: "Warehouses", whSubtitle: "List of warehouses", whAdd: "Add warehouse", whNotFound: "Warehouse not found", whNotFoundHint: "Add a new warehouse", thActions: "Actions", whDeleteText: "warehouse will be deleted.",
    lsTitle: "Low stock products", lsSubtitleSearch: "Find a product and set the minimum stock", lsSubtitle: "Products with stock below the set minimum", lsAlerts: "Alerts", lsEmpty: "No low stock products", lsEmptyHint: "Search a product to set the minimum stock", lsLow: "Low", lsEnough: "Enough", lsCurrentStock: "Current stock", lsMinStock: "Minimum stock", lsStatus: "Status",
    tfNotFound: "Not found", tfCatalogEmpty: "Catalog is empty", tfTypeProduct: "Type product name...", tfDocLoadError: "Document not loaded", tfFromRequired: "Source warehouse is required", tfToRequired: "Destination warehouse is required", tfSameWarehouse: "Cannot select the same warehouse", tfDateInvalid: "Invalid date (DD/MM/YYYY HH:MM)", tfMinOneProduct: "Enter at least one product", tfMoved: "Transferred", back: "Back", tfHeaderTitle: "Inter-warehouse transfer", tfDocTitle: "Transfer document", tfFrom: "From *", tfTo: "To *", tfSelectWarehouse: "Select warehouse...", tfThAvailFrom: "Available (from)", tfQty: "Quantity", tfAvailable: "Available", tfNote: "Note", tfNotePlaceholder: "Note...", tfDeleteText: "transfer document will be deleted. Stock will be reverted.",
  },

  cpCard: {
    kind: { purchaseOrder: "Purchase order", purchaseReceipt: "Receipt", purchaseReturn: "Purchase return", salesOrder: "Sales order", salesInvoice: "Sale", salesReturn: "Sales return" },
    payIn: "Payment (in)", payOut: "Payment (out)", weOwe: "We owe", theyOwe: "They owe us",
    tabs: { documents: "Documents", payments: "Payments", ledger: "Balance history", products: "Products", prices: "Prices" },
    loadError: "Loading error", cardTitle: "Counterparty card", back: "Back", notFound: "Counterparty not found", backToList: "Back to list", debtTitle: "Debt",
    thKind: "Type", thNumber: "Number", thDate: "Date", thStatus: "Status", thSum: "Amount", thCashbox: "Cashbox", thCategory: "Category", thDoc: "Document", thChange: "Change", thBalance: "Balance",
    noDocuments: "No documents", noPayments: "No payments", ledgerEmpty: "Balance history is empty",
  },

  counterparties: { addBtn: "Add", statTotal: "Total", statCustomers: "Customers", statSuppliers: "Suppliers",
    folderNamePlaceholder: "Folder name...", cancel: "Cancel", error: "Error", subFolderTitle: "Add subfolder",
    folders: "Folders", statusMgrTitle: "Manage statuses", editLabel: "Edit", newStatus: "New status",
    statusNamePlaceholder: "Status name...", save: "Save", add: "Add",
    all: "All", statusless: "No status", status: "Status",
    loadError: "Loading error", saved: "Updated", added: "Added", deleted: "Deleted",
    title: "Counterparties", subtitle: "Customers and suppliers", allFolders: "All folders", searchPlaceholder: "Search...",
    notFound: "No counterparties found", createHint: "Add a new counterparty",
    weOwe: "We owe", theyOwe: "They owe us",
    thName: "Name", thPhone: "Phone", thContacts: "Contacts", thDebt: "Debt", thActions: "Actions", contactsSuffix: "contacts",
    editTitle: "Edit", newTitle: "Add counterparty", nameLabel: "Name", namePlaceholder: "Company or person name",
    folderLabel: "Folder", noFolder: "No folder", configure: "Configure",
    phone: "Phone", phonePlaceholder: "+998 90 000 00 00", email: "Email", emailPlaceholder: "example@mail.com", comment: "Comment", commentPlaceholder: "Note...",
    contactsTitle: "Contact persons", addContact: "Add", noContacts: "No contacts added",
    cName: "Name", cNamePlaceholder: "First Last", cRole: "Position", cRolePlaceholder: "Director, Manager...", cPhone: "Number",
    requisitesTitle: "Requisites", inn: "TIN", innPlaceholder: "123456789",
    legalName: "Legal name", legalNamePlaceholder: "LLC \"Company\"", legalAddr: "Legal address", legalAddrPlaceholder: "Tashkent, Chilanzar district, ...",
    bankAccount: "Bank account", bankPlaceholder: "2020 8000 0000 0000 0000", update: "Update",
    location: "Address / Location", locationPlaceholder: "City, street, building...",
    deleteTitle: "Confirm deletion", deleteText: "will be deleted.", delete: "Delete",
  },

  uomNames: {
    pcs: "Piece", kg: "Kilogram", g: "Gram", t: "Ton", l: "Liter", ml: "Milliliter",
    m: "Meter", cm: "Centimeter", mm: "Millimeter", "m²": "Square meter", "m³": "Cubic meter", km: "Kilometer",
    pair: "Pair", roll: "Roll", box: "Box", pack: "Package", bag: "Bag", set: "Set",
    bottle: "Bottle", can: "Can", cyl: "Cylinder", coil: "Coil", spool: "Spool", sheet: "Sheet", bunch: "Bunch",
    hr: "Hour", min: "Minute", day: "Day", week: "Week", month: "Month", year: "Year",
    visit: "Visit", session: "Session", project: "Project", page: "Page", word: "Word", trip: "Trip",
  },
  productForm: {
    variantsTitle: "Variants", variantsHint: "Variants by attributes like color, size",
    attributesTitle: "Attributes", attrNamePlaceholder: "Attribute name (e.g. Color)", attrValuePlaceholder: "Add value + Enter",
    addAttribute: "Add attribute", generateVariants: "Generate variants",
    variantsListTitle: "Variants", totalStock: "Total stock", variantCol: "Variant", imageCol: "Image", skuCol: "SKU", priceCol: "Price", costCol: "Cost", stockCol: "Stock",
    stockHint: "Enter opening stock per variant; product stock = sum of variants",
    ptTitle: "Sale price types", ptHint: "Add, edit or delete", ptPlaceholder: "e.g. Wholesale, Retail...", ptAdd: "Add price type",
    added: "Added", deleted: "Deleted", error: "Error",
    images: "Images", imagesHint: "pcs • first is cover", setCover: "Set as cover", uploading: "Uploading...", imageDrop: "Choose an image or drop it here", imageError: "Image upload error",
    dimsTitle: "Dimensions", dimsHint: "— per unit", length: "Length", width: "Width", height: "Height",
    pkgTitle: "Packaging units", pkgBase: "Base:", pkgNoBase: "First select the base unit of measure (UOM) in the \"Info\" section",
    pkgUnit: "Packaging unit", pkgQty: "Quantity", pkgUomSelect: "Unit...", pkgAdd: "Add packaging",
    editTitle: "Edit", newProduct: "New product", newService: "New service",
    saved: "Updated", saveError: "An error occurred", saving: "Saving...", update: "Update", save: "Save", cancel: "Cancel",
    nameLabel: "Name", productNamePlaceholder: "Product name", serviceNamePlaceholder: "Service name",
    infoTitle: "Info", descLabel: "Description", descPlaceholder: "Short description...",
    folderLabel: "Folder", noFolder: "No folder", select: "Select...", skuLabel: "SKU", skuPlaceholder: "e.g. PRD-001",
    pricesTitle: "Prices", buyPrice: "Purchase price", salePricesTitle: "Sale prices", statusTitle: "Status", back: "Back", uomLabel: "Unit of measure", minStockLabel: "Min. stock", minStockHint: "If stock falls to or below this, it shows under \"Low stock\" (0 = no tracking)", configure: "Configure", active: "Active", activeBadge: "Active", isManufacturedLabel: "Manufactured", prodNormaTitle: "Production norm", prodNormaHint: "Raw materials consumed per 1 unit of this product", prodNormaAdd: "Add", prodNormaProduct: "Raw material", prodNormaQty: "Qty", prodNormaUom: "Unit", prodNormaFooter: "When this product is selected in production, the norm is loaded automatically", manufacturingUomLabel: "Manufacturing UOM", manufacturingUomHint: "Auto-set in the production form when this product is selected and cannot be changed.", manufacturingUomNone: "Not set (any)",
    mkixCodeLabel: "MKIX code", mkixCodePlaceholder: "e.g. 3926909709",
    nameRequired: "Product name is required", uomRequired: "Unit of measure is required",
  },

  products: {
    variantTag: "variant",
    typeAll: "All", product: "Product", service: "Service",
    cols: { category: "Folder", uom: "Unit", sku: "SKU", costPrice: "Cost", avgCost: "Avg. cost", salePrice: "Sale price", stock: "Stock", description: "Description", createdAt: "Created", updatedAt: "Updated", isActive: "Status" },
    active: "Active", inactive: "Inactive",
    searchPlaceholder: "Search...", colsMenuTitle: "Configure columns", colsMenu: "Columns", colsAll: "All", colsDefault: "Default",
    folders: "Folders", newFolder: "New folder", allFolders: "All", noFolders: "No folders", mobileAllFolders: "All (folder)",
    resizeHint: "Drag to resize (double-click to reset)",
    thName: "Name", notFound: "No products found", createHint: "Add your first product or service", inactiveBadge: "Inactive", stockLabel: "Stock",
    uomRequired: "Select a unit of measure", editTitle: "Edit —", newProductTitle: "+ New product", newServiceTitle: "+ New service",
    nameLabel: "Name", productNamePlaceholder: "Product name", serviceNamePlaceholder: "Service name",
    skuLabel: "SKU / Code", uomLabel: "Unit of measure", select: "Select...",
    folderLabel: "Folder", noFolder: "No folder", salePrice: "Sale price", costPriceLabel: "Cost price", descLabel: "Description", optional: "Optional...",
    activeCheck: "Active", cancel: "Cancel", save: "Save", add: "Add", saving: "Saving...",
    folderEditTitle: "Edit folder", folderNamePlaceholder: "Folder name", parentFolder: "Parent folder", rootFolder: "Root folder",
    deleteTitle: "Confirm deletion", deleteText: " — delete it? This action cannot be undone.", delete: "Delete", deleting: "Deleting...",
    saved: "Updated", added: "Added", folderSaved: "Folder updated", folderAdded: "Folder added", deleted: "Deleted", folderDeleted: "Folder deleted", error: "An error occurred",
  },

  files: {
    empty: "No files uploaded yet", fileName: "File", uploading: "Uploading...", upload: "Upload file",
    hint: "PDF, image, Word, Excel — max 15MB", uploaded: "Uploaded", uploadError: "Upload error",
  },

  smeta: {
    title: "Estimate", save: "Save",
    companyName: "Company name", companyNamePh: "Enter company name",
    directorName: "Director full name", directorNamePh: "Last First Middle",
    colName: "Work description", colCountry: "Country", colUom: "Unit",
    colQty: "Qty", colPrice: "Price", colDeliveryCost: "Supply cost",
    colVat: "VAT %", colTotal: "Total incl. VAT",
    total: "Total", addRow: "Add row",
    comment: "Comment", commentPh: "Additional notes...",
    validUntil: "Offer valid until", validUntilLabel: "Valid until:",
    positions: "Goods and services", preview: "Preview", close: "Close",
    download: "Download PDF", printPdf: "Print / PDF", orderNum: "Order №",
    delivery: "Supply cost", vat: "VAT", grandTotal: "Total incl. VAT",
    shareLink: "Share", linkCopied: "Copied!", linkError: "Link is invalid",
  },

  jobOrderForm: { dimW: "Width", dimL: "Length",
    back: "Back", title: "Order",
    procStatus: { waiting: "Not started", "in-progress": "In progress", paused: "Paused", done: "Done", problem: "Problem" },
    durMin: "min", durHour: "h", distFromInstall: "Distance from installation point",
    select: "Select...", search: "Search...", clearSelection: "— Clear selection —", notFound: "Not found",
    nameRequired: "Name is required", customerAdded: "Customer added", error: "Error",
    newCustomer: "New customer", nameLabel: "Name", customerNamePlaceholder: "Customer name", phone: "Phone", cancel: "Cancel", add: "Add",
    docLoadError: "Failed to load document", cashboxRequired: "Select a cashbox", amountInvalid: "Invalid amount",
    paymentReceived: "Payment received", movedToTrash: "Moved to trash", customerRequired: "Customer is required",
    warehouseRequired: "Warehouse is required", agreedInvalid: "Invalid agreed amount",
    deadlineRequired: "A delivery deadline is required", managerRequired: "A project manager must be selected", agreedRequired: "An agreed amount is required", descriptionRequired: "A description is required",
    savedToast: "Saved", createdToast: "Created", saveFirst: "Save the order first", delivered: "Delivered", reverted: "Reverted",
    modalTitle: "New job order", modalCreate: "Create and continue", modalHint: "After saving you'll add processes, expenses and totals.",
    fManager: "Project manager", managerNone: "— Not selected —",
    fSketch: "Sketch (image/PDF)", sketchUpload: "Upload sketch",
    basicInfo: "Basic information", moveLeft: "Move left", moveRight: "Move right",
    toTrash: "To trash", print: "Print", printTitle: "Print", deliver: "Completed", revertDelivery: "Revert completion", confirmAction: "Confirm", startAction: "Move to in-progress", completeAction: "Complete", statusChanged: "Status changed", startNeedProcess: "Add a process (stage) first", startNeedResponsible: "Assign a responsible person to each process", save: "Save",
    deliveredLockTitle: "To edit a delivered order, revert the delivery first",
    deliveredBanner: "Delivered. To edit, revert the delivery first.",
    invoiceTitle: "Invoice needs to be sent",
    invoiceText1: "Work on this order is done. An invoice must be sent to ", invoiceText2: " under ", invoiceText3: " contract.",
    contractAmount: "Contract amount:",
    fNumber: "Number", fDate: "Date", fCustomer: "Customer", customerPlaceholder: "Customer...", newCustomerTitle: "Add new customer",
    fContract: "Contract", noContract: "— No contract —", fAgreedPrice: "Agreed amount", fCurrency: "Currency", fDeadline: "Due date",
    fWarehouse: "Warehouse (materials)", fFolder: "Folder", noFolder: "— No folder —",
    fDescription: "Description (what is made)", fShortName: "Short name", shortNamePlaceholder: "e.g. Kitchen furniture", shortNameRequired: "Short name is required", sketchRequired: "Sketch upload is required", descPlaceholder: "Table, kitchen furniture...",
    fLocation: "Installation location", fLocationHint: "— customer link (Google Maps, Yandex)", openLink: "Open link", copyLink: "Copy", copied: "Copied",
    createdBy: "Created by:", priceLabel: "Price:", paidLabel: "Paid:", debtLabel: "Debt:", workedLabel: "Worked:", receivePayment: "Receive payment",
    processes: "Processes", addProcess: "Process", noProcesses: "No processes. Click \"+ Process\".",
    addProcessTitle: "New process", editProcessTitle: "Edit process", addProcessHint: "Pick a department and assignee", deptRequired: "A department is required",
    pDept: "Department", pResponsible: "Responsible", pStatus: "Status", pLabor: "Labor", pAllocated: "Allocated amount", pNote: "Note", pNotePlaceholder: "Note / special instruction...", workedShort: "Worked:", historyTitle: "Time history", calLoad: "orders", calBusy: "busy", historyEmpty: "No actions yet", fromProposal: "This order was created from proposal:", viewProposal: "View proposal", proposalTitle: "Proposal", prDate: "Date", prCustomer: "Customer", prAssignee: "Assigned employee", prCreatedBy: "Created by", prDescription: "Description", prNote: "Note", prFiles: "Files",
    trackStart: "Start", trackPause: "Pause", trackDone: "Finish", trackProblem: "Problem", trackResume: "Resume",
    materials: "Expenses (materials)", addRow: "Row", noMaterials: "No expenses. Click \"Row\".",
    mProduct: "Product", mQty: "Qty", mUom: "Unit", mCost: "Cost", mSum: "Sum", mProcess: "Process",
    stockLeft: "In stock",
    selectVariant: "Select variant",
    uomPlaceholder: "pcs", costFromProductTitle: "Cost taken from the product card", costOwnTitle: "Cost for this order", totalExpense: "Total expense",
    files: "Files and projects",
    totalsTitle: "Final calculation", tAgreed: "Agreed amount", tMaterials: "Materials", tLabor: "Labor", tTotalCost: "Total cost", tOtherExpenses: "Other expenses", otherExpenses: "Other expenses", addExpense: "Add expense", noExpenses: "No expenses", expCashbox: "Cashbox", expCashboxHint: "Only cashboxes in the order currency ({cur})", expCashboxRequired: "Select a cashbox", expAmount: "Amount", expAmountRequired: "Enter the amount", expNote: "Note", expNotePlaceholder: "Expense description…", expAdded: "Expense added", expDeleted: "Expense deleted", tProfit: "Profit",
    totalsHint: "After saving, the actual cost (FIFO/average) is recorded and profit becomes precise.",
    freezeAction: "Freeze", unfreezeAction: "Resume",
    freezeTitle: "Freeze order (pause)", freezeHint: "Freezing shifts the deadline forward. Time already elapsed is not refunded when resumed.",
    freezeUntilLabel: "Resume date",
    freezeExtendInfo: "Deadline will be extended by {days} day(s).",
    freezeConfirm: "Freeze", freezeDateRequired: "Please enter a resume date",
    freezeSuccess: "Order frozen", unfreezeSuccess: "Order resumed",
    frozenBanner: "Frozen (paused)", frozenFrom: "from:", frozenUntil: "until:",
    deleteTitle: "Move to trash", deleteText: "The order will be moved to trash. Raw materials stock is restored.",
    deleteTextInvoice: " The automatic invoice is also deleted and the customer balance is restored.",
    payTitle: "Receive payment", remainingDebt: "Remaining debt:", cashbox: "Cashbox", noCashbox: "no cashbox found in this currency",
    amount: "Amount", payNote: "Note", optional: "Optional...", receive: "Receive",
  },

  proposals: {
    title: "Commercial offer", countSuffix: "pcs", new: "Proposal", newTitle: "New proposal", editTitle: "Edit proposal", colNumber: "Number", colDate: "Date", colCustomer: "Customer", colDescription: "Description", colAmount: "Amount", colAssignee: "Employee", colCreatedBy: "Created by",
    searchPlaceholder: "Number, customer, description...", notFound: "No proposals found", loadError: "Loading error",
    resizeHint: "Drag to resize", backToList: "Back to list",
    emptyTitle: "No proposal selected", emptyHint: "Select on the left or create a new one",
    wonToast: "Order created! You can view it in the Job orders section.",
    tabs: { open: "Open", won: "Won", lost: "Lost" },
    statWon: "won", statLost: "lost", statOpen: "open",
    status: { new: "New", "in-discussion": "In discussion", won: "Won (order)", lost: "Rejected" },
    customerSelect: "Select customer...", search: "Search...", searchEmpty: "Not found", clearSelection: "Clear selection", fAssignee: "Assigned employee", assigneePlaceholder: "Select employee...", assigneeHint: "The assigned employee presses start/finish on their page (My work)", fManager: "Manager (Contract)", managerPlaceholder: "Admin or project manager...", managerHint: "The contract is tied to this user", workStatus: { waiting: "Not started", "in-progress": "In progress", done: "Done" },
    docLoadError: "Failed to load document", customerRequired: "Customer is required",
    savedToast: "Saved", createdToast: "Created", error: "Error",
    warehouseRequired: "Select a warehouse first", orderCreated: "Order created!",
    markedLost: "Marked as rejected", deleteConfirm: "Delete this proposal?", deletedToast: "Deleted",
    wonBannerTitle: "Order created", wonBannerText1: "This proposal is marked as won and converted to Order №",
    wonBannerText2: ".", openOrder: "Open order",
    lostBannerTitle: "Rejected proposal", reasonLabel: "Reason:",
    delete: "Delete", rejected: "Rejected", convertToOrder: "Convert to order", cancel: "Cancel", save: "Save",
    fNumber: "Number", fDate: "Date", fStatus: "Status", fCurrency: "Currency", fCustomer: "Customer",
    fAgreedPrice: "Agreed amount", fWarehouse: "Warehouse (for order)", notSelected: "— Not selected —",
    fDescription: "Description (what is made)", descPlaceholder: "Customer design / project description...",
    fAdvance: "Advance (deposit) amount", advancePaid: "Advance paid", fNote: "Note", optional: "Optional...", fFiles: "Files (sketch/photo/document)", createdBy: "Created by:",
    lostModalTitle: "Reject proposal", lostReasonLabel: "Reason (optional):", lostReasonPlaceholder: "Customer decided...",
    winModalTitle: "Convert to order",
    winModalText: "A new order (JobOrder) will be created and linked to this proposal. Processes and materials are added inside the order.",
    warehouseRequiredLabel: "Warehouse *", selectPlaceholder: "Select...", createOrder: "Create order",
  },

  jobOrders: { colsReorderHint: "Drag to reorder",
    title: "Job orders",
    subtitle: "Customer order: production → delivery",
    searchPlaceholder: "Number, customer, description...",
    newOrder: "Order",
    notFound: "No orders found",
    createHint: "Create a new order",
    loadError: "Loading error",
    thNumber: "Number",
    thActions: "Actions",
    filterAll: "All",
    tabAll: "All", tabFrozen: "Frozen", overdue: "Overdue", costOverrun: "Cost overrun",
    status: { new: "New", confirmed: "Confirmed", "in-progress": "In progress", delivered: "Completed", cancelled: "Cancelled" },
    cols: { sketch: "Sketch", shortName: "Short name",
      date: "Date", customer: "Customer", description: "Description", folder: "Folder", processes: "Processes",
      manager: "Project manager", agreedPrice: "Agreed", paid: "Paid", debt: "Debt",
      totalCost: "Cost", materialsCost: "Materials", laborCost: "Labor",
      profit: "Profit", status: "Status", createdBy: "Created by", expectedDeliveryDate: "Due date",
      deliveryDate: "Delivery date", currency: "Currency",
    },
    colsMenu: "Columns", colsMenuTitle: "Configure columns", colsAll: "All", colsDefault: "Default",
    statAgreed: "Total amount", filterCustomer: "Customer", filterAllCustomers: "All customers", filterAllManagers: "All managers", filterYear: "Year", filterPeriod: "Period", filterWholeYear: "Whole year", filterAllMonths: "All months", filterClear: "Clear", statPaid: "Paid", statDebt: "Debt", statCount: "Orders",
    folders: "Folders", newFolder: "New folder", allFolders: "All", noFolder: "No folder",
    noFolders: "No folders", mobileAllFolders: "All (folder)",
    folderEdit: "Edit folder", folderNameLabel: "Name", folderNamePlaceholder: "Folder name",
    parentFolder: "Parent folder", rootFolder: "Root folder",
    folderDeleteTitle: "Delete folder",
    folderDeleteText: "folder will be deleted. Orders inside are kept (only the folder link is removed).",
    trashTitle: "Move to trash",
    trashText: "order will be moved to trash. Raw materials stock is restored.",
    cancel: "Cancel", save: "Save", add: "Add", delete: "Delete", toTrash: "To trash",
    saved: "Updated", addedToast: "Added", deletedToast: "Deleted", movedToTrash: "Moved to trash", error: "Error",
    resizeHint: "Drag to resize (double-click to reset)",
  },

  // Auth
  login: "Login",
  register: "Register",
  logout: "Logout",
  email: "Email",
  phone: "Phone",
  password: "Password",
  confirmPassword: "Confirm Password",
  forgotPassword: "Forgot password?",

  // Register
  createOrganization: "Create Organization",
  organizationName: "Organization Name",
  organizationType: "Organization Type",
  yourName: "Your Name",
  yourEmail: "Your Email",
  yourPassword: "Password",
  alreadyHaveAccount: "Already have an account?",
  dontHaveAccount: "Don't have an account?",

  // Org types
  retail: "Retail",
  wholesale: "Wholesale",
  manufacturing: "Manufacturing",
  service: "Service",
  other: "Other",

  // Dashboard
  dashboard: "Dashboard",
  welcome: "Welcome",

  // Common
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  add: "Add",
  search: "Search",
  loading: "Loading...",
  error: "Error",
  success: "Success",

  // Errors
  required: "This field is required",
  invalidEmail: "Invalid email address",
  passwordMin: "Password must be at least 4 characters",
  passwordMatch: "Passwords do not match",

  // Login page
  login_page: {
    server: "Company code",
    serverPlaceholder: "e.g. miko",
    checking: "checking...",
    serverNotFound: "Server not found",
    serverNotFoundHint: "Server «{slug}» does not exist. Check the address.",
    phonePlaceholder: "90 123 45 67",
    passwordPlaceholder: "••••••",
    submitting: "Signing in...",
    forgotPassword: "Forgot password?",
    rights: "© 2025 CRM Line. All rights reserved.",
  },

  // Sales module
  sales: {
    dateLocale: "en-US",
    types: {
      orders:   { label: "Orders",   subtitle: "Customer orders", docLabel: "Sales order" },
      invoices: { label: "Invoices", subtitle: "Sales invoices", docLabel: "Sales invoice" },
      returns:  { label: "Returns",  subtitle: "Returning goods from a customer", docLabel: "Sales return" },
    },
    statusDraft: "Draft",
    statusConfirmed: "Confirmed",
    searchPlaceholder: "Number or customer...",
    notFound: "No documents found",
    createHint: "Create a new document",
    thNumber: "Number",
    thDate: "Date",
    thCustomer: "Customer",
    thLines: "Lines",
    thSum: "Total",
    thStatus: "Status",
    thVerified: "Verified",
    thState: "State",
    thCurrency: "Currency", thNote: "Note",
    thActions: "Actions",
    linesSuffix: "pcs",
    view: "View",
    edit: "Edit",
    deleteConfirmTitle: "Confirm deletion",
    deleteConfirmText: "will be deleted.",
    deleteInvoiceExtra: " Stock and customer debt will be reversed.",
    cancel: "Cancel",
    deleteBtn: "Delete",
    deleted: "Deleted",
    loadError: "Load failed",
    error: "Error",
  },

  // Purchases module
  purchases: {
    dateLocale: "en-US",
    types: {
      orders:   { label: "Orders",   subtitle: "Purchase order documents to suppliers", docLabel: "Purchase order" },
      receipts: { label: "Receipts", subtitle: "Supplier invoices (receipts)", docLabel: "Receipt document" },
      returns:  { label: "Returns",  subtitle: "Returning goods to a supplier", docLabel: "Purchase return" },
    },
    statusDraft: "Draft",
    statusConfirmed: "Confirmed",
    searchPlaceholder: "Number or supplier...",
    notFound: "No documents found",
    createHint: "Create a new document",
    thNumber: "Number",
    thDate: "Date",
    thSupplier: "Supplier",
    thLines: "Lines",
    thSum: "Total",
    thStatus: "Status",
    thVerified: "Verified",
    thState: "State",
   thCurrency: "Currency", thWarehouse: "Warehouse", thNote: "Note", thPayment: "Payment", payCash: "Cash", payCredit: "Credit",
    thActions: "Actions",
    linesSuffix: "pcs",
    view: "View",
    edit: "Edit",
    deleteConfirmTitle: "Confirm deletion",
    deleteConfirmText: "will be deleted.",
    cancel: "Cancel",
    deleteBtn: "Delete",
    deleted: "Deleted",
    loadError: "Load failed",
    error: "Error",
  },

  // Sales form page
  salesForm: {
    docTypes: {
      orders: "Sales order",
      invoices: "Sales invoice",
      returns: "Sales return",
    },
    back: "Back",
    delete: "Delete",
    print: "Print",
    copy: "Copy",
    cancel: "Cancel",
    save: "Save",
    add: "Add",
    error: "Error",
    statusManage: "Manage statuses",
    statusEdit: "Edit",
    statusNew: "New status",
    statusNamePlaceholder: "Status name...",
    statusAdd: "Add",
    productSearchPlaceholder: "Search product...",
    productNotFoundCreate: "Not found. Create a new product via",
    productNotFoundCreate2: ".",
    catalogEmpty: "Catalog is empty — add a product via +",
    productTypeName: "Type a product name...",
    notFound: "Not found",
    searchPlaceholder: "Search...",
    customerSelect: "Select customer...",
    customerAdded: "Customer added",
    newCustomer: "New customer",
    nameRequired: "Name *",
    customerNamePlaceholder: "Customer name",
    phone: "Phone",
    nameRequiredToast: "Name is required",
    warehouseSelect: "Select warehouse...",
    warehouseUpdated: "Updated",
    warehouseAdded: "Warehouse added",
    editWarehouse: "Edit warehouse",
    newWarehouse: "New warehouse",
    warehouseNamePlaceholder: "Warehouse name",
    currency: "Currency",
    baseLabel: "base",
    uploaded: "Uploaded",
    uploadError: "Upload failed",
    file: "File",
    uploading: "Uploading...",
    uploadFile: "Upload file",
    noFiles: "No files uploaded yet",
    fileHint: "PDF, image, Word, Excel — max 15MB",
    productAdded: "Product added",
    newProduct: "New product",
    productNamePlaceholder: "Product name",
    costPrice: "Cost price",
    docLoadError: "Failed to load the document",
    customerRequired: "A customer must be selected",
    warehouseRequired: "A warehouse must be selected",
    deadlineRequired: "A delivery deadline is required",
    managerRequired: "A project manager must be selected",
    agreedRequired: "An agreed amount is required",
    descriptionRequired: "A description is required",
    currencyRequired: "A currency must be selected",
    cashboxRequired: "A cashbox must be selected",
    dateInvalid: "Invalid date (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Invalid delivery date (DD/MM/YYYY)",
    needQty: "Enter a quantity for at least one item",
    saved: "Saved",
    created: "Added",
    copyNeedRow: "At least one row is needed to copy",
    copyCreated: "Copy created",
    deleted: "Deleted",
    productAlready: "This product is already added",
    dateLabel: "Date:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    statusless: "No status",
    verified: "Verified",
    counterparty: "Counterparty *",
    newCounterpartyTitle: "Add a counterparty",
    warehouse: "Warehouse",
    editWarehouseTitle: "Edit warehouse",
    newWarehouseTitle: "Add a warehouse",
    currencyReq: "Currency *",
    payment: "Payment",
    payCredit: "Credit (customer owes)",
    payCreditHint: "Recorded on the customer balance — then paid via an Incoming payment.",
    payCash: "Cash payment (into cashbox)",
    payCashHint: "The amount goes into the cashbox immediately, doesn't affect the customer balance.",
    cashbox: "Cashbox",
    selectPlaceholder: "Select...",
    notSelected: "— Not selected —",
    arrivalDate: "Arrival date",
    createInvoice: "Create sale",
    customerReq: "Customer *",
    invoiceCreated: "Sale created (deducted from stock)",
    newCustomerTitle: "Add customer",
    priceType: "Price type",
    priceTypeDefault: "Standard (1st price)",
    cashboxBalance: "balance",
    noCashbox: "No cashbox in \"{currency}\" found (or not assigned to you)",
    tabItems: "Items",
    tabFiles: "Files",
    thName: "Name",
    thSells: "Sells",
    thUom: "Unit",
    uomSelect: "Unit",
    uomRequired: "Select a unit for each product",
    overStock: "\"{name}\" not enough in stock (available: {qty} {uom})",
    thAvailable: "Available",
    thPrice: "Price",
    thDiscount: "Discount %",
    thSum: "Amount",
    thVatRate: "VAT rate",
    thVatAmount: "VAT amount",
    thTotal: "Total",
    newProductTitle: "Create a new product",
    total: "Subtotal",
    totalVat: "VAT",
    grandTotal: "Total (incl. VAT)",
    note: "Note",
    notePlaceholder: "Note or additional info...",
    saleConfirmed: "Sale confirmed",
    saleConfirmedHint: "Product stock decreased and customer debt increased (+{amount}).",
    deleteConfirmTitle: "Confirm deletion",
    deleteConfirmText: "will be permanently deleted.",
    partyLabel: "Customer",
  },

  // Purchase form page
  purchaseForm: {
    docTypes: {
      orders: "Purchase order",
      receipts: "Receipt document",
      returns: "Purchase return",
    },
    back: "Back",
    delete: "Delete",
    save: "Save",
    createReceipt: "Create receipt",
    cancel: "Cancel",
    error: "Error",
    statusManage: "Manage statuses",
    statusEdit: "Edit",
    statusNew: "New status",
    statusNamePlaceholder: "Status name...",
    statusAdd: "Add",
    productSearchPlaceholder: "Search product...",
    productNotFoundCreate: "Not found. Create a new product via",
    productNotFoundCreate2: ".",
    catalogEmpty: "Catalog is empty — add a product via +",
    productTypeName: "Type a product name...",
    notFound: "Not found",
    supplierSelect: "Select supplier...",
    supplierAdded: "Supplier added",
    newSupplier: "New supplier",
    nameRequired: "Name *",
    supplierNamePlaceholder: "Supplier name",
    phone: "Phone",
    warehouseSelect: "Select warehouse...",
    warehouseUpdated: "Updated",
    warehouseAdded: "Warehouse added",
    editWarehouse: "Edit warehouse",
    newWarehouse: "New warehouse",
    warehouseNamePlaceholder: "Warehouse name",
    nameRequiredToast: "Name is required",
    add: "Add",
    currency: "Currency",
    uploadError: "Upload failed",
    file: "File",
    uploading: "Uploading...",
    uploadFile: "Upload file",
    uploaded: "Uploaded",
    noFiles: "No files uploaded yet",
    fileHint: "PDF, image, Word, Excel — max 15MB",
    productAdded: "Product added",
    newProduct: "New product",
    productNamePlaceholder: "Product name",
    costPrice: "Cost price",
    docLoadError: "Failed to load the document",
    procLoadError: "Failed to load the procurement request",
    productAlready: "This product is already added",
    selectVariant: "Select variant",
    variantRequired: "Select a variant for the variant product",
    supplierRequired: "A supplier must be selected",
    warehouseRequired: "A warehouse must be selected",
    currencyRequired: "A currency must be selected",
    cashboxRequired: "A cashbox must be selected",
    dateInvalid: "Invalid date (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Invalid delivery date (DD/MM/YYYY)",
    needQty: "Enter a quantity for at least one item",
    saved: "Saved",
    created: "Added",
    copyNeedRow: "At least one row is needed to copy",
    copyCreated: "Copy created",
    receiptCreated: "Receipt created and stocked in",
    deleted: "Deleted",
    statusless: "No status",
    dateLabel: "Date:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    verified: "Confirmed",
    verifiedLockTitle: "Only an admin can revert a confirmed document",
    counterparty: "Counterparty *",
    newCounterpartyTitle: "Add a counterparty",
    editWarehouseTitle: "Edit warehouse",
    newWarehouseTitle: "Add a warehouse",
    arrivalDate: "Arrival date",
    dateOnlyPlaceholder: "DD/MM/YYYY",
    currencyReq: "Currency *",
    paymentMode: "Payment method",
    payDebt: "Debt (owed to supplier)",
    payDebtHint: "The supplier balance increases — then paid via an Outgoing payment.",
    payCash: "Cash (paid from cashbox)",
    payCashHint: "The amount leaves the cashbox immediately, doesn't affect the supplier balance.",
    cashbox: "Cashbox",
    selectPlaceholder: "Select...",
    noCashbox: "No cashbox in \"{currency}\" found (or not assigned to you)",
      convRate: "Conversion rate", convEdit: "Edit rate", convDeducted: "Deducted from cashbox",
    thName: "Name",
    thNeed: "Need",
    thReceived: "Received",
    thOrdered: "Ordered",
    thAvailable: "Available",
    thPrice: "Price",
    thDiscount: "Discount %",
    thSum: "Total",
    newProductTitle: "Create a new product",
    overReceiveError: "Cannot receive more than the needed quantity",
    excludeFromReceipt: "Exclude from this Receipt",
    total: "Total",
    note: "Note",
    notePlaceholder: "Note or additional info...",
    receiptConfirmed: "Receipt confirmed",
    receiptConfirmedHint: "Product stock updated and supplier balance increased (+{amount}).",
    deleteConfirmTitle: "Confirm deletion",
    deleteConfirmText: "will be permanently deleted.",
    partyLabel: "Supplier",
    warehouse: "Warehouse",
    warehouseNone: "— Not selected —",
    baseLabel: "base",
    print: "Print",
    copy: "Copy",
    tabItems: "Items",
    tabFiles: "Files",
    searchPlaceholder: "Search...",
    docNumberDash: "—",
    addRow: "Add row",
  
    linkedProductsHint: "Showing only this supplier's products",
  },

  // Procurement editor + form-page chrome
  procEditor: {
    pageTitle: "Procurement request",
    back: "Back",
    lockedTitle: "Document is read-only",
    lockedText: "This request belongs to a past day ({date}). Documents from past days are view-only.",
    toTrash: "To trash",
    createReceipt: "Create receipt",
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    number: "Number",
    date: "Date",
    needBy: "Delivery deadline",
    assignee: "Procurer (responsible)",
    statusPrefix: "State:",
    receiptsLinked: "· {n} receipts linked",
    overdue: "Overdue",
    neededProducts: "Needed products",
    rowsCount: "{n} rows",
    thProduct: "Product",
    thImage: "Image",
    thNeed: "Need",
    thUom: "Unit",
    thReceived: "Received",
    thRemaining: "Remaining",
    thNote: "Note",
    uomPlaceholder: "pcs",
    optional: "Optional",
    addRow: "Add row",
    note: "Note",
    notePlaceholder: "Optional...",
    attachments: "Attachment (image/file)",
    trashModalTitle: "Move to trash",
    trashModalText: "The request will be moved to trash. Linked receipt documents are kept.",
    needRow: "Enter at least one row", assigneeRequired: "Please select a procurement officer",
    saved: "Saved",
    created: "Created",
    movedToTrash: "Moved to trash",
    loadDocError: "Failed to load the document",
    error: "Error",
  },

  // Procurement list
  procurement: {
    dateLocale: "en-US",
    title: "Procurement",
    countSuffix: "requests",
    newRequestShort: "Request",
    newRequestTitle: "New request",
    searchPlaceholder: "Number, note...",
    notFound: "No requests found",
    unassigned: "— unassigned",
    positionsSuffix: "items", boughtOf: "{bought} of {total} bought", uploadError: "Upload error", imgZoom: "Zoom", selectVariant: "Select variant",  thDate: "Date", thBuy: "Buy", thProduct: "Product", thNeed: "Need", thUom: "Unit", thNote: "Note", optional: "Optional...", addRow: "Add row", flatHint: "Add a product via the bottom row — it goes into today's request. Overdue rows are red.", error: "Error",
    resizeHint: "Drag to resize (double-click to reset)",
    backToList: "Back to list",
    newDocTitle: "New procurement request",
    emptyTitle: "No request selected",
    emptyHint: "Pick one from the list on the left or create a new request",
    loadError: "Load failed",
    tabs: {
      overdue: "Overdue",
      new: "New",
      partial: "Partial",
      fulfilled: "Fulfilled",
    },
    status: {
      new: "New",
      partial: "Partial",
      fulfilled: "Fulfilled",
      cancelled: "Cancelled",
    },
  },

  // Dashboard home
  dashboardHome: {
    dateLocale: "en-US",
    greeting: "Welcome, {name}!",
    today: "Today is {date}",
    noAccess: "You don't have access to the metrics, or the data failed to load.",
    noWidgets: "There are no home metrics for your role. Pick a section from the left menu.",
    kpiTodaySales: "Today's sales",
    kpiMonthSales: "Monthly sales",
    kpiMonthProfit: "Monthly profit",
    kpiInventory: "Inventory value",
    trendTitle: "Sales trend",
    trendPeriod: "14 days",
    debtTitle: "Debt",
    debtTheyOwe: "They owe us",
    debtWeOwe: "We owe",
    debtNet: "Net",
    counterparties: "Counterparties",
    cashTitle: "Cashbox balances",
    cashEmpty: "No cashboxes",
    topDebtorsTitle: "Top debtors",
    noDebtors: "No debtors",
    viewAll: "View all",
    recentTitle: "Recent operations",
    recentEmpty: "No operations yet",
    recent: {
      salesInvoice: "Sale",
      purchaseReceipt: "Receipt",
      paymentIn: "Payment in",
      paymentOut: "Payment out",
    },
  },

  // Sidebar navigation (keyed by NAV_ITEMS key)
  nav: { education: "Education", "education-groups": "Education: groups and settings", integrations: "Integrations",
    dashboard: "Dashboard",
    contacts: "Contacts",
    tasks: "Tasks",
    inbox: "Inbox",
    calls: "Calls",
    reviews: "Reviews",
    funnels: "Funnels",
    purchases: "Purchases",
    "purchases-procurement": "Procurement",
    "purchases-orders": "Orders",
    "purchases-receipts": "Receipts",
    "purchases-returns": "Returns",
    sales: "Sales",
    "sales-orders": "Orders",
    "sales-invoices": "Invoices",
    "sales-returns": "Returns",
    "job-orders": "Job orders",
    "job-orders-proposals": "Commercial offer",
    "job-orders-orders": "Job orders",
    inventory: "Products",
    counterparties: "Counterparties",
    "counterparties-list": "Counterparties",
    "counterparties-contracts": "Contracts",
    "counterparties-aktsverka": "Reconciliation",
    sklad: "Warehouse",
    "sklad-balances": "Stock balances",
    "sklad-valuation": "Valuation",
    "sklad-transfers": "Transfers",
    "sklad-warehouses": "Warehouses",
    "sklad-lowstock": "Low stock",
    finance: "Finance",
    "finance-balance": "Company balance",
    "finance-pnl": "Profit & Loss",
    "finance-analysis": "Analysis",
    "finance-payments": "Payments", "finance-requests": "Requests",
    "finance-debts": "Debts",
    "finance-conversions": "Conversion",
    "finance-cashboxes": "Cashboxes",
    "finance-scheduled": "Scheduled payments",
    "finance-assets": "Assets",
    production: "Production",
    "production-orders": "Production",
    "production-packaging": "Packaging",
    "production-bom": "Recipes (BOM)",
  
    analytics: "Analytics",
  },

  analysis: {
    title: "Analysis",
    subtitle: "Monthly distribution of incoming funds across expense norms",
    income: "Income",
    allocated: "Allocated",
    spent: "Spent",
    available: "Available",
    carryIn: "From previous month",
    normSum: "Sum of norms",
    normHint: "It is recommended that the sum of norms equals 100%.",
    empty: "No expense categories.",
    remain: "Remaining",
    over: "Over budget",
    toNextMonth: "Carries to next month",
    loadError: "Failed to load data",
    error: "An error occurred",
    date: "Date",
    total: "Total",
    noSpend: "No expenses this month.",
    spentTotal: "Total spent",
    allocatedRow: "Available (norm)",
    carryShort: "(prev. month)",
    diffRow: "Difference → next month",
    diffHint: "Positive difference carries the remainder to next month; negative means the budget was exceeded.",
    readonly: "Read-only",
    noCounterparty: "No counterparty",
    unitK: "K", unitM: "M", unitB: "B",
    configNorms: "Configure percentages",
    normsTitle: "Category percentages (norm)",
    normsHint: "Set what percent of the monthly income is allocated to each category.",
    normsSaved: "Percentages saved",
    byCategoryTitle: "By category (monthly)",
    colName: "Name",
    colSumma: "Amount",
    colNorma: "Norm",
    colReal: "Real %",
    colResult: "Result",
    resultHint: "Result = Norm − Real. Positive (green) — spent below norm; negative (red) — over budget.",
    save: "Save",
    cancel: "Cancel",
  },

  // Account settings page
  account: {
    title: "Account settings",
    subtitle: "Edit your personal information",
    personalInfo: "Personal information",
    name: "Name",
    email: "Email",
    emailHint: "(for password recovery)",
    emailPlaceholder: "example@mail.com",
    phone: "Phone",
    phoneHint: "Phone number cannot be changed",
    save: "Save",
    saving: "Saving...",
    profileUpdated: "Profile updated",
    genericError: "An error occurred",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    passwordMismatch: "New passwords do not match",
    passwordTooShort: "Password must be at least 4 characters",
    passwordChanged: "Password changed successfully",
    changePasswordBtn: "Change password",
    namePlaceholder: "Full name",
    role: "Role",
    hide: "Hide",
    show: "Show",
  },

  // Settings page
  settings: {
    title: "Settings",
    back: "Back",
    tabs: {
      general: "General settings",
      branding: "Branding",
      modules: "Menu",
      users: "Users",
      workers: "Workers",
      roles: "Roles",
      currencies: "Currencies",
      uom: "Units of measure",
      company: "Company",
      assets: "Assets",
      trash: "Trash",
      funnels: "Funnels",
      tasks: "Tasks",
      "deal-sources": "Deal sources",
      "close-reasons": "Close reasons",
      "lead-forms": "Forms",
      goals: "Goals",
      integrations: "Integrations",
      inbox: "Inbox",
      atc: "Telephony (ATC)",
      "ai-calls": "AI call analysis",
      "api-keys": "API keys",
      "google-sheets": "Google Sheets",
      "owner-bot": "Owner bot",
      education: "Education",
      "lead-fields": "Lead fields",
      audit: "Audit log",
    },
    groups: {
      team: "Team",
      general: "General", crm: "CRM", channels: "Integrations", system: "System",
    },
    atc: {
      title: "PBX / IP telephony integration",
      subtitle: "Webhook settings for Mediateka (Sarkor Telekom), Sipuni or Utel PBX",
      connected: "Connected",
      notConnected: "Not connected",
      provider: "PBX provider",
      callBtn: "\"Call\" button",
      modeAtc: "PBX only",
      modePersonal: "Personal phone only",
      modeBoth: "Both — employee chooses",
      callBtnHint: "Applies to all \"Call\" buttons on the Contacts, Leads and Calls pages. If the PBX is not connected, the personal phone is always used regardless of this setting.",
      popupTitle: "Who sees the incoming call notification (top-right corner)",
      popupHint: "If none selected — visible to everyone (default). Owner/admin always sees it.",
      popupNoRoles: "No custom roles created — for now this setting applies to everyone",
      crmToken: "CRM Token",
      tokenPlaceholder: "Enter a secret token...",
      tokenHint: "Appended to the PBX webhook URL. Can be any value.",
      webhookTitle: "Webhook URL to set in the PBX:",
      copied: "Copied!",
      copy: "Copy",
      sipuniWebhookHint: "In the Sipuni dashboard: Settings → API → «Call event» (PBX Events) section.",
      utelDomain: "Utel domain",
      utelDomainHint: "Your PBX subdomain, e.g. cc999 (address cc999.utel.uz).",
      utelEmail: "Utel email",
      utelPassword: "Utel password",
      utelPasswordHint: "The password is used once to get a token and is not stored in the CRM.",
      utelConnect: "Connect Utel",
      utelReconnect: "Reconnect",
      utelConnecting: "Connecting…",
      utelConnectedTo: "Connected: {domain}",
      utelConnectedOk: "Utel connected",
      utelNeedConnect: "Connect Utel first (your dashboard login and password).",
      utelCheck: "Check connection",
      utelTokenOk: "Utel API access works",
      utelTokenBad: "Utel rejected the token: reconnect",
      utelWebhookFound: "Webhook is set up in Utel",
      utelWebhookMissing: "No webhook with our address found in Utel: add it (see below)",
      utelEventsOn: "Events enabled",
      utelEventsOff: "Disabled",
      utelExtensions: "Extensions in Utel",
      utelNoExtensions: "Could not load the extension list",
      utelSync: "Load calls for the last 3 days",
      utelSynced: "Calls loaded: {n}",
      utelSyncFailed: "Could not load call history",
      utelWebhookHint: "In the Utel panel: Integration → Webhook, paste this address and enable call_started, dial_answered, call_ended, call_saved (dial_started is optional).",
      utelNoClickToCall: "The Call button uses the Utel method (services/originate). Its request fields are not documented, so on the first call the CRM tries the likely formats itself: make a test call and check it.",
      unknownTitle: "Calls from unknown numbers",
      unknownHint: "If no matching contact is found, a contact is created automatically. If you also want a lead created automatically, choose where it should go (optional).",
      noLead: "— Do not create a lead —",
      noStage: "— No stage selected —",
      apiToken: "API Token (for Click-to-call)",
      apiTokenHint: "Mediateka PBX (ibrat.sip.uz) management API token (for originate calls)",
      sipDomainHint: "Domain name only. For Click-to-call:",
      sipuniUser: "Sipuni account number (user)",
      sipuniUserHint: "Account number in your Sipuni dashboard",
      sipuniSecret: "Sipuni Secret Key",
      sipuniSecretHint: "Secret key from Sipuni → Settings → API (for click-to-call)",
      save: "Save",
      saved: "Saved",
      error: "Error",
    },
    branding: {
      title: "Branding",
      subtitle: "Organization name, logo and brand color — the app opens with this look",
      orgName: "Organization name",
      orgNamePlaceholder: "Company name",
      logo: "Logo",
      upload: "Upload",
      removeLogo: "Remove",
      brandColor: "Brand color",
      defaultGreen: "Default (green)",
      customColor: "Custom color", solidTitle: "Sidebar/topbar in original color", solidHint: "When on, the sidebar and top bar show the exact chosen color (no darkening). Off — current darker shade.",
      preview: "Preview",
      primaryBtn: "Primary button",
      badge: "Badge",
      linkText: "Link text",
      save: "Save",
      imageOnly: "Image file only",
      uploadError: "Upload failed",
      nameRequired: "Organization name is required",
      saved: "Branding saved",
      error: "Error",
    },
    users: {
      countPrefix: "Total",
      countSuffix: "users", searchPlaceholder: "Name or phone...", noResults: "Nothing found",
      seats: "Seats on your plan: {used} of {total}",
      add: "Add",
      thUser: "User",
      thPhone: "Phone",
      thRole: "Role",
      thDept: "Department", noDept: "No department",
      thStatus: "Status",
      you: "You",
      userType: "Employee type", userTypeNone: "Regular employee", userTypeHint: "Pick a role: procurer / process worker / project manager (optional)",
      snabjenist: "Procurer",
      active: "Active",
      inactive: "Inactive",
      editTitle: "Edit",
      changePasswordTitle: "Change password",
      deleteTitle: "Delete",
      newUser: "New user",
      editUser: "Edit user",
      name: "Name",
      namePlaceholder: "Full name",
      role: "Role", position: "Position",
      dept: "Department",
      deptNone: "— Not selected —", deptMulti: "Departments (multiple)", noDeptsYet: "No departments yet", cpFolders: "Counterparty folders (access)", cpFoldersHint: "The procurement officer sees counterparties only from checked folders. If none checked — all.", noFoldersYet: "No folders yet",
      snabjenistHint: "If enabled, appears in the \"Responsible\" list on the Procurement form",
      customRole: "Role (RBAC)",
      customRoleNone: "— Unrestricted (full) —",
      customRoleHint: "If a custom role is assigned, the user is restricted to its permissions. owner/admin always full.", roleHint: "Administrator - full access (RBAC bypassed). User - restricted; you can pick a custom role below.", adminFullHint: "Administrator can access all modules - a custom role (RBAC) is not needed.",
      processWorker: "Process worker",
      processWorkerHint: "Assignable on job-order processes and can start/finish/pause them",
      projectManager: "Project manager", cashier: "Cashier",
      projectManagerHint: "Can be selected as the responsible manager on a job order (shown in the list when creating an order)",
      permissions: "Permissions",
      cashboxes: "Linked cashboxes (for procurer)",
      cashboxesHint: "On a cash Receipt the user can only choose these cashboxes. If left empty, the user can't make a cash Receipt.",
      phone: "Phone",
      phonePlaceholder: "90 123 45 67",
      email: "Email",
      emailHint: "(for password recovery)",
      emailPlaceholder: "example@mail.com",
      password: "Password",
      passwordPlaceholder: "At least 6 characters",
      newPassword: "New password",
      passwordModalTitle: "Password —",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      change: "Change",
      deleteUser: "Delete user",
      deleteConfirmPrefix: "Confirm deletion of ",
      deleteConfirmSuffix: "? This action cannot be undone.",
      deleteBtn: "Delete",
      deleting: "Deleting...",
      accountOwner: "Account owner",
      loadError: "Failed to load users",
      updated: "User updated",
      passwordChanged: "Password changed",
      deleted: "User deleted",
      added: "User added",
      genericError: "An error occurred",
      passwordTooShort: "Password must be at least 4 characters",
      roles: { owner: "Owner", admin: "Administrator", user: "User", cashier: "Cashier" },
      perms: { products: "Products", clients: "Clients", suppliers: "Suppliers", sales: "Sales", purchases: "Purchases", reports: "Reports" },
    },
    currencies: {
      baseTitle: "Base currency",
      baseSubtitle: "All prices are shown in this currency",
      change: "Change",
      baseTag: "Base",
      basePickTitle: "Select the base currency",
      basePickHint: "The first currency you pick becomes the base",
      addTitle: "Additional currencies",
      addSubtitle: "Rate is shown relative to the base currency",
      add: "Add",
      empty: "No additional currencies added yet",
      pickBaseModal: "Select the base currency",
      pickAddModal: "Select a currency",
      searchPlaceholder: "Search (USD, dollar...)",
      notFound: "Not found",
      rateModalTitle: "Rate —",
      editRateModalTitle: "Edit rate —",
      editRateTooltip: "Edit rate", bankRate: "Bank rate:", useBankRate: "Bank rate", bankRateHint: "When enabled, the rate is taken from the Central Bank (CBU) and refreshed on save.", bankRateOn: "Using bank rate", bankSource: "Central Bank rate, date:", bankError: "Could not fetch bank rate (you can enter it manually).",
      ratePlaceholder: "e.g. 12700",
      rateHint: "Enter how many {base} equal 1 {code}",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving...",
      addBtn: "Add",
      rateInvalid: "Enter a valid rate",
      baseFirst: "Select the base currency first",
      saved: "Currency settings saved",
      error: "An error occurred",
      names: {
        UZS: "Uzbek som", USD: "US dollar", EUR: "Euro", RUB: "Russian ruble",
        KZT: "Kazakh tenge", GBP: "Pound sterling", JPY: "Japanese yen",
        CNY: "Chinese yuan", TRY: "Turkish lira", AED: "UAE dirham", KGS: "Kyrgyz som",
        TJS: "Tajik somoni", TMT: "Turkmen manat", AZN: "Azerbaijani manat",
        GEL: "Georgian lari", UAH: "Ukrainian hryvnia", BYN: "Belarusian ruble",
        SAR: "Saudi riyal", CAD: "Canadian dollar", AUD: "Australian dollar",
        CHF: "Swiss franc", INR: "Indian rupee", KRW: "South Korean won",
        SEK: "Swedish krona", NOK: "Norwegian krone", DKK: "Danish krone",
        PLN: "Polish zloty", CZK: "Czech koruna", HUF: "Hungarian forint", RON: "Romanian leu",
      },
    },
    general: {
      saved: "Saved",
      error: "Error",
      soonBadge: "(soon)",
      businessTitle: "Business type",
      businessSubtitle: "Choose which modules your organization needs — the sidebar is trimmed accordingly",
      businessNote: "The mode only affects the UI — data is always preserved. To show a module again, select \"All\".",
      skladTitle: "Warehouse",
      skladSubtitle: "Sales and stock settings",
      jobFoldersSectionTitle: "Job orders — folders",
      jobFoldersTitle: "Show folders",
      jobFoldersHint: "Enables folder organization (folder tree) in the Job orders module. Off by default.", paymentsTitle: "Payments", paymentsSubtitle: "Settings for incoming/outgoing payment documents.", paymentStatusesTitle: "Payment statuses", paymentStatusesHint: "When enabled, incoming and outgoing payments show a status field — statuses can be added/removed. When off, the status field is hidden.", purchasesTitle: "Purchases", purchasesSubtitle: "Purchase document settings.", purchaseReturnsTitle: "Purchase returns", salesTitle: "Sales sections", salesSubtitle: "Choose which sub-sections appear in the Sales menu.", salesOrders: "Orders", salesInvoices: "Sales (invoices)", salesReturns: "Returns", salesSectionsHint: "A disabled section is hidden from the sidebar. If all are off, the Sales group isn't shown.", salesProductFolder: "Product folder", salesProductFolderHint: "In the sales form only products from this folder (and subfolders) are shown. Empty = all.", purchaseReturnsHint: "When enabled, \"Returns\" appears in the Purchases section. When off — hidden.", discountFieldTitle: "Discount field", discountFieldHint: "When enabled, a discount (%) column appears in purchase receipts and sales invoices. Off by default.", purchaseDefaultWarehouse: "Default warehouse", purchaseDefaultWarehouseHint: "Warehouse automatically pre-selected when creating purchase receipts. Empty = not set.", productionDefaultWarehouses: "Default warehouses", productionDefaultWarehousesHint: "Warehouses automatically pre-selected when creating production orders.", productionDefaultRawWarehouse: "Raw materials warehouse", productionDefaultFinishedWarehouse: "Finished goods warehouse", jobProcLaborTitle: "Process labor cost", jobProcLaborHint: "Shows the labor cost field in job order processes. When off — hidden.", jobProcAllocatedTitle: "Process allocated amount", jobProcAllocatedHint: "Shows the allocated amount field in job order processes. When off — hidden.", sketchRequiredTitle: "Sketch required", sketchRequiredHint: "When enabled, uploading a sketch (image/PDF) is required when creating a job order. When off (default) — optional.", sketchInListTitle: "Sketch in job orders list", sketchInListHint: "When enabled, the 1st image (sketch) shows in the job orders list (after #) — click the magnifier to view full. Empty square if no image. Off by default.", costWarnTitle: "Cost warning percent", costWarnHint: "If an order's cost exceeds this percent of the agreed price, a red warning shows in the list (for in-progress and completed orders). E.g. 50% — cost over half the price. Default 50%.", ndsTitle: "Tax (VAT)", ndsSubtitle: "Enable if the organisation is a VAT payer — VAT columns will appear in sales invoices.", hasNdsTitle: "VAT-registered organisation", hasNdsHint: "When enabled, sales invoices show MKIX code, VAT rate, VAT amount, and Total (incl. VAT) columns.", negCashboxTitle: "Allow negative cashbox", negCashboxHint: "When enabled, an expense may exceed the cashbox balance and go negative. When off (default) — expenses above the balance are blocked.", cashierTitle: "Cashier", cashierSubtitle: "Which cashboxes are visible to Cashier-type employees.", cashierNoCashboxes: "No cashboxes.", cashierHint: "Only checked cashboxes are visible to the cashier. If none checked — none.", cashierCpTitle: "Cashier — counterparty folders", cashierCpSubtitle: "Which folders\u2019 counterparties appear for the cashier on income.", cashierNoFolders: "No folders.", cashierCpHint: "Only counterparties from checked folders are visible to the cashier. If none checked — none.", snabjenistCpTitle: "Procurement officer — supplier folders", snabjenistCpSubtitle: "Which folders are visible to the procurement officer when viewing suppliers.", snabjenistCpHint: "Only counterparties from checked folders are visible to the procurement officer. If none checked — all are shown.", catCpTitle: "Category \u2014 counterparty folder", catCpSubtitle: "When a category is picked in a payment, the counterparty list is filtered to this folder.", catCpEmpty: "No categories.", catCpHint: "For a category set to \"No counterparty\" (e.g. Groceries) no counterparty is asked.", catCpAll: "All counterparties", catCpNone: "No counterparty", catCpIncoming: "income", catCpOutgoing: "expense",
      negStockTitle: "Allow negative stock",
      negStockHint: "If enabled, you can sell goods not in stock (the balance goes negative). If disabled, a sales invoice is blocked when there isn't enough stock.",
      servSellTitle: "Sell services",
      servSellHint: "If enabled, inventory shows the \"+ Service\" button and \"Service\" filter — you can add and sell service-type items. If disabled, only products are handled.",
      purchasesTitle: "Purchases",
      purchasesSubtitle: "Choose which submenu shows in the \"Purchases\" sidebar section",
      purchasesNote: "The mode only affects the UI — existing data is preserved.",
      costingTitle: "Cost accounting (COGS)",
      costingSubtitle: "Which method computes profit and inventory value",
      costingNote: "Note: cost is \"frozen\" at sale time — changing the method doesn't change the profit of existing documents.",
      cpSectionTitle: "Counterparties", cpStatusTitle: "Counterparty status", cpStatusHint: "Enables the status field for counterparties. When off — the status column/filter/field is hidden.", cpFolderTitle: "Counterparty filter", cpFolderSubtitle: "Filter counterparties by folder in forms",
      cpFolderAll: "All (no filter)",
      cpSupplierFolder: "Purchase / Procurement folder", cpSupplierFolderHint: "Purchase and procurement forms show only suppliers from this folder",
      cpCustomerFolder: "Sales / Job order folder", cpCustomerFolderHint: "Sales and job-order forms show only customers from this folder",
      cpFolderNone: "No folder",
      cpJobOrderNewCustomerFolder: "Folder for new customers in job orders", cpJobOrderNewCustomerFolderHint: "A new customer added from within the job order form goes into this folder", prodFolderTitle: "Production — product folders", prodFolderSubtitle: "In the production form, the raw material and finished product pickers are filtered to these folders (including subfolders).", prodRawFolder: "Raw material folder", prodRawFolderHint: "In production components (raw materials) only products from this folder are shown. Empty = all.", prodFinishedFolder: "Finished product folder", prodFinishedFolderHint: "In production outputs (finished goods) only products from this folder are shown. Empty = all.", prodOutputBatchTitle: "Finished product batch & expiry", prodOutputBatchHint: "When on, batch number and expiry fields appear for finished products in production. Off by default.", navOrderTitle: "Sidebar order", navOrderSubtitle: "Configure the order of sections in the sidebar.", navOrderReset: "Reset to default",
      costing: {
        average: { label: "Weighted average (AVCO)", hint: "Average cost is calculated automatically from receipts" },
        manual:  { label: "Manual (product cost)", hint: "Uses the cost entered manually on the product" },
        fifo:    { label: "FIFO (first in — first out)", hint: "Layered cost: the oldest batch is sold first" },
        batch:   { label: "By batch (lot)", hint: "A batch is selected on sale, with expiry" },
      },
      business: {
        retail:      { label: "Store (sales)", hint: "Retail store — keeps goods in the warehouse and sells to customers. Job orders and Production modules are hidden." },
        "job-order": { label: "Maker (job orders)", hint: "Works per customer order — finished goods aren't stocked, handed directly to the customer. Sales and Production modules are hidden." },
        production:  { label: "Manufacturing", hint: "Produces finished goods from raw materials and sells them. Production section is shown, Job orders module is hidden." },
        all:         { label: "All (mixed)", hint: "Sales, Job orders and Production — all visible. The most flexible option." },
      },
      procurement: {
        orders:      { label: "Orders", hint: "Direct purchase order (PO) to supplier — a simple workflow." },
        procurement: { label: "Procurement", hint: "Internal procurement process: requester's request → warehouse receipt. For larger teams." },
        both:        { label: "Both", hint: "Orders and Procurement — both submenus are visible." },
        none:        { label: "Receipts only", hint: "Hides both Orders and Procurement — only Receipts (and Returns)." },
      },
    },
  },

  // Settings → UOM & Company tabs
  settingsExtra: {
    uom: {
      customTitle: "My units of measure",
      customSubtitle: "Added by you, can be deleted",
      add: "Add",
      customEmpty: "You don't have any custom units yet",
      thShort: "Short",
      thFull: "Full name",
      deleteTitle: "Delete",
      systemTitle: "System units of measure",
      systemSubtitle: "Shared across all organizations, can't be deleted",
      systemBadge: "System", thVisible: "Visible", visibleHint: "If checked — shown across the system (forms and lists)", addDisabled: "Disabled for now",
      newUnit: "New unit of measure",
      shortName: "Short name",
      shortNamePlaceholder: "e.g. kg, pcs, m²",
      shortNameHint: "Short label shown on the product card",
      fullName: "Full name",
      fullNamePlaceholder: "e.g. Kilogram, Piece, Square meter",
      cancel: "Cancel",
      saving: "Saving...",
      addBtn: "Add",
      added: "Unit of measure added",
      deleted: "Unit of measure deleted",
      loadError: "Failed to load units of measure",
      error: "An error occurred",
      groups: {
        count: "Count",
        weight: "Weight",
        length: "Length",
        areaVol: "Area & volume",
        liquid: "Liquid",
        packaging: "Packaging & containers",
        time: "Time",
        service: "Service",
        other: "Other",
      },
    },
    trash: {
      retentionLabel: "Retention period",
      never: "Never delete",
      neverMark: "Kept",
      retentionSaved: "Period saved",
      subtitleNever: "records are never removed automatically. Restoring also brings back related data (notes, links).",
      title: "Trash",
      subtitlePrefix: "Deleted records",
      subtitleSuffix: "are permanently removed after this many days. Restoring also brings back related data (notes, links).",
      searchPlaceholder: "Name, phone...",
      empty: "Trash is empty",
      thType: "Type",
      thDetails: "Details",
      thName: "Name",
      thDeletedBy: "Deleted by", allTypes: "All types", allUsers: "All users",
      kinds: { Contact: "Contact", Deal: "Deal", Task: "Task", Funnel: "Funnel" },
      thDate: "Date",
      thLeft: "Left",
      daysSuffix: "days",
      restoreTitle: "Restore",
      permDeleteTitle: "Delete permanently",
      modalTitle: "Delete permanently",
      confirmSuffix: "— delete it permanently? This cannot be undone — the record and attached files will be removed. For a funnel, its deals are removed too.",
      cancel: "Cancel",
      deleting: "Deleting...",
      permDeleteBtn: "Delete permanently",
      restored: "Restored",
      restoreError: "Restore failed",
      permDeleted: "Permanently deleted",
      deleteError: "Delete failed",
      loadError: "Load failed",
    },
    audit: {
      title: "Audit log",
      subtitle: "Who did what and when",
      empty: "No records",
      thTime: "Time",
      thUser: "User",
      thAction: "Action",
      thBranch: "Department",
      thObject: "Object",
      thIp: "IP",
      view: "View",
      detailTitle: "Record details",
      fResource: "Department / resource",
      fId: "Object ID",
      fMethod: "Method",
      fPath: "Path",
      fStatus: "Status",
      allUsers: "All users",
      dateFrom: "From",
      dateTo: "To",
      thModule: "Module",
      modules: { trash: "Trash", organization: "Settings", uom: "Units", inventory: "Products", counterparty: "Counterparties", warehouse: "Warehouses", purchases: "Purchases", sales: "Sales", payments: "Payments", "payment-requests": "Payment requests", integrations: "Integrations", cashbox: "Cashboxes", conversions: "Conversion", transfers: "Transfers", reports: "Reports", upload: "Files", trash: "Trash", export: "Export", production: "Production", departments: "Departments", branches: "Branches", "job-orders": "Job orders", proposals: "Proposals", "job-order-folders": "Job order folders", contracts: "Contracts", "akt-sverka": "Reconciliation act", procurement: "Procurement",
        contacts: "Contacts", funnels: "Pipelines", tasks: "Tasks", "lead-forms": "Lead forms", inbox: "Inbox", instagram: "Instagram", facebook: "Facebook", whatsapp: "WhatsApp", atc: "IP telephony", "lead-journey": "Lead journey", email: "Email", push: "Push notifications", reviews: "Reviews", yandex: "Yandex",
        "organization-users": "Users", "organization-roles": "Roles", "organization-currencies": "Currency settings", "organization-settings": "General settings", "organization-contact-fields": "Contact fields", "organization-deal-fields": "Deal fields", "organization-task-stages": "Task stages", "organization-deal-sources": "Deal sources", "organization-close-reasons": "Close reasons", "organization-goals": "Goals", "organization-sticker-packs": "Sticker packs", "organization-telegram-bot": "Telegram bot", "organization-telegram-accounts": "Telegram account",
        "funnels-deals": "Deals", "funnels-deal-activities": "Deal comments", "funnels-deal-files": "Deal files", "call-analysis": "AI call analysis", "contacts-activities": "Contact comments" },
      actions: { create: "Created", update: "Updated", delete: "Deleted", login: "Logged in", logout: "Logged out", register: "Registered", password_change: "Changed password", profile_update: "Updated profile", view: "Viewed" },
      loadError: "Load failed",
    },
    company: {
      subBranches: "Branches",
      subDepartments: "Departments",
      branches: {
        title: "Branches",
        subtitle: "Organization branches — departments can be linked to these branches",
        add: "Add",
        empty: "No branches",
        thName: "Name",
        thActions: "Actions",
        newBranch: "New branch",
        editBranch: "Edit branch",
        name: "Name",
        namePlaceholder: "Head office, Chilonzor branch...",
        nameRequired: "Name is required",
        cancel: "Cancel",
        save: "Save",
        deleteTitle: "Delete branch",
        deleteSuffix: "— delete this branch? Departments in this branch will have their branch link removed (the departments themselves are kept).",
        deleteBtn: "Delete",
        added: "Added",
        updated: "Updated",
        deleted: "Deleted",
        loadError: "Load failed",
        error: "Error",
      },
      departments: {
        title: "Departments (production processes)",
        subtitle: "Processes inside a job order are picked from these departments (cutting, gluing, painting...)",
        add: "Add",
        empty: "No departments",
        thName: "Name",
        thBranch: "Branch",
        thActions: "Actions",
        newDept: "New department",
        editDept: "Edit department",
        name: "Name",
        namePlaceholder: "Cutting, Painting...",
        branch: "Branch",
        branchNone: "— Not selected —",
        thType: "Type",
        type: "Department type",
        typeProcess: "Process (workflow)",
        typeManagement: "Management",
        typeHint: "When adding a job-order process, only \"process\" departments are shown (not management).",
        cancel: "Cancel",
        save: "Save",
        deleteTitle: "Delete department",
        deleteSuffix: "— delete this department? The related link on users will be removed (but the users themselves are kept).",
        deleteBtn: "Delete",
        added: "Department added",
        updated: "Updated",
        deleted: "Deleted",
        loadError: "Load failed",
        error: "Error",
      },
    },
  },

  // Top navbar
  units: {
    billion: "B",
    million: "M",
    thousand: "K",
  },

  analytics: {
    title: "Analytics",
    subtitle: "All statistics on sales, calls, contacts and channels in one place",
    tabs: {
      director: "Director",
      sales: "Sales",
      calls: "Calls",
      funnels: "Funnels",
      journey: "Lead journey",
      quality: "Call quality",
      contacts: "Contacts",
      inbox: "Inbox",
      reviews: "Reviews",
    },
    period: {
      "7d": "7 days",
      "30d": "30 days",
      "90d": "90 days",
      month: "This month",
      custom: "Custom",
    },
    director: {
      reportFor: "Report for",
      allStaff: "All employees",
      staffN: "Employees: {n}",
      period: {
        today: "Today",
        yesterday: "Yesterday",
        thisWeek: "This week",
        lastWeek: "Last week",
        thisMonth: "This month",
        lastMonth: "Last month",
        quarter: "This quarter",
        year: "This year",
        custom: "Custom range",
      },
      sum: {
        dealsInWork: "Deals in progress",
        notes: "Notes added",
        tasksInWork: "Tasks in progress",
        purchases: "Successful deals (purchases total)",
      },
      deals: {
        title: "Deals",
        inWork: "In progress",
        new: "New",
        lost: "Lost",
        won: "Successful",
        note: "\"In progress\" — deals open right now. \"New\" — created in the period. \"Lost\" and \"Successful\" — closed in the period. The percentage is the share of successful deals among all deals.",
      },
      contacts: {
        title: "Contacts",
        total: "Total",
        new: "New in period",
      },
      events: {
        title: "Events",
        dealsCreated: "Deals created",
        contactsCreated: "Contacts created",
        stageChanges: "Stage changes",
        tasksCompleted: "Completed tasks",
        withResult: "with a result: {n}",
        notes: "Notes added",
        files: "Files attached",
        callsIn: "Incoming calls",
        callsOut: "Outgoing calls",
      },
      tasks: {
        title: "Tasks",
        type: {
          call: "Contact",
          meeting: "Meeting",
          other: "Other",
        },
        new: "New",
        overdue: "Overdue",
        done: "Completed",
        completion: "Completion rate",
        avgTime: "Average completion time",
        hours: "h",
        days: "d",
        dueToday: "Due today",
        unassigned: "Unassigned",
      },
      staff: {
        title: "Employees: overall picture",
        employee: "Employee",
        dealsCreated: "Deals",
        contactsCreated: "Contacts",
        stageChanges: "Stage changes",
        notes: "Notes",
        tasksCompleted: "Tasks done",
        tasksOpen: "Tasks open",
        tasksOverdue: "Overdue",
        callsIn: "Incoming",
        callsOut: "Outgoing",
      },
    },
    loadError: "Failed to load data",
    empty: "No data for the selected period",
    sales: {
      created: "New deals",
      won: "Won",
      lost: "Lost",
      conversion: "Conversion",
      cycle: "Deal cycle",
      days: "d",
      avgDeal: "Average deal {v}",
      activeNow: "In progress now: {n}",
      dynamics: "Deal dynamics",
      lostReasons: "Lost reasons",
      noReason: "No reason given",
      byManager: "By manager",
      thManager: "Manager",
      thSum: "Sales amount",
      noManager: "Unassigned",
      ownership: "Assigned to employees",
      ownLeads: "Active leads",
      ownLeadsShared: "of which shared",
      ownContacts: "Contacts",
      ownContactsShared: "of which shared",
      ownershipNote: "If a lead or contact has several owners, it is counted for each of them.",
      bySource: "Sources: received → won",
      noSource: "No source",
      allFunnels: "All funnels",
      allManagers: "All managers",
      pipeline: "Pipeline now",
    },
    funnels: {
      view_intake: "Lead intake",
      view_staff: "By employee",
      noFunnels: "No funnels yet",
      total: "Total leads",
      assigned: "Assigned to a manager",
      notAssigned: "Not assigned",
      assignRate: "Assigned rate",
      noLeads: "No leads in this period",
      staffHint: "How many leads each employee created in this funnel and their current status (leads moved to other funnels are included).",
      thEmployee: "Employee",
      thTotal: "Total",
      thActive: "Active",
      thWon: "Won",
      thLost: "Lost",
    },
    reviews: {
      scans: "QR scans",
      clicks: "Review clicks",
      conversion: "Conversion",
      pending: "New complaints",
      newReviews: "New map reviews",
    },
  },

  ui: {
    filters: "Filters",
    reset: "Reset",
    done: "Done",
    more: "More",
    clearAll: "Clear all",
    search: "Search",
    sort: "Sort",
    assignee: "Assignee",
    source: "Source",
    created: "Created date",
    dateFrom: "From",
    dateTo: "To",
    all: "All",
    none: "Not set",
    back: "Back",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    selected: "Selected: {n}",
  },

  // Автоматически вынесенные тексты интерфейса (loc.<файл>.<ключ>)
  loc: {
    registerPage: {
      thisSlugIsTakenChoose: "This slug is taken. Choose another one",
      takeYourBusiness: "Take your business",
      digital: "digital",
      warehouseSalesCustomersAndFinance: "Warehouse, sales, customers and finance — all in one system.",
      whatIsASlug: "What is a slug?",
      aSlugIsYourOrganization: "A slug is your organization’s unique identifier in the system. For example:",
      youWillUseThisSlug: ". You will use this slug when signing in.",
      "2025CrmLineAllRights": "© 2025 CRM Line. All rights reserved.",
      createAnOrganization: "Create an organization",
      createAnAccountAndGet: "Create an account and get started right away",
      organization: "Organization",
      organizationName: "Organization name",
      eGBarakaSavdo: "E.g.: Baraka Savdo",
      organizationSlug: "Organization slug",
      uniqueIdInTheSystem: "(unique ID in the system)",
      thisSlugIsTakenChoose2: "This slug is taken. Choose another name",
      thisSlugIsAvailable: "✓ This slug is available",
      forSignIn: "For sign-in:",
      organizationType: "Organization type",
      adminAccount: "Admin account",
      yourName: "Your name",
      firstLastName: "First Last name",
      phone: "Phone",
      forSignIn2: "(for sign-in)",
      email: "Email",
      forPasswordRecovery: "(for password recovery)",
      password: "Password",
      confirm: "Confirm",
      loading: "Loading...",
      alreadyHaveAnAccount: "Already have an account?",
      signIn: "Sign in",
    },
    callButton: {
      startingCall: "Starting call...",
      noExtensionIsAssignedTo: "No extension is assigned to you. Contact your administrator.",
      pbx: "{title} (PBX)",
      viaPbx: "Via PBX",
      fromPersonalPhone: "From personal phone",
    },
    callRecordingPlayer: {
      download: "Download recording",
      downloadFailed: "Could not download the recording",
      couldNotLoadTheCall: "Could not load the call recording",
      couldNotLoadTheRecording: "Could not load the recording",
      speed: "Speed",
    },
    categoryProductPicker: {
      selected: "{size} selected",
      nothingSelected: "Nothing selected",
      done: "Done",
    },
    incomingCallModal: {
      incomingCall: "Incoming call",
      outgoingCall: "Outgoing call",
      crmContact: "CRM contact",
      assignee: "Assignee:",
      openContact: "Open contact",
      unknownNumber: "Unknown number",
      notFoundInCrm: "Not found in CRM",
      extension: "Extension:",
      close: "Close",
      contact: "Contact",
    },
    lockScreen: {
      opened: "Opened",
      wrongPassword: "Wrong password",
      signOutOfTheAccount: "Sign out of the account completely?",
      user: "User",
      passwordToUnlockTheScreen: "Password to unlock the screen",
      password: "Password",
      unlock: "Unlock",
      signInWithAnotherAccount: "Sign in with another account",
    },
    accountPage: {
      saved: "Saved",
      somethingWentWrong: "Something went wrong",
      extension: "Extension",
      notAssigned: "Not assigned",
      yourPbxExtensionSipuniIbrat: "Your PBX extension (Sipuni/ibrat.sip.uz) — only an admin can assign or change it in Settings → Employees.",
      thisNumberIsAlsoUsed: "This number is also used to sign in — only an admin can change it in Settings → Employees.",
      email: "Email",
      atLeast4Characters: "at least 4 characters",
    },
    callsPage: {
      error: "Error",
      linkCall: "Link call",
      number: "Number:",
      contact: "Contact",
      searchForAContact: "Search for a contact...",
      remove: "Remove",
      deal: "Deal",
      enterDealTitle: "Enter deal title...",
      cancel: "Cancel",
      save: "Save",
      failedToLoad: "Failed to load",
      selected: "{size} selected",
      changeTheFilterOrSearch: "Change the filter or search",
      link: "Link",
      callBack: "Call back",
      delete: "Delete",
      previous: "Previous",
      next: "Next",
    },
    contactAnalyticsPage: {
      text: "{count} · {date}",
      newContactsInPeriod: "New contacts in period",
      totalContacts: "Total contacts",
      allTime: "All time",
      newContactsPerDay: "New contacts per day ({from} — {to})",
      byChannelViaInbox: "By channel (via Inbox)",
      noData: "No data",
      byOperator: "By operator",
      noPhoneNumbers: "No phone numbers",
    },
    contactFormPage: {
      select: "— Select",
      notSaved: "Not saved",
      chooseFile: "Choose file",
      call: "call",
      outgoing: "Outgoing",
      incoming: "Incoming",
      ext: "· Ext: {ext}",
      contactNotFound: "Contact not found",
      nameIsRequired: "Name is required",
      contactAdded: "Contact added",
      saved: "Saved",
      somethingWentWrong: "Something went wrong",
      fileUploaded: "File uploaded",
      uploadFailed: "Upload failed",
      deleteTheFile: "Delete the file?",
      fileDeleted: "File deleted",
      deleteFailed: "Delete failed",
      blockRemoved: "Block removed",
      contactBlocked: "Contact blocked",
      contactDeleted: "Contact deleted",
      phone: "Phone",
      format998xxxxxxxxx: "Format: +998XXXXXXXXX",
      email: "Email",
      assignee: "Assignee",
      notAssigned: "Not assigned",
      loading: "Loading...",
      uploadFile: "+ Upload file",
      saveTheContactFirstTo: "Save the contact first to upload files",
      noFilesYet: "No files yet",
      download: "Download",
      sections: "Sections",
      main: "Main",
      phoneEmailResponsiblePerson: "Phone · Email · Responsible person",
      fields: "{length} fields",
      sectionName: "Section name...",
      addNewSection: "Add new section",
      fields2: "Fields",
      noFieldsYet: "No fields yet",
      fieldName: "Field name...",
      options: "Options",
      atLeast1: "(at least 1)",
      optionName: "Option name...",
      save: "Save",
      cancel: "Cancel",
      add: "Add",
      addField: "Add field",
      shiftEnterNewLine: "Shift+Enter — new line",
    },
    contactsPage: {
      deleteContact: "Delete contact",
      thisActionCannotBeUndone: "This action cannot be undone.",
      contactsWillBeDeleted: "contacts will be deleted.",
      text: "{count}",
      willBeDeleted: "will be deleted.",
      cancel: "Cancel",
      delete: "Delete",
      onlyCsvFilesAreAccepted: "Only CSV files are accepted",
      importError: "Import error",
      csvImport: "CSV import",
      importComplete: "Import complete!",
      contactsAdded: "contacts added,",
      skippedExistingOrEmpty: "skipped (existing or empty).",
      text2: "{created}",
      text3: "{skipped}",
      close: "Close",
      csvFileFormat: "CSV file format:",
      theFirstRowMustContain: "The first row must contain column names.",
      dropTheCsvFileHere: "Drop the CSV file here",
      orClickToChoose: "or click to choose",
      rows: "{v} — {length} rows",
      clear: "Clear",
      more: "… more",
      rows2: "rows",
      import: "Import (",
      text4: ")",
      failedToLoad: "Failed to load",
      merged: "Merged",
      error: "Error",
      duplicateContacts: "Duplicate contacts",
      noDuplicates: "No duplicates",
      allGood: "All good!",
      duplicateNumbers: "{count} duplicate numbers",
      merge: "Merge",
      created: "Created: {toLocaleDateString}",
      willBeSaved: "Will be saved",
      failedToLoadContacts: "Failed to load contacts",
      convertAllContactPhoneNumbers: "Convert all contact phone numbers to +998XXXXXXXXX format?",
      numbersNormalized: "{updated} numbers normalized",
      somethingWentWrong: "Something went wrong",
      csvDownloaded: "CSV downloaded",
    },
    dealDetailPage: {
      call: "call",
      outgoing: "Outgoing",
      incoming: "Incoming",
      ext: "· Ext: {ext}",
      select: "— Select",
      noOptions: "No options",
      failedToLoad: "Failed to load",
      titleIsRequired: "Title is required",
      saved: "Saved",
      assignedToYou: "Assigned to you",
      error: "Error",
      deleted: "Deleted",
      archived: "Archived",
      restoredFromArchive: "Restored from archive",
      closedAsWon: "Closed as won",
      closedAsLost: "Closed as lost",
      reopened: "Reopened",
      fileUploaded: "File uploaded",
      uploadFailed: "Upload failed",
      newRequest: "New deal",
      newDeal: "New deal",
      request: "Lead",
      won: "Won",
      lost: "Lost",
      reopen: "Reopen",
      closeAsWon: "Close as won",
      closeAsLost: "Close as lost",
      restoreFromArchive: "Restore from archive",
      archive: "Archive",
      reasonOptional: "Reason (optional)",
      whyWasItLost: "— why was it lost?",
      noReasonSelected: "— No reason selected —",
      eGTheClientSigned: "E.g.: the client signed the contract",
      eGThePriceDid: "E.g.: the price did not fit",
      close: "Close",
      reasonComment: "Reason (comment) *",
      whyIsItBeingArchived: "Why is it being archived?",
      clientName: "Client name...",
      dealTitle: "Deal title...",
      source: "Source",
      notSelected: "— Not selected —",
      note: "Note",
      noNotes: "No notes",
      notFound: "Not found",
      loading: "Loading...",
      contact: "Contact",
      blocked: "Blocked",
      phone: "Phone",
      email: "Email",
      reminder: "Reminder",
      overdue: "Overdue",
      openContact: "Open contact",
      notSelected2: "— Not selected",
      takeIt: "Take it",
      created: "Created",
      days: "days",
      call2: "Call",
      inOut: "In/Out",
      missedCalls: "Missed calls",
      activityOverTheLast14: "Activity over the last 14 days",
      callHistory: "Call history",
      noCallsYet: "No calls yet",
      uploadFile: "+ Upload file",
      saveFirstToUploadFiles: "Save first to upload files",
      noFilesYet: "No files yet",
      download: "Download",
      sections: "Sections",
      main: "Main",
      stageAmountSourceContactAssignee: "Stage · Amount · Source · Contact · Assignee",
      fields: "{length} fields",
      sectionName: "Section name...",
      addNewSection: "Add new section",
      fields2: "Fields",
      noFieldsYet: "No fields yet",
      fieldName: "Field name...",
      options: "Options",
      atLeast1: "(at least 1)",
      optionName: "Option name...",
      save: "Save",
      cancel: "Cancel",
      add: "Add",
      addField: "Add field",
      shiftEnterNewLine: "Shift+Enter — new line",
    },
    forgotPasswordPage: {
      serverAndPhoneAreRequired: "Server and phone are required",
      error: "Error",
      check: "Check",
      ifSuchAUserExists: "If such a user exists, a password reset link has been sent to the email. The link is valid for 1 hour.",
      backToSignIn: "Back to sign in",
      resetPassword: "Reset password",
      enterYourServerAndPhone: "Enter your server and phone number — a reset link will be sent to your email.",
      server: "Company code",
      phone: "Phone",
      sendLink: "Send link",
      sending: "Sending...",
    },
    funnelPage: {
      age: "Created {days} d ago",
      dealsLabel: "Deals:",
      archive: "Archive",
      request: "Lead",
      d: "{days} d",
      takeIt: "Take it",
      reactivate: "Reactivate",
      deal: "deal",
      empty: "Empty",
      selectEverythingInThisStage: "Select everything in this stage",
      quickAdd: "Quick add",
      request2: "Leads:",
      source: "Source",
      notSelected: "— Not selected —",
      titleStageContactPhoneSource: "Title, Stage, Contact, Phone, Source, Value, Status, Note",
      failedToLoad: "Failed to load",
      restoredFromArchive: "Restored from archive",
      error: "Error",
      deleted: "Deleted",
      archive2: "Archive",
      theArchiveIsEmpty: "The archive is empty",
      openDeal: "Open deal",
      restore: "Restore",
      closedAsWon: "Closed as won",
      closedAsLost: "Closed as lost",
      assignedToYou: "Assigned to you",
      reactivated: "Reactivated",
      leadAdded: "Lead added",
      selected: "{size} selected",
      moveToStage: "Move to stage...",
      toAnotherFunnel: "To another funnel",
      assign: "Assign...",
      unassign: "— Unassign —",
      deletePermanently: "Delete permanently?",
      no: "No",
      yesDelete: "Yes, delete",
      delete: "Delete",
      close: "Close",
      thisFunnelHasNoStages: "This funnel has no stages",
      addStagesInSettingsFunnels: "Add stages in Settings → Funnels",
      won: "Won",
      lost: "Lost",
      chooseAnAssignee: "Choose an assignee",
      dealsSelected: "{size} deals selected",
      chooseAnEmployee: "Choose an employee...",
      cancel: "Cancel",
      confirm: "Confirm",
      closeAsWon: "Close as won",
      closeAsLost: "Close as lost",
      reasonOptional: "Reason (optional)",
      whyWasItLost: "— why was it lost?",
      noReasonSelected: "— No reason selected —",
      eGTheClientSigned: "E.g.: the client signed the contract",
      eGThePriceDid: "E.g.: the price did not fit",
      responsibleEmployee: "Responsible employee",
      moveToAnotherFunnel: "Move to another funnel",
      selected2: "selected",
      leads: "{size} leads",
      willBeArchived: "will be archived",
      leads2: "{length} leads",
      reasonComment: "Reason (comment) *",
      whyIsItBeingArchived: "Why is it being archived?",
    },
    inboxAnalyticsPage: {
      previousPeriod: "{pct}% (previous period: {prevValue})",
      conversationsPerDay: "Conversations per day",
      days: "{length} days",
      text: "{count} · {date}",
      inbox: "Inbox",
      totalConversations: "Total conversations",
      unanswered: "Unanswered",
      closed: "Closed",
      avgResponseTime: "Avg. response time",
      comparePeriods: "Compare periods",
      total: "Total",
      resolved: "Resolved, %",
      conversationsPerDay2: "Conversations per day ({from} — {to})",
      byChannel: "By channel",
      noData: "No data",
      agents: "Agents",
      labels: "Labels",
      noLabels: "No labels",
      reportByEmployee: "Report by employee",
      downloadCsv: "Download CSV",
      employee: "Employee",
      conversations: "Conversations",
      closed2: "Closed, %",
      avgReply: "Avg. reply",
      call: "Call",
    },
    inboxPage: {
      anonymous: "Anonymous",
      comment: "Comment",
      loading: "Loading...",
      file: "File",
      openFile: "Open file",
      post: "Post",
      instagramPost: "Instagram post",
      internalNote: "Internal note",
      replyToThisComment: "Reply to this comment",
      failedToLoad: "Failed to load",
      error: "Error",
      chatClosed: "Chat closed",
      chatReopened: "Chat reopened",
      failedToLoadData: "Failed to load data",
      thisContactAlreadyExists: "This contact already exists",
      contactCreated: "Contact created",
      agentAssigned: "Agent assigned",
      agentRemoved: "Agent removed",
      deleteThisChatAllMessages: "Delete this chat? All messages will be deleted too.",
      deleteFailed: "Delete failed",
      inbox: "Inbox",
      search: "Search...",
      conversations: "{convTotal} conversations",
      previous: "← Previous",
      next: "Next →",
      back: "Back",
      searchMessages: "Search messages",
      changeAgent: "Change agent",
      chooseAnAgent: "Choose an agent",
      remove: "Remove",
      labels: "Labels",
      availableLabels: "Available labels",
      newLabel: "New label...",
      reopenChat: "Reopen chat",
      contactInfo: "Contact info",
      commentsUnderThePostClick: "Comments under the post · click the comment you want to reply to",
      pressTheButton: "press the button",
      searchInMessages: "Search in messages...",
      results: "{length} results",
      replyToTheSelectedComment: "Reply to the selected comment",
      replyToTheLatestComment: "Reply to the latest comment",
      cancel: "Cancel",
      addAStickerPackIn: "Add a sticker pack in settings",
      sticker: "Sticker",
      sendFile: "Send file",
      status: "Status",
      call: "Call",
      phone: "Phone",
      email: "Email",
      noPacks: "No packs",
      noStickersFound: "No stickers found",
      selectAConversation: "Select a conversation",
      openAConversationFromThe: "Open a conversation from the list on the left",
    },
    resetPasswordPage: {
      passwordMustBeAtLeast: "Password must be at least 6 characters",
      passwordsDoNotMatch: "Passwords do not match",
      passwordChangedYouCanSign: "Password changed. You can sign in now.",
      error: "Error",
      newPassword: "New password",
      theLinkIsInvalidPlease: "The link is invalid. Please start the password reset again.",
      tryAgain: "Try again",
      enterYourNewPassword: "Enter your new password.",
      confirmPassword: "Confirm password",
      changePassword: "Change password",
      saving: "Saving...",
    },
    reviewsPage: {
      uploadFailed: "Upload failed",
      failedToLoadReviews: "Failed to load reviews",
      deleteThisPage: "Delete this page?",
      error: "Error",
      newReviewsCollected: "{added} new reviews collected",
      noNewReviews: "No new reviews",
      collectionFailed: "Collection failed",
      reviews: "Reviews",
      collectCustomerReviewsViaQr: "Collect customer reviews via QR",
      newPage: "New page",
      scans: "Scans",
      reviewClicks: "Review clicks",
      conversion: "Conversion",
      newComplaints: "New complaints",
      googleReviews: "Google reviews",
      edit: "Edit",
      delete: "Delete",
      totalReviews: "Total: {collectedTotal} reviews",
      collectNow: "Collect now",
      noMapReviewsCollectedYet: "No map reviews collected yet. If Google/Yandex is connected on the page, reviews are collected automatically (every few hours).",
      anonymous: "Anonymous",
      loadMore: "Load more ({length}/{collectedTotal})",
      noInternalFeedbackYet: "No internal feedback yet",
      contact: "Contact",
      complaint: "Complaint",
      reviewed: "Reviewed",
      saved: "Saved",
      saveFailed: "Save failed",
      testMessageSent: "Test message sent ✅",
      testWasNotSent: "Test was not sent",
      telegramNotifications: "Telegram notifications",
      newGoogleYandexReviewsAre: "New Google/Yandex reviews are automatically sent to your Telegram group/channel.",
      notificationsEnabled: "Notifications enabled",
      botToken: "Bot token",
      savedEnterANewOne: "•••••• (saved — enter a new one to change)",
      createABotInBotfather: "Create a bot in @BotFather and enter its token.",
      chatId: "Chat ID",
      "1001234567890OrChannelName": "-1001234567890 or @channel_name",
      addTheBotToThe: "Add the bot to the group. You can get the group chat_id via @getidsbot.",
      saving: "Saving...",
      save: "Save",
      test: "Test",
      noPagesYet: "No pages yet",
      createYourFirstReviewPage: "Create your first review page",
      failedToDownloadQr: "Failed to download QR",
      downloadQr: "Download QR",
      printItAndPlaceIt: "Print it and place it on the table",
      googlePlaceLinkedTheReview: "Google place linked — the review link was filled in automatically",
      linkingFailed: "Linking failed",
      updated: "Updated",
      updateFailed: "Update failed",
      unlinkGoogle: "Unlink Google?",
      unlinked: "Unlinked",
      googleReviews2: "Google reviews — {name}",
      findYourBusinessOnGoogle: "Find your business on Google Maps and link it — the rating and reviews will appear here.",
      eGCaffeBahorChilanzar: "E.g.: Caffe Bahor, Chilanzar Tashkent",
      nothingFoundRefineTheName: "Nothing found — refine the name",
      reviews2: "{toFixed} · {total} reviews",
      onTheMap: "On the map",
      reviews3: "reviews",
      updated2: "Updated: {syncedLabel}",
      inMin: "in {cooldownMin} min",
      refresh: "Refresh",
      unlink: "Unlink",
      reviewTextNotFound: "Review text not found",
      user: "User",
      googlePlacesApiReturnsOnly: "Google Places API returns only the latest ~5 reviews.",
      googleApiKeyIsNot: "Google API key is not configured",
      searchError: "Search error",
      yandexApiKeyIsNot: "Yandex API key is not configured",
      "2gisConnectedReviewsCollected": "2GIS connected — reviews collected",
      "2gisConnectionError": "2GIS connection error",
      "2gisDisconnected": "2GIS disconnected",
      enterAName: "Enter a name",
      editing: "Editing",
      newReviewPage: "New review page",
      nameBranch: "Name (branch)",
      chilanzarBranch: "Chilanzar branch",
      titleVisibleToTheCustomer: "Title (visible to the customer)",
      reviews4: "{toFixed}★ · {total} reviews",
      change: "Change",
      googleReviewLinkFilledIn: "Google review link filled in automatically",
      linkAGoogleMapsPlace: "Link a Google Maps place (URL is filled in automatically)",
      enterTheBusinessName: "Enter the business name...",
      notFoundRefineYourQuery: "Not found — refine your query",
      yandexReviewLinkFilledIn: "Yandex review link filled in automatically",
      linkAYandexMapsPlace: "Link a Yandex Maps place (URL is filled in automatically)",
      "2gisBranch": "2GIS branch",
      review: "review",
      toLink2gisSaveThe: "To link 2GIS, save the page first, then reopen it.",
      "2gisLink2gisUzTashkent": "2GIS link: 2gis.uz/tashkent/firm/70000...",
      link: "Link",
      platformsAndLinks: "Platforms and links",
      filledInAutomaticallyWhenA: "Filled in automatically when a Google place is linked",
      reviewLinkUrl: "Review link (URL)",
      smartRoutingGating: "Smart routing (gating)",
      highRatingMapLowRating: "High rating → map; low rating → internal feedback",
      publishingThreshold: "Publishing threshold:",
      "4AndAbove": "4★ and above",
      "5Only": "5★ only",
      "3AndAbove": "3★ and above",
      googleProhibitsReviewGatingTurn: "⚠️ Google prohibits \"review gating\" — turn it off if you don’t need it.",
      cancel: "Cancel",
    },
    settingsPage: {
      main: "Main",
      contactDetails: "Contact details",
      appearance: "Appearance",
      baseCurrency: "Base currency",
      allDealsAndLeadsAre: "All deals and leads are shown in this currency.",
      directorSFullName: "Director’s full name",
      eGAliyevJasurAkhmadovich: "E.g.: Aliyev Jasur Akhmadovich",
      officeNumber: "Office number",
      address: "Address",
      eGTashkentChilanzarDistrict: "E.g.: Tashkent, Chilanzar district, 12",
      website: "Website",
      usernameOrFullLink: "@username or full link",
      usernameOr998: "@username or +998...",
      funnelNameIsRequired: "Funnel name is required",
      saved: "Saved",
      funnelCreated: "Funnel created",
      error: "Error",
      deleted: "Deleted",
      funnels: "Funnels",
      configureDealAndLeadStages: "Configure deal and lead stages",
      newFunnel: "New funnel",
      noFunnelsYet: "No funnels yet",
      createANewFunnelAnd: "Create a new funnel and add stages to it",
      noStages: "No stages",
      editFunnel: "Edit funnel",
      funnelName: "Funnel name",
      eGMainSalesB2b: "E.g.: Main sales, B2B, Premium...",
      stages: "Stages",
      add: "Add",
      color: "Color",
      aDealReachingThisStage: "A deal reaching this stage is automatically marked as Won (sale)",
      won: "Won",
      aDealReachingThisStage2: "A deal reaching this stage is automatically marked as Lost",
      lost: "Lost",
      choosingAnAssigneeIsRequired: "Choosing an assignee is required when moving to this stage (e.g. handing over from reception to a manager)",
      assigneeRequired: "Assignee required",
      staysInThisFunnel: "Stays in this funnel",
      moveTo: "Move to “{name}”",
      chooseAStage: "Choose a stage",
      whichRolesCanSeeIt: "Which roles can see it",
      ifNoneIsSelectedVisible: "If none is selected — visible to everyone (default).",
      noCustomRolesCreated: "No custom roles created",
      cancel: "Cancel",
      save: "Save",
      create: "Create",
      failedToLoad: "Failed to load",
      taskStages: "Task stages",
      configureTheKanbanColumnsTasks: "Configure the kanban columns. Tasks in a stage marked “Done” are considered completed.",
      done: "Done:",
      notCompleted: "Not completed:",
      doneStage: "“Done” stage",
      done2: "Done",
      addStage: "Add stage",
      salesSources: "Sales sources",
      sourcesThatCanBeChosen: "Sources that can be chosen when adding a sale",
      addSource: "Add source",
      addReason: "Add reason",
      closingReasons: "Closing reasons",
      whenADealIsClosed: "When a deal is closed as Won or Lost, the employee picks a reason from this list — instead of free text, so statistics use consistent values.",
      whenWon: "When won",
      whenLost: "When lost",
      formNameIsRequired: "Form name is required",
      selectAFunnel: "Select a funnel",
      selectAStage: "Select a stage",
      formUpdated: "Form updated",
      formCreated: "Form created",
      somethingWentWrong: "Something went wrong",
      editForm: "Edit form",
      newForm: "New form",
      formName: "Form name",
      eGWebsiteContactForm: "E.g.: Website contact form",
      funnel: "Funnel",
      stage: "Stage",
      titleOnTheFormPage: "Title (on the form page)",
      additionalDescription: "Additional description",
      optional: "Optional...",
      formColor: "Form color",
      organizationBrandColor: "Organization brand color",
      customColor: "Custom color",
      everyFormAlways: "Every form always",
      and: "and",
      fieldsRequired: "fields (required).",
      name: "Name",
      phone: "Phone",
      extraQuestions: "Extra questions",
      required: "Required",
      noExtraQuestionsYet: "No extra questions yet",
      questionText: "Question text...",
      options: "Options",
      atLeast1: "(at least 1)",
      optionName: "Option name...",
      addQuestion: "Add question",
      uploadFailed: "Upload failed",
      linkCopied: "Link copied",
      couldNotCopy: "Could not copy",
      formDeleted: "Form deleted",
      leadForms: "Lead forms",
      placeOnYourWebsiteOr: "Place on your website or social media — submitted requests go to the selected funnel.",
      firstCreateAFunnelIn: "First create a funnel in the “Funnels” section.",
      inactive: "Inactive",
      requests: "requests",
      delete: "Delete",
      enable: "Enable",
      noFormsYet: "No forms yet",
      deleteForm: "Delete form",
      willBeDeletedTheLink: "will be deleted. The link will stop working.",
      moduleVisibility: "Module visibility",
      whichModulesToShowOr: "Which modules to show or hide in the top bar and menu — applies to all users.",
      hidden: "Hidden",
      visible: "Visible",
      goals: "Goals",
      setSalesGoalsOverallAnd: "Set sales goals — overall and per employee",
      overallGoal: "Overall goal",
      amountUzs: "Amount (UZS)",
      numberOfSales: "Number of sales",
      byEmployee: "By employee",
      amountGoal: "Amount goal",
      countGoal: "Count goal",
      pushNotificationsEnabled: "Push notifications enabled!",
      permissionDeniedOrTheBrowser: "Permission denied or the browser does not support it",
      anErrorOccurred: "An error occurred",
      pushNotificationsDisabled: "Push notifications disabled",
      instagramConnectedSuccessfully: "Instagram connected successfully!",
      connectionError: "Connection error",
      facebookConnectedSuccessfully: "Facebook connected successfully!",
      facebookConnectionError: "Facebook connection error",
      failedToStartOauth: "Failed to start OAuth",
      disconnectInstagram: "Disconnect Instagram?",
      instagramDisconnected: "Instagram disconnected",
      facebookDisconnected: "Facebook disconnected",
      enterThePhoneNumberId: "Enter the Phone Number ID and Access Token",
      whatsappConnected: "WhatsApp connected!",
      connectionError2: "Connection error",
      disconnectWhatsapp: "Disconnect WhatsApp?",
      whatsappDisconnected: "WhatsApp disconnected",
      thisPackHasAlreadyBeen: "This pack has already been added",
      stickerPacksSaved: "Sticker packs saved",
      botTokenIsRequired: "Bot token is required",
      connected: "@{botUsername} connected",
      connectionCancelled: "Connection cancelled",
      disconnectTheBot: "Disconnect the bot?",
      botDisconnected: "Bot disconnected",
      enterAPhoneNumber: "Enter a phone number",
      theCodeWasSentTo: "The code was sent to your Telegram app",
      couldNotSendTheCode: "Could not send the code",
      enterTheCode: "Enter the code",
      enterThePassword: "Enter the password",
      telegramAccountConnected: "Telegram account connected",
      signInFailed: "Sign-in failed",
      disconnectTheAccountConversationsWill: "Disconnect the {label} account? Conversations will be closed.",
      accountDisconnected: "Account disconnected",
      emailSettingsSaved: "Email settings saved",
      testFailed: "Test failed",
      socialNetworks: "Social networks",
      email: "Email",
      notifications: "Notifications",
      integrations: "Integrations",
      connectExternalChannelsToThe: "Connect external channels to the CRM",
      telegramBot: "Telegram Bot",
      superchatAllMessagesArriveIn: "Superchat — all messages arrive in Inbox",
      connected2: "Connected",
      active: "active",
      notConfigured: "not configured",
      theBotWorksViaWebhook: "The bot works via webhook. When users message the bot, the messages arrive on the Inbox page.",
      disconnect: "Disconnect",
      botToken: "Bot Token",
      createANewBotAnd: "create a new bot and enter its token",
      connect: "Connect",
      telegramAccounts: "Telegram accounts",
      personalProfileTheCustomerWrites: "Personal profile — the customer writes to a real person, not a bot",
      text: "{length}",
      anEmployeeSPersonalTelegram: "An employee’s personal Telegram account is connected — its conversations appear in Inbox, and when replying from the CRM the customer receives the message from that profile.",
      addAccount: "Add account",
      automatingAPersonalAccountViolates: "Automating a personal account violates Telegram rules — the account may be blocked if spam is sent.",
      connectATelegramAccount: "Connect a Telegram account",
      phoneNumber: "Phone number",
      telegramWillSendAConfirmation: "Telegram will send a confirmation code to this number (the code arrives in the app itself).",
      sendCode: "Send code",
      verificationCode: "Verification code",
      codeSentTo: "Code sent to {phone}",
      confirm: "Confirm",
      "2faPassword": "2FA password",
      cloudPassword: "Cloud password",
      twoStepVerificationIsEnabled: "Two-step verification is enabled on the account",
      signIn: "Sign in",
      stickerPacks: "Sticker packs",
      stickerSetsForInboxChat: "Sticker sets for Inbox chat",
      add2: "Add",
      view: "view",
      noStickerPacksAddedYet: "No sticker packs added yet",
      instagramDm: "Instagram DM",
      connectDirectMessagesToInbox: "Connect Direct messages to Inbox",
      instagramBusinessAccountConnected: "Instagram Business account connected",
      instagramDmMessagesArriveOn: "Instagram DM messages arrive on the Inbox page automatically.",
      connectYourInstagramBusinessOr: "Connect your Instagram Business or Creator account. Authorization is done via OAuth through your Facebook page.",
      connectViaFacebook: "Connect via Facebook",
      metaDeveloperAppIdAnd: "Meta Developer App ID and Secret must be configured in .env",
      emailImapSmtp: "Email (IMAP/SMTP)",
      receiveAndReplyToEmail: "Receive and reply to email messages in Inbox",
      imapIncomingMessages: "IMAP — incoming messages",
      passwordAppPassword: "Password / App password",
      useTlsSslPort993: "Use TLS/SSL (port 993)",
      smtpOutgoingMessages: "SMTP — outgoing messages",
      senderNameEmailFrom: "Sender name/email (From)",
      useSslPort465: "Use SSL (port 465)",
      imap: "IMAP:",
      success: "Success",
      smtp: "SMTP:",
      test: "Test",
      forGmailEnableAppPasswords: "For Gmail, enable “App passwords”. The IMAP client automatically fetches new messages and adds them to Inbox.",
      pushNotifications: "Push notifications",
      aNotificationIsSentTo: "A notification is sent to your device when a new message arrives",
      yourBrowserDoesNotSupport: "Your browser does not support push notifications",
      browserPermissionWasDeniedAllow: "Browser permission was denied. Allow notifications in your browser settings.",
      notificationsEnabled: "✓ Notifications enabled",
      notificationsDisabled: "Notifications disabled",
      facebookMessenger: "Facebook Messenger",
      connectPageMessagesToInbox: "Connect Page messages to Inbox",
      facebookPageConnected: "Facebook Page connected",
      reallyDisconnect: "Really disconnect?",
      cancel2: "Cancel",
      yesDisconnect: "Yes, disconnect",
      targetLeadAdsLeads: "Target (Lead Ads) leads",
      leadsFromInstagramFacebookAds: "Leads from Instagram/Facebook ads (via a Lead Ads form) automatically land in this funnel and stage.",
      noFunnelSelected: "— No funnel selected —",
      noStageSelected: "— No stage selected —",
      untilAFunnelIsSelected: "Until a funnel is selected, target leads do not reach the CRM.",
      connectYourFacebookBusinessPage: "Connect your Facebook business page. Messenger messages sent to the page arrive in Inbox.",
      whatsappBusiness: "WhatsApp Business",
      connectViaCloudApi: "Connect via Cloud API",
      whatsappCloudApiConnected: "WhatsApp Cloud API connected",
      enterTheMetaCloudApi: "Enter the Meta Cloud API details (Meta dashboard → WhatsApp → API Setup).",
      whatsappBusinessAccountIdOptional: "WhatsApp Business Account ID (optional)",
      phoneNumberEG998: "Phone number (e.g. +998...)",
      accessTokenPermanent: "Access Token (permanent)",
      orders: "Orders",
      salesPurchases: "Sales & Purchases",
      cashier: "Cashier",
      other: "Other",
      employeeReportPhotoVideoLocation: "Employee report (photo/video/location)",
      employeeCreatesASupplyRequest: "Employee creates a supply request",
      enterStartDate: "Enter start date",
      createEstimatesInJobOrders: "Create estimates in job orders",
      showEstimatesToEmployees: "Show estimates to employees",
      showPricesToEmployees: "Show prices to employees",
      colourWarningAsTheDeadline: "Colour warning as the deadline approaches",
      colourRules: "Colour rules",
      ifTheDeadlineIsToday: "If the deadline is today — always red. Below: which colour to use when X days remain.",
      addRule: "+ Add rule",
      noRulesYetClickAdd: "No rules yet. Click “+ Add rule”.",
      daysLeft: "{daysLeft} days left",
      days: "Days:",
      background: "Background:",
      text2: "Text:",
      overdue: "Overdue",
      alwaysRedCannotBeChanged: "Always red — cannot be changed",
      tvModeButton: "TV mode button",
      freezePauseOption: "Freeze (pause) option",
      accountingTriggers: "Accounting triggers",
      whenMovingToTheStatus: "When moving to the status chosen below, the corresponding action runs automatically. If left empty — controlled by the old “Confirmed” button.",
      stockTrigger: "Stock trigger",
      inWhichStatusToDeduct: "— in which status to deduct from product stock",
      notSetLegacy: "— Not set (legacy) —",
      debtTrigger: "Debt trigger",
      inWhichStatusToRecord: "— in which status to record the counterparty’s debt",
      noFolders: "— No folders —",
      noneSelectedAllFoldersAre: "None selected — all folders are visible",
      hideWarehouseSelectionInThe: "Hide warehouse selection in the form",
      whichModulesAndSubmodulesTo: "Which modules and submodules to show or hide in the sidebar",
      extensionPbx: "Extension (PBX)",
      eG209: "E.g.: 209",
      pbxExtensionSipuniIbratSip: "PBX extension (Sipuni/ibrat.sip.uz) — used by the employee when calling via the PBX.",
      nameIsRequired: "Name is required",
      error2: "Error",
      confirmDeletion: "Confirm deletion?",
      failedToLoad2: "Failed to load",
      titleAndTextAreRequired: "Title and text are required",
      updated: "Updated",
      added: "Added",
      quickReplies: "Quick Replies",
      whenTypingInAChat: "When typing in a chat",
      pressAndChooseAQuick: "press and choose a quick reply",
      editing: "Editing",
      addNew: "Add new",
      title: "Title *",
      eGHello: "e.g.: hello",
      shortcut: "Shortcut",
      text3: "Text *",
      replyText: "Reply text...",
      noQuickReplies: "No quick replies",
    },
    tasksPage: {
      error: "Error",
    },
    userProfilePage: {
      userNotFound: "User not found",
      nameIsRequired: "Name is required",
      phoneNumberIsRequired: "Phone number is required",
      saved: "Saved",
      error: "Error",
      imageWasNotUploaded: "Image was not uploaded",
      filesUploaded: "{length} files uploaded",
      uploadFailed: "Upload failed",
      passwordMustBeAtLeast: "Password must be at least 4 characters",
      passwordChanged: "Password changed",
      userProfile: "User profile",
      user: "User",
      password: "Password",
      save: "Save",
      you: "You",
      active: "Active",
      inactive: "Inactive",
      basicInformation: "Basic information",
      name: "Name *",
      phoneNumber: "Phone number *",
      signInIsDoneWith: "Sign-in is done with this number.",
      extensionPbx: "Extension (PBX)",
      eG209: "E.g.: 209",
      eMail: "E-mail",
      dateOfBirth: "Date of birth",
      ddMmYyyy: "DD/MM/YYYY",
      homeAddress: "Home address",
      cityStreetHouse: "City, street, house...",
      additionalPhoneNumbers: "Additional phone numbers",
      add: "Add",
      noAdditionalNumbers: "No additional numbers",
      homeWork: "Home / Work",
      positionAndPermissions: "Position and permissions",
      position: "Position",
      organizationOwner: "Organization owner",
      administrator: "Administrator",
      employee: "Employee",
      department: "Department",
      noDepartment: "No department",
      customRole: "Custom role",
      noRoleDefault: "No role (default)",
      passportAndDocuments: "Passport and documents",
      uploadFile: "Upload file",
      imagesAndPdfFilesAre: "Images and PDF files are accepted. Max 15 MB.",
      noDocumentsUploaded: "No documents uploaded",
      passportScanPhotoProofOf: "Passport scan/photo, proof of residence, and other documents",
      changePassword: "Change password",
      newPassword: "New password",
      atLeast4Characters: "At least 4 characters",
      cancel: "Cancel",
    },
  },

  shared: {
    fieldTypes: {
      text: "Text",
      textarea: "Long text",
      number: "Number",
      phone: "Phone",
      email: "Email",
      url: "URL",
      date: "Date",
      boolean: "Yes / No",
      dropdown: "Dropdown (single)",
      multiselect: "Dropdown (multiple)",
      file: "File",
    },
    callStatus: {
      ringing: "Ringing",
      active: "Active",
      completed: "Answered",
      missed: "Missed",
      cancelled: "Cancelled",
    },
    dateFilters: {
      all: "All",
      today: "Today",
      week: "This week",
      month: "This month",
    },
    profileTabs: {
      info: "Details",
      docs: "Documents",
    },
    fileN: "File {n}",
    stageN: "Stage {n}",
    sourceN: "Source {n}",
    reasonN: "Reason {n}",
  
    created: "Created",
  
    user: "User",
  
    dealTabs: { main: "Main", 
    stats: "Statistics",
  
    files: "Files",
  
    settings: "Settings",
  },
  
    reviewTabs: { pages: "Pages", 
    collected: "Map reviews",
  
    feedback: "Internal feedback ({n})",
  },
  
    noLinkedPages: "No pages linked to Google/Yandex",
  
    googleKeyMissing: "Google API key is not configured yet (GOOGLE_PLACES_API_KEY)",
  
    searchError: "Search error",
  
    save2gisFirst: "Save the page first, then connect 2GIS",
  
    hoursN: "{n} h",
  
    loadFailed: "Failed to load",
  
    resolvedN: "Resolved: {n}%",
  
    firstReply: "First reply",
  
    genericError: "Something went wrong",
  
    error: "Error",
  
    justNow: "Now",
  
    minShort: "{n}m",
  
    regFeatures: { f1: "Warehouse and product accounting", 
    f2: "Sales and purchasing workflows",
  
    f3: "Customers and suppliers",
  
    f4: "Financial reports",
  },
  
    contactCreated: "Contact created",
  
    fileUploadFailed: "File upload failed: {name}",
  
    yes: "Yes",
  
    no: "No",
  
    fileLabel: "📎 File",
  
    callAction: "Call",
  
    roles: { owner: "Owner", 
    admin: "Admin",
  
    user: "User",
  },
  
    sumSymbol: "UZS",
  
    hourShort: "{n}h",
  
    dayShort: "{n}d",
  },

  assignees: {
    none: "Unassigned",
    hint: "You can pick several. The first is the primary",
    clear: "Clear",
    primary: "primary",
  },

  contactHistory: {

    fromDeal: "Deal",

    dealCreated: "Deal \"{deal}\" created",

    dealWon: "Deal \"{deal}\" won",

    dealLost: "Deal \"{deal}\" lost",
    nobody: "nobody",
    assigned: "{who}: owners {from} → {to}",
    assignedViaDeal: "{who}: owners via deal “{deal}”: {from} → {to}",
    dealAssigned: "Owners: {from} → {to}",
    merged: "{who} merged contacts: {names}",
  },

  merge: {
    title: "Merge contacts",
    subtitle: "Review what will be moved. Nothing changes until you confirm.",
    mainContact: "Main contact (kept)",
    removedContacts: "Will be merged and removed",
    deals: "Deals",
    tasks: "Tasks",
    calls: "Calls",
    chats: "Chats",
    history: "History",
    files: "Files",
    dealsHint: "Checked deals move to the main contact. Unchecked deals are detached from the contact (the deals themselves are not deleted).",
    noDeals: "The contacts being merged have no deals",
    possibleDup: "possible duplicate",
    selectAll: "Select all",
    clearAll: "Clear all",
    fromContact: "from contact {name}",
    alsoMove: "Also move",
    fillEmpty: "Fill empty fields of the main contact with data from the merged ones",
    conflicts: "Values differ (the main contact’s values are kept)",
    field: {
      name: "Name",
      email: "Email",
    },
    owners: "Owners",
    ownersKeep: "Keep the main contact’s owners",
    ownersUnion: "Combine all owners",
    status: {
      active: "Active",
      won: "Won",
      lost: "Lost",
    },
    summary: "Deals to move: {n}",
    confirm: "Merge",
    cancel: "Cancel",
    success: "Contacts merged",
    error: "Could not merge",
    loadError: "Could not load the preview",
  },

  quickTask: {

    typeLabel: "Task type",
    tab: "Task",
    type: {
      call: "Get in touch",
      meeting: "Meeting",
      other: "Other",
    },
    on: "for",
    for: "assigned to",
    today: "Today",
    tomorrow: "Tomorrow",
    week: "In a week",
    placeholder: "What needs to be done…",
    place: "Create",
    cancel: "Cancel",
    created: "Task created",
    badDate: "Enter a date and time",
  },

  callAI: {
    badge: {
      analyze: "AI analysis",
      queued: "Queued",
      processing: "Analyzing…",
      failed: "Analysis failed",
      problem: "Problem call",
      tooShort: "Too short",
    },
    modal: {
      title: "AI call review",
      notAnalyzed: "This call hasn't been analyzed yet",
      notAnalyzedHint: "Run the analysis: the system will transcribe the recording and prepare a checklist report.",
      analyze: "Analyze",
      starting: "Starting…",
      disabled: "AI call analysis is off. Enable it in Settings → Integrations → AI call analysis.",
      noEngine: "Transcription or analysis isn't connected on the server — the call will wait until it is.",
      tabReport: "Report",
      tabTranscript: "Transcript",
      retry: "Retry",
      reanalyze: "Re-run",
      delete: "Delete",
      deleteConfirm: "Delete the transcript, scores and the recording copy?",
      close: "Close",
      summary: "Summary",
      intent: "What the client wanted",
      outcome: "Outcome",
      checklist: "Checklist score",
      redFlags: "Violations and risks",
      noRedFlags: "No violations found",
      actions: "Follow-ups after the call",
      coaching: "Advice for the agent",
      metrics: "Call metrics",
      topics: "Topics",
      noTranscript: "Transcript is not available yet",
      rolesInferred: "Agent and client roles were inferred from context",
      tooShortNote: "The call is too short to score: only metrics were calculated.",
      error: "Error",
      agent: "Agent",
      client: "Client",
      unknown: "Unknown",
      audioError: "Could not load the recording",
      score: "Score",
      clientSentiment: "Client tone",
      agentSentiment: "Agent tone",
      notApplicable: "n/a",
      createTask: "Create task",
    },
    status: {
      queued: "Queued",
      downloading: "Downloading recording…",
      downloaded: "Recording saved, waiting for transcription",
      transcribing: "Transcribing…",
      transcribed: "Transcribed, waiting for analysis",
      analyzing: "Analyzing…",
      done: "Done",
      failed: "Failed",
      skipped: "Skipped",
    },
    sentiment: {
      positive: "Positive",
      neutral: "Neutral",
      negative: "Negative",
    },
    outcome: {
      sale: "Sale",
      agreed_next_step: "Next step agreed",
      callback_requested: "Asked to call back",
      info_given: "Information given",
      no_interest: "Not interested",
      complaint: "Complaint",
      other: "Other",
    },
    flag: {
      rude: "Rudeness",
      no_next_step: "No next step",
      false_promise: "Unrealistic promise",
      complaint: "Client complaint",
      competitor: "Competitor mentioned",
      price_unhandled: "Price objection not handled",
      data_leak: "Excess data shared",
      other: "Other",
    },
    severity: {
      low: "Low",
      medium: "Medium",
      high: "High",
    },
    item: {
      greeting: "Greeting and introduction",
      needs: "Needs discovery",
      presentation: "Product/service information",
      objections: "Objection handling",
      next_step: "Next step agreed",
      politeness: "Politeness and tone",
      closing: "Call closing",
    },
    metric: {
      agentTalkPct: "Agent talk share",
      silencePct: "Silence",
      interruptions: "Interruptions",
      avgResponseGapSec: "Pause between turns, s",
      agentWpm: "Words per minute (agent)",
      longestAgentMonologueSec: "Longest agent monologue, s",
      durationSec: "Duration, s",
      words: "Total words",
    },
    lang: {
      auto: "Auto",
      uz: "Uzbek",
      ru: "Russian",
      tg: "Tajik",
      en: "English",
    },
    analytics: {
      analyzed: "Calls analyzed",
      avgScore: "Average score",
      problem: "Problem calls",
      talkMinutes: "Talk minutes",
      cost: "Cost, $",
      pending: "Processing: {n}",
      failedN: "Errors: {n}",
      tooShortN: "Too short: {n}",
      byAgent: "Employees",
      thAgent: "Employee",
      thCalls: "Calls",
      thScore: "Score",
      thProblem: "Problem",
      thFlags: "Violations",
      thTalk: "Talk share",
      checklist: "Score by checklist item",
      outcomes: "Call outcomes",
      sentiment: "Client sentiment",
      trend: "Score trend",
      topFlags: "Frequent violations",
      topTopics: "Conversation topics",
      worst: "Lowest-scored calls",
      empty: "No analyzed calls in this period",
      disabledTitle: "AI call analysis is off",
      disabledText: "Enable it in settings and the system will start transcribing and scoring new conversations.",
      goSettings: "Open settings",
      allAgents: "All employees",
      noAgent: "Unknown",
      open: "Open",
      allDirections: "All calls",
      incoming: "Incoming",
      outgoing: "Outgoing",
      truncated: "Showing the first 5000 calls of the period",
    },
    settings: {
      title: "AI call analysis",
      subtitle: "The system transcribes recorded conversations with clients and prepares a report: summary, checklist score, violations and advice.",
      enable: "Enable AI analysis",
      enableHint: "Only new calls are analyzed — after enabling. Older recordings are not processed.",
      auto: "Analyze automatically",
      autoHint: "If off, analysis is started manually with a button in the call.",
      minTalk: "Minimum talk duration, min",
      minTalkHint: "Talk time is counted from the moment of answer (ringing is not counted). Some businesses need 2 minutes, others 15 is too little. 0 — no limit.",
      maxTalk: "Maximum duration, min",
      maxTalkHint: "Very long calls can be skipped to save money. 0 — no limit.",
      directions: "Which calls to analyze",
      in: "Incoming",
      out: "Outgoing",
      language: "Conversation language",
      languageHint: "“Auto” works for a mix of Uzbek, Russian and Tajik.",
      vocabulary: "Organization vocabulary",
      vocabularyHint: "Brands, models, product and employee names, comma-separated. During analysis the AI fixes words misheard by speech recognition (e.g. “lifis” → LI 9) and spells them correctly in the report.",
      vocabularyPlaceholder: "Li Auto, LI 7, LI 9, Li Avto Buxoro, installment, Rosa",
      reportLanguage: "Report language",
      retention: "Keep recordings, days",
      retentionHint: "After this period the audio copy is deleted; the transcript and scores stay. 0 — keep forever.",
      managerOnly: "Reports visible to managers only",
      managerOnlyHint: "An employee sees reviews of their own calls only.",
      checklist: "Scoring checklist",
      checklistHint: "The system scores every call on these items. Weight is how much an item matters for the total score.",
      usingDefault: "The default checklist is used",
      customize: "Customize",
      resetDefault: "Restore default",
      addItem: "Add item",
      itemTitle: "Title",
      itemDescription: "What counts as done",
      itemWeight: "Weight",
      save: "Save",
      saved: "Settings saved",
      saveError: "Could not save",
      engine: "Connection",
      engineStt: "Speech transcription",
      engineLlm: "Text analysis",
      engineOn: "connected",
      engineOff: "not connected",
      onlyAdmin: "Only the owner or an administrator can change these settings.",
      consentTitle: "Important: notify your clients",
      consentText: "Tell clients that conversations are recorded and may be analyzed automatically (for example, in the PBX voice greeting). This is required by personal data law.",
      consentCheck: "I confirm that clients are informed their calls are recorded and automatically analyzed",
      consentRequired: "Confirm that clients are informed to enable analysis",
      consentAt: "Confirmed {date}",
      maskPii: "Hide personal data from the external model",
      maskPiiHint: "Phone numbers, card numbers, passports and e-mails are replaced with placeholders before the text is sent for analysis. The transcript in your database stays intact.",
      eraseTitle: "Erase client data",
      eraseHint: "On a client’s request you can delete all transcripts, scores and recording copies linked to their number. The calls themselves stay in the call log.",
      erasePhone: "Client phone number",
      eraseBtn: "Erase data",
      eraseConfirm: "Delete all AI analysis data for {phone}? This cannot be undone.",
      erased: "Reviews deleted: {n}",
      eraseBadPhone: "Enter a phone number",
      minutesShort: "min",
      unlimited: "no limit",
      queue: "Queue",
    },
  },

  leadMap: {
    autoCreate: "Create a field automatically for every new question",
    autoCreateHint: "When a lead with a new question arrives, the CRM creates a deal field for it (in the \"Lead form\" section) and puts the answer there. No manual mapping needed.",
    autoOn: "Automatic fields enabled",
    autoOff: "Automatic fields disabled",
    title: "Lead fields",
    subtitle: "How answers from Facebook/Instagram forms and API leads are placed on the deal card. Anything you do not map still goes to the comment, as before.",
    hintStandard: "Name, phone and e-mail from the standard form questions go to the contact automatically. Other questions and ad data are configured here.",
    question: "Form question",
    sample: "Sample answer",
    count: "Leads",
    target: "Save to",
    toNote: "Comment (default)",
    createField: "Create field \"{name}\"",
    dealFields: "Deal field",
    contact: "Contact",
    contactName: "Contact name",
    contactPhone: "Contact phone",
    contactEmail: "Contact e-mail",
    ignore: "Do not save",
    importMeta: "Load questions from the Meta form",
    imported: "Questions added: {n}",
    importFail: "Could not load questions from Meta",
    empty: "Questions appear here after the first lead. Or load them from the Meta form with the button above.",
    emptyNoFb: "Questions appear here after the first lead from Facebook/Instagram or via the API.",
    saved: "Saved",
    fieldCreated: "Field created: {name}",
    loadError: "Could not load the settings",
  },

  apiKeys: {
    title: "API keys",
    subtitle: "Receive leads from external systems: CRM Line, Zapier, Make, website forms. Each key puts leads into the chosen funnel and stage.",
    create: "Create key",
    createTitle: "New API key",
    editTitle: "Edit key",
    name: "Name",
    namePh: "e.g. CRM Line (li-buxoro)",
    funnel: "Funnel",
    stage: "Stage",
    source: "Source",
    sourceHint: "Source label on the deal. Can be overridden in the request itself.",
    save: "Save",
    cancel: "Cancel",
    nameRequired: "Enter a name",
    error: "The action failed",
    saved: "Saved",
    empty: "No keys yet",
    destination: "Leads go to",
    lastUsed: "Last request",
    neverUsed: "Never used",
    leadsCount: "leads: {n}",
    edit: "Edit",
    revoke: "Revoke key",
    revokeConfirm: "Revoke the key “{name}”? It stops working immediately and this cannot be undone.",
    revoked: "Key revoked",
    createdTitle: "Key “{name}” created",
    shownOnce: "Copy the key now: it is shown only once. If you lose it, revoke it and create a new one.",
    copy: "Copy",
    copied: "Copied",
    done: "Done",
    docsTitle: "How to send leads",
    endpoint: "Endpoint",
    example: "Example request",
    docAuth: "Send the key in the Authorization: Bearer … header (or X-API-Key).",
    docRequired: "Required: phone or email. Name is optional.",
    docExternal: "external_id (e.g. the Meta lead id) prevents duplicates: resending will not create a second deal.",
    docOptional: "Optional: source, funnel_id, stage_id, notes, answers {field: value}, campaign, ad_name, form_name, page_name, platform.",
    docLimit: "Limit: 120 requests per minute per key.",
  },

  callPanel: {
    initiatedSoftphone: "Opening MicroSIP and dialing…",
    noStartSoftphone: "The call did not start. Check that MicroSIP is running, registered as extension {ext} and set as the app for tel: links.",
    initiated: "Command sent to the PBX…",
    ringing: "Answer the PBX call in MicroSIP (ext. {ext}) — then the PBX will dial the client",
    ringingDirect: "Dialing the client…",
    active: "Call in progress",
    completed: "Call ended",
    missed: "Not connected",
    noStart: "The PBX has not started the call yet. Check that MicroSIP is running and registered as extension {ext}.",
    retry: "Call again",
    openCard: "Open card",
    close: "Close",
    noExt: "You have no PBX extension assigned. Ask an administrator (Settings → Employees).",
    viaPbx: "Via PBX (ext. {ext})",
    viaPbxNoExt: "Via PBX — no extension",
    menuHint: "Your MicroSIP will ring — answer it and the PBX will dial the client",
    startFailed: "Could not send the command to the PBX",
    duration: "Duration {d}",
    reason: {
      no_answer: "Client did not answer",
      busy: "Busy",
      cancelled: "Cancelled before answer",
      failed: "Line error",
      unknown: "Reason unknown",
    },
    stats: {
      title: "Outgoing call results",
      connected: "Connected",
      fromCrm: "From the CRM button: {n}, connected {c}",
      empty: "No outgoing calls in this period",
    },
  },

  ownerBot: {
    title: "Telegram bot for the business owner",
    subtitle: "Personal reports and instant alerts for the business owner only.",
    notConfigured: "The bot is not configured on the server yet. Contact Miko.",
    noPhone: "The owner phone is not set. A Miko administrator enters it: contact support.",
    phone: "Owner phone",
    phoneHint: "Only the owner of this number can connect in Telegram.",
    connect: "Connect Telegram",
    connecting: "Creating link…",
    linkReady: "Connection link (one-time, valid for 15 minutes)",
    open: "Open in Telegram",
    copy: "Copy",
    copied: "Copied",
    linkSteps: "Open the link on the owner's phone, press Start and share your number with the button in the bot.",
    devices: "Connected devices",
    noDevices: "Nobody is connected yet.",
    linkedAt: "connected",
    sendReport: "Report now",
    reportSent: "Report sent",
    disconnect: "Disconnect",
    disconnectConfirm: "Disconnect this device from the bot?",
    times: "Report times",
    evening: "Evening report for today",
    morning: "Morning report for yesterday",
    quiet: "No instant messages",
    quietFrom: "from",
    quietTo: "to",
    save: "Save",
    saved: "Saved",
    attempts: "Connection attempts",
    rejected: "Rejected: phone did not match",
    linked: "Connected",
    whatTitle: "What the bot sends",
    what1: "Every evening and morning: inquiries, calls (including missed), won and lost deals, tasks (done and overdue).",
    what2: "Who did what in the app and when: important changes (deletions, settings, staff, integrations).",
    what3: "Instantly: a missed incoming call, a won deal, an important change.",
    what4: "Bot commands: Today, Yesterday, Settings.",
  },
  notifCenter: {
    title: "Notifications",
    empty: "Nothing new yet",
    message: "New message",
    lead: "New lead",
    call: "Missed call",
    media: "Attachment",
    missedCallText: "Call the client back",
    now: "now",
    min: "min",
    hour: "h",
    clear: "Clear",
    soundOn: "Turn sound on",
    soundOff: "Turn sound off",
    unreadInbox: "Unread in Inbox",
  },
  topbar: {
    hotkeysHint: "jump to sections, N — new deal",
    cmdGo: "Go to", cmdFunnel: "Funnel", cmdTheme: "Switch theme", cmdGroup: "Commands", recent: "Recent",
    appearance: "Appearance", themeLight: "Light", themeDark: "Dark", themeAuto: "Auto",
    liteMode: "Simplified view", liteHint: "No blur or animations: faster on slow devices",
    searchNavigate: "select",
    searchOpen: "open",
    search: "Search",
    searchPlaceholder: "Client, deal or command…",
    searchContacts: "Contacts",
    searchDeals: "Deals",
    searchEmpty: "Nothing found",
    searchHint: "Type at least 2 characters",
    create: "Create",
    createDeal: "New deal",
    createContact: "New contact",
    funnels: "Funnels",
    close: "Close",
    accountSettings: "Account settings",
    settings: "Settings",
    refresh: "Refresh",
    lockScreen: "Lock screen",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    roles: {
      owner: "Owner",
      admin: "Admin",
      manager: "Manager",
      cashier: "Cashier",
      warehouse: "Warehouse",
      viewer: "Viewer",
    },
    hidePanel: "Hide top bar",
    showPanel: "Show top bar",
    language: "Language",
  },
  assets: {
    pageTitle: "Company Assets", pageSubtitle: "Equipment, furniture and other fixed assets",
    addBtn: "Add Asset", searchPlaceholder: "Name or inventory ID...",
    statTotal: "Total assets", statUnit: "pcs", statCost: "Original cost",
    statAccDep: "Depreciation", statBookValue: "Book value", currency: "UZS",
    catAll: "All categories",
    cat_furniture: "Furniture", cat_electronics: "Electronics",
    cat_computer: "Computers & tech", cat_vehicle: "Vehicles",
    cat_equipment: "Production equipment", cat_office: "Office equipment", cat_other: "Other",
    statusAll: "All statuses", statusActive: "Active", statusDisposed: "Disposed",
    status_active: "Active", status_disposed: "Disposed",
    thInventoryId: "Inv. ID", thName: "Name", thCategory: "Category",
    thCost: "Original cost", thAccDep: "Depreciation", thBookValue: "Book value",
    thStatus: "Status", thActions: "Actions",
    noItems: "No assets found",
    deleteConfirm: "Delete this asset?",
    deleteHint: "All depreciation records will also be deleted.",
    deleteBtn: "Delete", cancel: "Cancel", deleted: "Asset deleted",
    saved: "Saved", created: "Asset created",
    formTitleNew: "New Asset", formTitleEdit: "Edit Asset",
    saveBtn: "Save", backBtn: "Back",
    sectionMain: "General Info", sectionFinance: "Financial Data",
    sectionDepreciation: "Depreciation", sectionHistory: "Depreciation History",
    nameLabel: "Name", namePlaceholder: "e.g. HP EliteBook 840",
    categoryLabel: "Category", statusLabel: "Status",
    descriptionLabel: "Description", descriptionPlaceholder: "Additional info...",
    locationLabel: "Location / Department", locationPlaceholder: "e.g. Finance dept.",
    responsibleLabel: "Responsible person", responsiblePlaceholder: "Full name",
    purchaseDateLabel: "Purchase date", purchaseCostLabel: "Original cost (UZS)",
    disposalDateLabel: "Disposal date",
    disposalNoteLabel: "Disposal reason", disposalNotePlaceholder: "Worn out, sold...",
    depMethodLabel: "Depreciation method",
    depMethodNone: "No depreciation", depMethodStraightLine: "Straight-line",
    usefulLifeLabel: "Useful life (months)",
    monthlyDepLabel: "Monthly depreciation", annualDepLabel: "Annual depreciation",
    accDepLabel: "Accumulated depreciation", bookValueLabel: "Book (residual) value",
    noteLabel: "Notes", notePlaceholder: "Note...",
    addDepBtn: "Record depreciation",
    depModalTitle: "Record Depreciation",
    depDateLabel: "Date", depAmountLabel: "Amount",
    depNoteLabel: "Note", depNotePlaceholder: "e.g. June 2026 depreciation",
    depSaveBtn: "Record", depAdded: "Depreciation recorded", depDeleted: "Entry deleted",
    suggestedDep: "Suggested amount",
    depAmountRequired: "Amount is required",
    noDepHistory: "No depreciation records",
    nameRequired: "Name is required", categoryRequired: "Category is required",
    thDepDate: "Date", thDepAmount: "Amount", thDepNote: "Note",
    catNone: "No category", catEmpty: "No categories — add them in Settings",
    statusNone: "No status", statusEmpty: "No statuses — add them in Settings",
    statusAllFilter: "All statuses",
    depMethodStraightLineHint: "Equal monthly charge",
    monthsSuffix: "mo.",
  },
  settingsAssets: {
    tabLabel: "Assets",
    title: "Asset Settings",
    catTitle: "Categories",
    catSubtitle: "Categories to group and filter assets",
    statusTitle: "Statuses",
    statusSubtitle: "Current condition labels for each asset",
    addCatBtn: "Add Category",
    addStatusBtn: "Add Status",
    namePlaceholder: "Name...",
    colorLabel: "Color",
    saveBtn: "Save",
    cancelBtn: "Cancel",
    noCats: "No categories yet",
    noStatuses: "No statuses yet",
    deleted: "Deleted",
    saved: "Saved",
    created: "Created",
    dupError: "This name already exists",
  },

  // ── CRM-specific pages ─────────────────────────────────────────────────────

  crmDashboard: {
    greeting: "Welcome, {name}!",
    loadError: "Failed to load data",
    reload: "Reload",
    kpiCalls: "Today's calls",
    kpiContacts: "New contacts",
    kpiDeals: "Open deals",
    kpiUnanswered: "Awaiting reply",
    kpiSubToday: "today",
    kpiSubTodayAdded: "added today",
    kpiSubTotal: "total",
    kpiSubUnanswered: "unanswered",
    missedTitle: "Missed calls",
    missedEmpty: "No missed calls",
    allCalls: "All calls →",
    allTasks: "All tasks →",
    overdueTitle: "Overdue tasks",
    dueDate: "Due:",
    activityTitle: "Recent activity",
    activityEmpty: "No activity",
    funnelTitle: "Funnel statistics",
    funnelEmpty: "No funnels",
    noDeal: "No deals",
    quickLinks: "Quick links",
    addContact: "Add contact",
    callHistory: "Call history",
    incoming: "Incoming",
    outgoing: "Outgoing",
  },

  tasks: {
    title: "Tasks",
    newTask: "New task",
    editTask: "Edit task",
    viewTask: "View task",
    close: "Close",
    noStagesTitle: "Tasks",
    noStages: "No stages configured. Go to Settings → Tasks to add stages.",
    search: "Search...",
    filter: "Filter",
    clearFilters: "Clear",
    allPriorities: "All",
    allAssignees: "All members",
    assignedToMe: "Assigned to me",
    createdByMe: "Created by me",
    overdue: "overdue",
    totalNote: "{total} total — showing first {shown}",
    deleteConfirm: "Delete this task?",
    archive: "Archive", archived: "Task archived", archiveEmpty: "No archived tasks",
    restore: "Restore", restored: "Task restored",
    prioLow: "Low",
    prioMedium: "Medium",
    prioHigh: "High",
    modalTitle: "Title *",
    titlePlaceholder: "What needs to be done...",
    titleRequired: "Title is required",
    description: "Description / notes",
    descPlaceholder: "Detailed description...",
    priority: "Priority",
    stage: "Stage",
    assignee: "Assignee",
    additionalAssignees: "Additional assignees",
    unassigned: "Unassigned",
    dueDate: "Due date",
    contact: "Contact",
    contactSearch: "Search contact...",
    contactNotFound: "Contact not found",
    contactCreate: "Create contact \"{q}\"",
    contactNew: "New contact",
    contactName: "Name",
    contactPhone: "Phone",
    contactSave: "Create",
    contactCreated: "Contact created and linked",
    contactExisting: "A contact with this phone already exists: {name}. Linked",
    contactCreateError: "Could not create the contact",
    linked: "Linked",
    files: "Files",
    uploadFile: "+ Upload file",
    uploading: "Uploading...",
    tags: "Tags",
    tagsPlaceholder: "Add a tag, press Enter...",
    createdByPrefix: "Added by:",
    historyTitle: "Change history",
    histUnknownUser: "Unknown",
    histCreated: "created the task",
    histStageChanged: "changed the stage",
    histAssigned: "assigned",
    histUnassigned: "unassigned",
    histArchived: "archived",
    histUnarchived: "unarchived",
    histCompleted: "marked as done",
    assignedToPrefix: "Assigned to:",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    saved: "Saved",
    created: "Created",
    deleted: "Deleted",
    loadError: "Loading error",
    error: "Error",
    viewKanban: "Kanban",
    viewDue: "Due date",
    viewCalendar: "Calendar",
    viewDay: "Day",
    viewWeek: "Week",
    viewMonth: "Month",
    noDateBucket: "No date",
    colOverdue: "Overdue",
    colToday: "Today",
    colTomorrow: "Tomorrow",
    colThisWeek: "This week",
    colNextWeek: "Next week",
    completeTitle: "Complete task",
    outcomeNotePlaceholder: "Outcome: what was discussed, agreement...",
    logToDeal: "Log to deal timeline",
    createFollowUp: "Create follow-up task",
    followUpTitle: "Follow-up task title",
    followUpDue: "Follow-up due date",
    followUpAssignee: "Assignee (optional)",
    completeConfirm: "Complete",
    completeSuccess: "Task completed",
    markDone: "I completed it",
    noDoneStage: "No \"done\" stage is configured",
    doneBadge: "Done",
    archiveAction: "Archive",
    callTitle: "Call",
    noDealAccess: "You don't have access to this deal",
    authorTitle: "Author: {name}",
    assigneeTitle: "Assignee: {name}",
    viewAction: "Open",
    editAction: "Edit",
    deleteAction: "Delete",
  
    scopeMine: "Mine",
  },

  calls: {
    fPeriod: "Period",
    fStatus: "Status",
    fDirection: "Direction",
    resetFilters: "Reset filters",
    title: "Calls",
    all: "All",
    incoming: "Incoming",
    outgoing: "Outgoing",
    missed: "Missed",
    completed: "Completed",
    ringing: "Ringing",
    busy: "Busy",
    search: "Phone or contact...",
    dateFrom: "From",
    dateTo: "To",
    noResults: "No calls found",
    emptyHint: "Your first calls will appear here",
    deleteSelected: "Delete selected",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    deleteConfirm: "Delete {n} selected call(s)?",
    deleted: "Deleted",
    loadError: "Loading error",
    thDate: "Date / time",
    thDirection: "Direction",
    thPhone: "Phone",
    thContact: "Contact",
    thDuration: "Duration",
    thStatus: "Status",
    thRecord: "Recording",
    thExt: "Extension",
    statsTotal: "Total",
    statsMissed: "Missed",
    statsDuration: "Total time",
    linkContact: "Link",
    linked: "Linked",
    viewContact: "View contact",
    analytics: "Analytics",
    noContact: "No contact",
    unknown: "Unknown",
  
    colExt: "Extension",
  
    secShort: "{n}s",
  },

  contacts: {
    thAssignee: "Assignee",
    colAssignee: "Assignee",
    colCreated: "Date added",
    sortBy: "Sort",
    title: "Contacts",
    reminderOverdue: "Reminder overdue",
    newContact: "New contact",
    search: "Name, phone, email...",
    noContacts: "No contacts found",
    emptyHint: "Add your first contact",
    import: "Import",
    export: "Export",
    columns: "Columns",
    deleteSelected: "Delete ({n})",
    deleteConfirm: "Delete {n} selected contact(s)?",
    deleted: "Deleted",
    loadError: "Loading error",
    importTitle: "CSV import",
    importHint: "Upload a CSV file. First row — column names.",
    importBtn: "Upload",
    importPreview: "Preview",
    importSave: "Save",
    importCancel: "Cancel",
    importSuccess: "{n} contacts added",
    importError: "Import error",
    exportSuccess: "Export started",
    selectFile: "Select CSV file",
    mapping: "Map columns",
    analytics: "Analytics",
    thName: "Name",
    thPhone: "Phone",
    thEmail: "Email",
    thSource: "Source",
    thCreated: "Date",
    thActions: "Actions",
    filterSource: "Filter by source",
    allSources: "All sources",
    yes: "Yes",
    no: "No",
    fileAttached: "📎 File",
    columnsTitle: "Select columns",
    blocked: "Blocked",
    noResults: "Nothing found",
    addFirst: "Add your first contact",
    add: "Add",
    duplicates: "Duplicates",
    duplicatesTitle: "Find duplicate numbers",
    normalizeAll: "Normalize numbers to +998",
    normalizeTitle: "Convert all numbers to +998 format",
    selectedN: "Selected: {n}",
    colContact: "Contact",
    colPhone: "Phone",
    colEmail: "Email",
    extraFields: "Extra fields",
    exportError: "Export failed",
    searchPlaceholder: "Name, phone, email...",
  },

  contactForm: {
    phoneInvalid: "Check the number, e.g. +998 90 123 45 67",
    phoneHint: "Example: +998 90 123 45 67",
    newTitle: "New contact",
    editTitle: "Edit contact",
    back: "Back",
    save: "Save",
    saving: "Saving...",
    delete: "Delete",
    deleteConfirm: "Delete this contact?",
    deleted: "Deleted",
    saved: "Saved",
    created: "Created",
    loadError: "Loading error",
    tabGeneral: "General",
    tabActivity: "Activity history",
    tabDeals: "Deals",
    name: "Name *",
    namePlaceholder: "Full name...",
    nameRequired: "Name is required",
    phone: "Phone",
    phonePlaceholder: "+998 XX XXX XX XX",
    email: "Email",
    emailPlaceholder: "example@mail.com",
    source: "Source",
    sourcePlaceholder: "Telegram, website...",
    notes: "Notes",
    notesPlaceholder: "Notes...",
    activityEmpty: "No activity yet",
    activityCall: "Call",
    activityNote: "Note",
    dealsEmpty: "No deals",
    dealAdd: "Add deal",
    error: "An error occurred",
    cancel: "Cancel",
    blocked: "Blocked",
    reminder: "Reminder",
    reminderOverdue: "Reminder overdue",
    block: "Block",
    unblock: "Unblock",
    tabFiles: "Files",
    tabSettings: "Settings",
    activitySub: "Notes, calls and changes",
    activityHint: "Save the contact to add notes and records",
    activityEmptyHint: "Write the first note",
  },

  inbox: {
    title: "Inbox",
    search: "Search...",
    tabUnanswered: "Unanswered",
    tabAccepted: "Accepted",
    tabClosed: "Closed",
    noUnanswered: "No unanswered messages",
    noUnansweredHint: "New messages will appear here",
    noClosed: "No closed chats",
    noClosedHint: "Closed conversations will appear here",
    noAccepted: "No accepted chats",
    noConvsTotal: "No conversations",
    selectConv: "Select a conversation",
    selectConvHint: "Choose a conversation from the list",
    convCount: "{n} conversations",
    sendPlaceholder: "Write a message...",
    emailPlaceholder: "Write an email reply...",
    notePlaceholder: "Write an internal note...",
    noteMode: "Internal note mode — visible to team only",
    deleteConv: "Delete conversation",
    deleteMsg: "Delete message",
    markAnswered: "Mark as answered",
    markUnanswered: "Mark as unanswered",
    closeConv: "Close conversation",
    openConv: "Reopen conversation",
    reassign: "Assign",
    reassignTitle: "Assign to member",
    reassignNone: "Unassigned",
    labelTitle: "Label",
    addLabel: "Add label...",
    convInfo: "Info",
    goToContact: "Go to contact",
    createContact: "Create contact",
    loadError: "Loading error",
    sendError: "Failed to send",
    deleteError: "Failed to delete",
    analytics: "Analytics",
    back: "Back",
    noSubject: "(No subject)",
    from: "From:",
    to: "To:",
    noAcceptedHint: "Accepted chats appear here",
    delete: "Delete",
    msgNotFound: "Message not found",
    noMsgs: "No messages",
    captionPlaceholder: "Add a caption (optional)...",
    allConvs: "All conversations",
    assignedAgent: "Assigned agent",
    linkedContact: "Linked contact",
    contactName: "Name *",
    cancel: "Cancel",
    save: "Save",
    noData: "No data",
  },

  dashboardHome: {
    showPeriod: "Show: {p}",
    secOverview: "Business right now",
    kpiOpenDeals: "Open deals",
    kpiNewContacts: "New contacts today",
    kpiUnanswered: "Unanswered",
    kpiUnansweredSub: "Conversations in the inbox",
    kpiCalls: "Calls today",
    kpiNewContactsSub: "Added today",
    kpiCallsSub: "Incoming and outgoing",
    dateLocale: "en-US",
    loadError: "Failed to load data", retry: "Retry",
    overdueLabel: "Overdue", overdueSubAlert: "Needs immediate attention", overdueSubOk: "All on time",
    completedLabel: "Completed", completedSub: "In the final stage",
    activeLabel: "Active tasks", activeSub: "Need to be done",
    unassignedLabel: "Unassigned", unassignedSubNoLeads: "Unassigned leads",
    goalsTitle: "Goals", gaugeSum: "Amount", gaugeDealCount: "Number of deals",
    byEmployee: "By employee", donutSum: "Amount", donutCount: "Count",
    byManager: "By manager", dealsCountLabel: "Deals", sumLabel: "Amount",
    dealSources: "Deal sources", other: "Other", total: "Total", unit: "",
    secCalls: "Calls",
    secCallsSub: "Incoming and outgoing, answered and missed",
    secTasks: "Tasks",
    secSales: "Sales",
    pToday: "Today",
    pWeek: "Week",
    pMonth: "Month",
    allEmployees: "All employees",
    noEmployee: "No employee",
    cTotal: "Total calls",
    cIn: "Incoming",
    cOut: "Outgoing",
    cMissed: "Missed",
    cAvg: "Average duration",
    cAnswered: "Answered {n}",
    cMissedN: "Missed {n}",
    cMissedPct: "{n}% of all calls",
    cTalk: "Total talk time: {t}",
    chartTitle: "Call activity",
    legIn: "Incoming",
    legOut: "Outgoing",
    legMissed: "Missed",
    empTitle: "By employee",
    thEmployee: "Employee",
    thTotal: "Total",
    thIn: "In",
    thOut: "Out",
    thMissed: "Missed",
    thTalk: "Talk time",
    noCalls: "No calls in the selected period",
    callsLoadError: "Failed to load call statistics",
    openCalls: "All calls",
  
    cNoAnswerN: "No answer {n}",
  },

  funnel: {
    journeyAnalytics: "Lead journey",
    newDeal: "New deal",
    addQuick: "Quick add",
    dealSearch: "Deal, contact name or number...",
    sortLabel: 'Sort',
    sortManual: 'Default (manual order)',
    sortCreatedAsc: 'Oldest - newest (by created date)',
    sortCreatedDesc: 'Newest - oldest (by created date)',
    sortUpdatedAsc: 'Oldest - newest (by status change)',
    sortUpdatedDesc: 'Newest - oldest (by status change)',
    sortTitleAsc: 'A - Z',
    sortTitleDesc: 'Z - A',
    dateFrom: 'Created date — from',
    dateTo: 'Created date — to',
    showClosed: 'Closed',
    bulkSelectTitle: 'Bulk select',
    select: 'Select',
    selectCancel: 'Cancel',
    archiveBtn: 'Archive',
    statsBtn: 'Stats',
    noDeals: "No deals",
    totalDeals: "deals",
    totalValue: "total value",
    loadError: "Loading error",
    deleteConfirm: "Delete this deal?",
    deleted: "Deleted",
    edit: "Edit",
    newLead: "New deal",
    leadNameLabel: "Client name *",
    contactOpt: "Contact (optional)",
    noContact: "— No contact",
    createContact: "+ Create new contact",
    contactNamePh: "Name *",
    contactPhonePh: "Phone",
    contactEmailPh: "Email",
    contactCreated: "Contact created",
    contactExists: "Contact already exists",
    responsibleLabel: "Assigned to",
    unassigned: "— Unassigned",
    notesPlaceholder: "Additional info...",
    addBtn: "Add",
    titleRequired: "Title is required",
    searchPlaceholder: "Search...",
    noFunnel: "Funnel not found",
    stagePlaceholder: "Stage name...",
    moveTitle: "Deal value",
    moveHint: "Enter amount (optional)",
    moveSave: "Move",
    moveCancel: "Cancel",
    export: "Export",
    import: "Import",
    exportDone: "Excel downloaded",
    exportError: "Export error",
    importTitle: "Excel import",
    importDone: "Import finished!",
    importCreated: "leads added",
    importSkipped: "skipped",
    importFormat: "Excel (.xlsx) columns:",
    importHint: "First row — column names. Only the «Sarlavha» column is required.",
    downloadTemplate: "Download template",
    templateError: "Failed to download template",
    importBtn: "Import",
    importError: "Import error",
    onlyXlsx: "Only .xlsx files are accepted",
    dropXlsx: "Drop the Excel (.xlsx) file here",
    orClick: "or click to select",
    clear: "Clear",
    cancel: "Cancel",
    close: "Close",
    dealsCount: "{n} deals",
    dealsCountFiltered: "{shown} of {total}",
    viewActive: "Active",
    viewClosed: "Closed",
    allSources: "All sources",
    noSource: "No source",
    cfAll: "{name}: all",
    cfNone: "No {name}",
    chipSearch: "“{q}”",
    chipDates: "{from} — {to}",
    bulkMoved: "{n} leads moved",
    bulkTransferred: "{n} leads transferred",
    bulkDeleted: "{n} leads deleted",
    bulkArchived: "{n} leads archived",
    bulkAssigned: "{n} leads assigned",
    bulkSkipped: ", {n} skipped",
  },

  deals: {
    moveStage: "Stage", moveStageTitle: "Move to stage", showMore: "Show {count} more",
    nextStep: "Next step",
    noNextStep: "No next step: add a task so the deal does not get lost",
    setNextStep: "Add a task",
    back: "Back",
    newDeal: "New deal",
    editDeal: "Edit deal",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirm: "Delete this deal?",
    deleted: "Deleted",
    saved: "Saved",
    created: "Created",
    loadError: "Loading error",
    titleLabel: "Title *",
    titlePlaceholder: "Deal name...",
    titleRequired: "Title is required",
    contact: "Contact",
    value: "Amount",
    currency: "Currency",
    stage: "Stage",
    moveToFunnel: "Move to another funnel",
    moveFunnelLabel: "Funnel",
    moveFunnelPlaceholder: "Select a funnel...",
    moveStagePlaceholder: "Select a stage...",
    moveReasonLabel: "Reason (optional)",
    moveReasonPlaceholder: "Why is the lead moving to another funnel...",
    moveSubmit: "Move",
    moveSuccess: "Moved to another funnel",
    assignee: "Assignee",
    dueDate: "Due date",
    notes: "Notes",
    notesPlaceholder: "Notes...",
    wonTitle: "Deal won",
    lostTitle: "Deal lost",
    wonReason: "Reason or note (optional)",
    lostReason: "Reason for loss (optional)",
    reasonPlaceholder: "Reason...",
    confirm: "Confirm",
    activitySub: "Notes and changes",
    notePlaceholder: "Write a note...",
    activityEmpty: "No activity yet",
    activityHint: "Write the first note",
    noteTab: "Note",
    communicationTab: "Contact",
    contactTypeCall: "Call",
    contactTypeMessage: "Message",
    contactTypeMeeting: "Meeting",
    durationLabel: "min",
    outcomeInterested: "Interested",
    outcomeThinking: "Thinking",
    outcomeDeclined: "Declined",
    outcomeNoAnswer: "No answer",
    outcomeOther: "Other",
  },

  inboxAnalytics: {
    title: "Inbox Analytics",
    back: "Inbox",
    tabGeneral: "Overview",
    tabAgents: "Agents",
    preset7d: "7 days",
    presetMonth: "This month",
    presetPrevMonth: "Last month",
    presetQuarter: "This quarter",
    presetCustom: "Custom",
    apply: "Apply",
    compare: "Compare with previous period",
    totalConvs: "Total conversations",
    unanswered: "Unanswered",
    closed: "Closed",
    avgResponse: "Avg. response time",
    firstResponse: "First response",
    resolutionRate: "Resolution rate:",
    prevPeriod: "prev. period:",
    dailyChart: "Daily conversations",
    dayCount: "days",
    comparison: "Period comparison",
    total: "Total",
    closedPct: "Closed %",
    byChannel: "By channel",
    agentStats: "Agents",
    labelStats: "Labels",
    noData: "No data",
    noLabels: "No labels",
    agentReport: "Agent report",
    exportCsv: "Export CSV",
    thAgent: "Agent",
    thTotal: "Conversations",
    thClosed: "Closed",
    thClosedPct: "Close %",
    thAvgResp: "Avg. response",
    thCalls: "Calls",
    loadError: "Failed to load",
  },

  contactAnalytics: {
    title: "Contact Analytics",
    back: "Contacts",
    preset30d: "30 days",
    presetMonth: "This month",
    preset90d: "90 days",
    presetCustom: "Custom",
    apply: "Apply",
    periodNew: "New contacts in period",
    totalAll: "Total contacts",
    allTime: "All time",
    dailyChart: "Daily new contacts",
    byChannel: "By channel (via Inbox)",
    byOperator: "By operator",
    noPhone: "No phone numbers",
    noData: "No data",
    loadError: "Failed to load",
  },

  leadJourney: {
    title: "Lead journey",
    back: "Funnels",
    preset30d: "30 days",
    presetMonth: "This month",
    preset90d: "90 days",
    presetCustom: "Custom",
    apply: "Apply",
    contactsWidgetTitle: "Contacts for period",
    uniqueLeadsContacted: "unique leads contacted",
    byType: "By type",
    interactedTitle: "Customers interacted with",
    calledTitle: "Customers spoken to",
    calledHint: "Reached by call and talked",
    sourceFunnelChange: "Funnel transition",
    sourceStageChange: "Stage move",
    sourceComment: "Comment left",
    sourceInbox: "Message (Telegram, etc.)",
    transitionsWidgetTitle: "Funnel-to-funnel transitions",
    transitionsEmpty: "No transitions in this period",
    snapshotWidgetTitle: "Current snapshot — by funnel/stage",
    loadError: "Failed to load",
  },

  sheets: {
    title: "Google Sheets",
    subtitle: "Leads from a spreadsheet (for example where Meta Lead Ads drops new leads) reach the CRM by themselves: every new row becomes a deal.",
    add: "Connect a sheet",
    empty: "No sheets connected",
    paused: "paused",
    destination: "Leads go to",
    lastSync: "Checked",
    neverSynced: "Not checked yet",
    totalImported: "deals created: {n}",
    rows: "rows in the sheet: {n}",
    syncNow: "Check now",
    pause: "Pause",
    resume: "Resume",
    edit: "Edit",
    remove: "Disconnect",
    removeConfirm: "Disconnect \"{name}\"? Deals already created stay.",
    removed: "Sheet disconnected",
    imported: "New deals: {n}",
    nothingNew: "No new rows",
    error: "Something went wrong",
    connected: "Sheet connected. New rows will appear in the CRM by themselves",
    connectedImported: "Sheet connected, deals loaded: {n}",
    saved: "Saved",
    howTitle: "How it works",
    "how1": "The CRM checks the sheet every 2 minutes and takes only new rows.",
    "how2": "A row becomes a contact and a deal in the chosen funnel and stage. No duplicates: every row is read once.",
    "how3": "Rows without a phone and without an email are skipped.",
    "how4": "Answers to form questions go to the deal comment; you can map them to fields in \"Lead fields\".",
    addTitle: "Connect a Google Sheet",
    editTitle: "Sheet settings",
    accessTitle: "First open access to the sheet",
    accessHint: "In the sheet press \"Share\" → \"Anyone with the link\" → role \"Viewer\". The CRM only reads the sheet and never changes it.",
    link: "Sheet link",
    check: "Check",
    tabHint: "Copy the link from the address bar while the needed tab is open: the CRM reads exactly that tab.",
    found: "The sheet is accessible. Rows with data: {n}",
    name: "Source name",
    namePh: "For example, Meta: November",
    defaultName: "Google Sheet",
    funnel: "Funnel",
    stage: "Stage",
    source: "Deal source",
    sourceHint: "The source label on the deal (for example Facebook or Instagram).",
    columns: "What each column means",
    none: "— none —",
    colIdHint: "Unique row number: the CRM will not create a duplicate",
    restHint: "The other columns (form answers, ad, platform) go to the deal comment.",
    needContact: "Choose the phone or email column",
    col: {
      name: "Name",
      phone: "Phone",
      email: "Email",
      id: "Row number (id)",
      createdAt: "Lead time",
    },
    importExisting: "Also load the rows already in the sheet ({n})",
    importExistingHint: "If unchecked, only rows added after connecting reach the CRM.",
    cancel: "Cancel",
    connect: "Connect",
    save: "Save",
    meta: {
      enable: "Report outcomes to Meta: \"Won\" and \"Lost\"",
      enableHint: "Ads learn to find people like those who buy (Conversions API for CRM). The Meta lead id is taken from the id column.",
      dataset: "Dataset ID",
      token: "Access token",
      tokenSaved: "•••• saved (type a new one to replace)",
      tokenHint: "Both values are created by the ad account admin in Meta Events Manager: dataset → Settings → Conversions API → \"Generate access token\". The token is stored on the server only and is never shown.",
      wonEvent: "Event for \"Won\"",
      lostEvent: "Event for \"Lost\"",
      testCode: "Test event code (optional)",
      testCodeHint: "While a code is set, events go to the \"Test events\" tab and do not reach ad statistics. Leave empty for real sending.",
      check: "Check connection",
      ok: "Connected: {name}",
      checkLater: "You can check the connection after saving: open the source with the \"Edit\" button.",
      badge: "Meta: outcomes",
    },
    err: {
      bad_url: "This is not a Google Sheets link",
      private: "No access to the sheet. Turn on \"Anyone with the link\" with role \"Viewer\" and press \"Check\" again.",
      bad_tab: "There is no such tab in the sheet. Open the needed tab and copy the link again.",
      not_found: "Sheet not found. Check the link.",
      empty: "The sheet is empty",
      network: "Could not reach Google. Try again later.",
      failed: "Could not check the sheet",
    },
  },
  edu: {
    io: {
      import: "Import",
      export: "Export",
      title: "Import students from Excel",
      step1: "Download the template",
      step1Hint: "Staff fill it in: one student per row. The \"Help\" sheet explains everything; pick the group from the list.",
      template: "Download template",
      step2: "Upload the filled file",
      pick: "Choose file",
      change: "Choose another",
      drop: "Drop an .xlsx here or choose a file",
      check: "Check",
      importN: "Import: {n}",
      cancel: "Cancel",
      close: "Close",
      checked: "Ready to import: {ok}. To fix or skip: {bad}. Nothing has been saved yet.",
      empty: "The file has no filled rows",
      doneTitle: "Import finished",
      created: "added",
      skipped: "skipped",
      problems: "Rows with problems: {n}",
      row: "row {n}",
      onlyXlsx: "An .xlsx file is required",
      templateError: "Could not download the template",
      importError: "Could not upload the file",
      exportError: "Could not export the file",
      err: { no_name: "name is missing", no_group: "group is missing", group_unknown: "no such group", group_archived: "group is archived", bad_date: "invalid date", bad_number: "invalid number", bad_lang: "language must be uz or ru", duplicate: "this student is already in the group", group_full: "the group is full", bad_package: "lessons in the package are missing", too_many_rows: "too many rows (up to 1000)", failed: "could not be saved" },
    },
    deal: {
      enroll: "Enrol in a group",
      enrollAnother: "Enrol in another group",
      enrolled: "{group}: {n} left",
      openStudents: "Open students",
      noGroups: "No groups yet. Create a group in the Education section first.",
      toGroups: "To groups",
      linkHint: "Name, phone and contact come from the deal, nothing to retype. Record payments on the student card.",
      openDeal: "Deal",
      openContact: "Contact",
    },
    title: "Education",
    add: "Add",
    all: "All",
    archive: "Archive",
    restore: "Restore",
    cancel: "Cancel",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    date: "Date",
    delete: "Delete",
    edit: "Edit",
    end: "End",
    start: "Start",
    group: "Group",
    loading: "Loading…",
    note: "Note",
    save: "Save",
    saved: "Saved",
    d1: "Mon",
    d2: "Tue",
    d3: "Wed",
    d4: "Thu",
    d5: "Fri",
    d6: "Sat",
    d7: "Sun",
    dl1: "Monday",
    dl2: "Tuesday",
    dl3: "Wednesday",
    dl4: "Thursday",
    dl5: "Friday",
    dl6: "Saturday",
    dl7: "Sunday",
    status: {
      present: "Present",
      late: "Late",
      absent: "Absent",
      excused: "Excused",
    },
    st: {
      active: "Studying",
      frozen: "Frozen",
      left: "Left",
      completed: "Completed",
    },
    method: {
      cash: "Cash",
      card: "Card",
      transfer: "Transfer",
      other: "Other",
    },
    tabs: {
      today: "Today",
      groups: "Groups",
      students: "Students",
      debts: "Debts",
      report: "Attendance",
      settings: "Settings",
    },
    sum: {
      students: "students enrolled",
      lessonsToday: "lessons marked today",
      debt: "debt ({n} students)",
      low: "packages running out",
    },
    today: {
      prev: "Previous day",
      next: "Next day",
      goToday: "Back to today",
      noLessons: "No lessons on this day",
      markAll: "All present",
      save: "Save",
      saved: "Attendance saved",
      progress: "{m} of {n} marked",
      notMarked: "Not marked",
      held: "Held",
      cancelled: "Cancelled",
      cancel: "Cancel lesson",
      reopen: "Restore",
      cancelPrompt: "Reason for cancelling (optional):",
      readonly: "Editing is closed: marks can only be changed within the last {n} days.",
      extra: "extra lesson",
      addLesson: "Extra lesson",
      left: "{n} left",
      debt: "debt",
      noStudents: "No students in this group",
    },
    groups: {
      new: "New group",
      edit: "Edit group",
      name: "Name",
      course: "Course",
      teacher: "Teacher",
      room: "Room",
      color: "Colour",
      schedule: "Schedule",
      day: "Day",
      addSlot: "Add day",
      startDate: "Course start",
      endDate: "Course end",
      capacity: "Seats in group",
      capacityHint: "0 — unlimited",
      packageLessons: "Lessons per package",
      packagePrice: "Package price",
      showArchived: "Show archived",
      archiveConfirm: "Archive group “{name}”? No new lessons will be created for it.",
      none: "No groups yet",
      studentsCount: "{n} students",
      frozenCount: "{n} frozen",
      packageShort: "package {n} lessons · {price}",
    },
    students: {
      new: "New student",
      name: "Name",
      phone: "Phone",
      parent: "Parent",
      parentName: "Parent name",
      parentPhone: "Parent phone",
      parentLang: "Message language for parent",
      langDefault: "Default",
      joined: "Enrolled on",
      withPackage: "Enrol with a lesson package",
      lessons: "Lessons",
      price: "Price",
      paid: "Paid",
      contactHint: "If a phone is given, a contact card is created in the CRM automatically.",
      search: "Name or phone",
      allGroups: "All groups",
      activeFrozen: "Studying and frozen",
      anyBalance: "Any balance",
      onlyDebt: "Only with debt",
      onlyLow: "Package running out",
      needGroup: "Create a group on the “Groups” tab first.",
      none: "No students",
      leftLessons: "lessons left",
      debt: "debt",
      credit: "overpaid",
      leftAt: "Left on",
      balanceHint: "Bought {bought}, used {used}, adjustment {adjust}",
      packages: "Packages and payments",
      addPackage: "New package",
      addPayment: "Payment",
      noPackages: "No packages",
      packageLine: "Package of {n} lessons",
      amount: "Amount",
      method: "Method",
      deletePaymentConfirm: "Delete this payment?",
      deletePackageConfirm: "Delete the package with its payments?",
      telegram: "Parent’s Telegram",
      noBot: "Bot is not connected: Settings → Education.",
      tgLinked: "Parent connected",
      tgMuted: "notifications turned off by the parent",
      tgNotLinked: "Parent has not connected yet: send them the link",
      remindDebt: "Remind about debt",
      remindLow: "Remind to pay",
      reminded: "Reminder sent",
      history: "Attendance history",
      noHistory: "No lessons yet",
      status: "Status",
      transfer: "Group",
      transferConfirm: "Move the student to another group?",
      adjust: "Lesson adjustment",
      adjustHint: "+N or −N: compensation, carry-over, etc.",
      leftReasonPrompt: "Reason (optional):",
      delete: "Delete student",
      deleteConfirm: "Delete the student? Only possible when there are no attendance marks.",
    },
    debts: {
      total: "Total debt",
      count: "Students: {n}",
      none: "No debts or expiring packages",
      remind: "Remind",
    },
    report: {
      from: "From",
      to: "To",
      rate: "Attendance",
      lessons: "lessons held: {n}",
      none: "No marks in this period",
    },
    settings: {
      open: "Settings",
      charge: "What uses up a lesson from the package",
      chargeHint: "Checked statuses reduce the student’s remaining lessons. The balance is recalculated every time, so changing a rule updates all balances.",
      rules: "Rules and thresholds",
      lowBalance: "Warn when lessons left are",
      lowBalanceHint: "0 — no warning",
      absentStreak: "Absences in a row to create a manager task",
      absentStreakHint: "0 — no task",
      assignee: "Assign the task to",
      assigneeAuto: "Group creator",
      editDays: "How many days back reception can edit marks",
      editDaysHint: "Owner and admin can edit any day.",
      defaultPackage: "Default package",
      defaultPackageHint: "Used when a group has no package set.",
      regional: "Time and language",
      timezone: "Time zone",
      parentLang: "Message language for parents",
      bot: "Telegram bot for parents",
      botHint: "Each learning centre has its own bot: parents see its name and avatar.",
      botStep1: "In Telegram open @BotFather and send /newbot.",
      botStep2: "Choose a name and username (for example “Rustamov Academy” and rustamov_academy_bot).",
      botStep3: "Copy the token you receive and paste it here.",
      botConnect: "Connect",
      botConnected: "Bot connected",
      botDisconnect: "Disconnect",
      botDisconnectConfirm: "Disconnect the bot? Parents will stop receiving messages.",
      notify: "Parent notifications",
      notifyHint: "Messages go only to parents who connected via the link from the student card.",
      notifyEnabled: "Send notifications",
      notifyNeedBot: "Connect the bot first.",
      onAbsent: "When a student is absent",
      onLate: "When a student is late",
      onLow: "When the package is running out",
      templates: "Message texts",
      templatesHint: "Leave empty to use the default text. You can use: {vars}",
    },
    tpl: {
      absent: "Absent",
      late: "Late",
      low: "Package running out",
      debt: "Debt",
    },
  },

  bottomNav: {
    more: "More", label: "Main navigation",
    education: "Education",
    dashboard: "Home",
    contacts: "Contacts",
    tasks: "Tasks",
    inbox: "Inbox",
    calls: "Calls",
    reviews: "Reviews",
    funnels: "Funnels",
    analytics: "Analytics",
  },

    serverText: { unknownPhone: "Unknown ({phone})", 
    unknown: "Unknown",
  
    assignedTo: "Assigned to {name}",
  
    bulk: " (bulk)",
  
    archived: "Archived",
  
    unarchived: "Restored from archive",
  
    unassigned: "Unassigned",
  
    claimed: "Took it",
  },
  };
